const ICON_TYPE = {
  TWEMOJI: 'twemoji',
  LUCIDE: 'lucide',
};

const courseIconType = {
  14: ICON_TYPE.TWEMOJI,
  13: ICON_TYPE.LUCIDE,
  15: ICON_TYPE.TWEMOJI,
  16: ICON_TYPE.TWEMOJI,
  17: ICON_TYPE.TWEMOJI,
  18: ICON_TYPE.LUCIDE,
  19: ICON_TYPE.LUCIDE,
  20: ICON_TYPE.LUCIDE,
  21: ICON_TYPE.LUCIDE,
  22: ICON_TYPE.LUCIDE,
  23: ICON_TYPE.LUCIDE,
  27: ICON_TYPE.LUCIDE,
  29: ICON_TYPE.LUCIDE,
  25: ICON_TYPE.LUCIDE,
  28: ICON_TYPE.LUCIDE,
  26: ICON_TYPE.LUCIDE,
};

const flashcardsData = {
  // Course ID 15: علم ابني الأشكال
  15: [
    // === Shape Recognition (10 cards) ===
    {
      id: 1,
      front: { emoji: '⭕', text: 'واش هذا الشكل؟' },
      back: { title: 'الدايرة', subtitle: 'دائرة | Circle', detail: 'ماعندهاش زوايا! الدايرة تدور بزاف 🔄' },
      category: 'shapes',
    },
    {
      id: 2,
      front: { emoji: '⬜', text: 'واش هذا الشكل؟' },
      back: { title: 'المربع', subtitle: 'مربع | Square', detail: 'عندو 4 جوانب متساوية و 4 زوايا قائمة 📐' },
      category: 'shapes',
    },
    {
      id: 3,
      front: { emoji: '🔺', text: 'واش هذا الشكل؟' },
      back: { title: 'المثلث', subtitle: 'مثلث | Triangle', detail: 'عندو 3 جوانب و 3 زوايا! شكل قوي بزاف 💪' },
      category: 'shapes',
    },
    {
      id: 4,
      front: { emoji: '▭', text: 'واش هذا الشكل؟' },
      back: { title: 'المستطيل', subtitle: 'مستطيل | Rectangle', detail: 'عندو 4 جوانب: 2 طويلة و 2 قصيرة 📱' },
      category: 'shapes',
    },
    {
      id: 5,
      front: { emoji: '⭐', text: 'واش هذا الشكل؟' },
      back: { title: 'النجمة', subtitle: 'نجمة | Star', detail: 'عندها 5 رؤوس تلمع في السما! ✨' },
      category: 'shapes',
    },
    {
      id: 6,
      front: { emoji: '❤️', text: 'واش هذا الشكل؟' },
      back: { title: 'القلب', subtitle: 'قلب | Heart', detail: 'شكل الحب والحنان! 💕' },
      category: 'shapes',
    },
    {
      id: 7,
      front: { emoji: '🥚', text: 'واش هذا الشكل؟' },
      back: { title: 'البيضاوي', subtitle: 'بيضاوي | Oval', detail: 'كيف الدايرة لكن ممدود! ماعندوش زوايا 🔄' },
      category: 'shapes',
    },
    {
      id: 8,
      front: { emoji: '💎', text: 'واش هذا الشكل؟' },
      back: { title: 'المعين', subtitle: 'معين | Diamond', detail: 'كيف المربع لكن مائل! عندو 4 جوانب متساوية ✨' },
      category: 'shapes',
    },
    {
      id: 9,
      front: { emoji: '⬟', text: 'واش هذا الشكل؟' },
      back: { title: 'الخماسي', subtitle: 'خماسي | Pentagon', detail: 'عندو 5 جوانب و 5 زوايا! 🏛️' },
      category: 'shapes',
    },
    {
      id: 10,
      front: { emoji: '⬡', text: 'واش هذا الشكل؟' },
      back: { title: 'السداسي', subtitle: 'سداسي | Hexagon', detail: 'عندو 6 جوانب! خلايا النحل سداسية 🐝' },
      category: 'shapes',
    },

    // === How many sides? (6 cards) ===
    {
      id: 11,
      front: { emoji: '🔺', text: 'شحال من جانب عند المثلث؟' },
      back: { title: '3 جوانب', subtitle: 'و 3 زوايا', detail: 'المثلث أبسط شكل مغلق!' },
      category: 'properties',
    },
    {
      id: 12,
      front: { emoji: '⬜', text: 'شحال من جانب عند المربع؟' },
      back: { title: '4 جوانب', subtitle: 'كلهم متساوية', detail: 'وعندو 4 زوايا قائمة (90°)!' },
      category: 'properties',
    },
    {
      id: 13,
      front: { emoji: '⬟', text: 'شحال من جانب عند الخماسي؟' },
      back: { title: '5 جوانب', subtitle: 'و 5 زوايا', detail: 'كيف أصابع اليد الواحدة! ✋' },
      category: 'properties',
    },
    {
      id: 14,
      front: { emoji: '⬡', text: 'شحال من جانب عند السداسي؟' },
      back: { title: '6 جوانب', subtitle: 'و 6 زوايا', detail: 'النحل يبني خلايا سداسية! 🍯' },
      category: 'properties',
    },
    {
      id: 15,
      front: { emoji: '⭕', text: 'شحال من زاوية عند الدايرة؟' },
      back: { title: '0 زوايا!', subtitle: 'ماعندهاش زوايا أصلاً', detail: 'الدايرة كلها منحنية 🔄' },
      category: 'properties',
    },
    {
      id: 16,
      front: { emoji: '▭', text: 'واش الفرق بين المربع والمستطيل؟' },
      back: { title: 'المستطيل عندو 2 جوانب طويلة و 2 قصيرة', subtitle: 'المربع كل جوانبو متساوية', detail: 'كلاهما عندهم 4 زوايا قائمة!' },
      category: 'properties',
    },

    // === Real-world objects (10 cards) ===
    {
      id: 17,
      front: { emoji: '⚽', text: 'الكورة واش شكلها؟' },
      back: { title: 'دايرة ⭕', subtitle: 'الكورة دايرة', detail: 'كل الحوايج اللي تدور دايرة!' },
      category: 'objects',
    },
    {
      id: 18,
      front: { emoji: '🚪', text: 'الباب واش شكلو؟' },
      back: { title: 'مستطيل ▭', subtitle: 'الباب مستطيل', detail: 'التلفزة والتليفون زادهم مستطيل! 📱' },
      category: 'objects',
    },
    {
      id: 19,
      front: { emoji: '⛺', text: 'الخيمة واش شكلها؟' },
      back: { title: 'مثلث 🔺', subtitle: 'الخيمة مثلث', detail: 'الجبل زادو مثلث! 🏔️' },
      category: 'objects',
    },
    {
      id: 20,
      front: { emoji: '🪟', text: 'الطاقة واش شكلها؟' },
      back: { title: 'مربع ⬜', subtitle: 'الطاقة مربع', detail: 'الكادو والنرد زادهم مربع! 🎁' },
      category: 'objects',
    },
    {
      id: 21,
      front: { emoji: '🥚', text: 'البيضة واش شكلها؟' },
      back: { title: 'بيضاوي 🥚', subtitle: 'البيضة بيضاوي', detail: 'الكيوي والزيتون زادهم بيضاوي!' },
      category: 'objects',
    },
    {
      id: 22,
      front: { emoji: '🪁', text: 'الطيارة الورقية واش شكلها؟' },
      back: { title: 'معين 💎', subtitle: 'الطيارة معين', detail: 'الماسة والجوهرة زادهم معين! 💎' },
      category: 'objects',
    },
    {
      id: 23,
      front: { emoji: '🐝', text: 'خلية النحل واش شكلها؟' },
      back: { title: 'سداسي ⬡', subtitle: 'خلايا النحل سداسية', detail: 'الثلج زادو سداسي! ❄️' },
      category: 'objects',
    },
    {
      id: 24,
      front: { emoji: '🌕', text: 'القمر واش شكلو؟' },
      back: { title: 'دايرة ⭕', subtitle: 'القمر دايرة', detail: 'الشمس زادها دايرة! ☀️' },
      category: 'objects',
    },
    {
      id: 25,
      front: { emoji: '📱', text: 'التليفون واش شكلو؟' },
      back: { title: 'مستطيل ▭', subtitle: 'التليفون مستطيل', detail: 'الكتاب والورقة زادهم مستطيل! 📔' },
      category: 'objects',
    },
    {
      id: 26,
      front: { emoji: '⚠️', text: 'علامة التحذير واش شكلها؟' },
      back: { title: 'مثلث 🔺', subtitle: 'علامة التحذير مثلث', detail: 'قطعة البيتزا زادها مثلث! 🍕' },
      category: 'objects',
    },

    // === 3D Shapes (3 cards) ===
    {
      id: 27,
      front: { emoji: '⚽', text: 'واش هذا الشكل الثلاثي الأبعاد؟' },
      back: { title: 'كرة | Sphere', subtitle: 'شكل 3D دايري', detail: 'تقدر تمسكها بيدك وتدورها! 🌍' },
      category: '3d',
    },
    {
      id: 28,
      front: { emoji: '🎲', text: 'واش هذا الشكل الثلاثي الأبعاد؟' },
      back: { title: 'مكعب | Cube', subtitle: 'شكل 3D مربع', detail: 'كل وجوهو مربعات! 📦' },
      category: '3d',
    },
    {
      id: 29,
      front: { emoji: '🔺', text: 'واش هذا الشكل الثلاثي الأبعاد اللي عندو رأس؟' },
      back: { title: 'هرم | Pyramid', subtitle: 'شكل 3D مثلثي', detail: 'كيف أهرامات مصر! 🏛️' },
      category: '3d',
    },

    // === Pattern completion (1 card) ===
    {
      id: 30,
      front: { emoji: '🎨', text: 'أكمل النمط:\n⭕ ⬜ ⭕ ⬜ ⭕ ___' },
      back: { title: '⬜ المربع!', subtitle: 'النمط: دايرة، مربع، دايرة، مربع...', detail: 'الأنماط تتكرر دايماً! 🔄' },
      category: 'patterns',
    },
  ],

  // Course ID 14: علم ابني الأرقام
  14: [
    // === Numbers 0-10 (10 cards) ===
    {
      id: 1,
      front: { emoji: '0️⃣', text: 'واش يعني الرقم صفر؟' },
      back: { title: 'والو! لا شيء!', subtitle: 'صفر = ماكاينش حتى حاجة', detail: '🚫🍎 صفر تفاحة = ماكاينش تفاح!' },
      category: 'numbers-0-10',
    },
    {
      id: 2,
      front: { emoji: '1️⃣', text: 'واش هو الرقم واحد بالدارجة؟' },
      back: { title: 'واحد!', subtitle: 'One | UN', detail: '☝️ حط صبع واحد! 🍎 واحد تفاحة، 🌙 واحد قمر' },
      category: 'numbers-0-10',
    },
    {
      id: 3,
      front: { emoji: '2️⃣', text: 'واش هو الرقم 2 بالدارجة؟' },
      back: { title: 'زوج!', subtitle: 'Two | DEUX', detail: '✌️ زوج صوابع! 👁️👁️ زوج عيون، 👂👂 زوج ودنين' },
      category: 'numbers-0-10',
    },
    {
      id: 4,
      front: { emoji: '3️⃣', text: 'واش هو الرقم 3 بالدارجة؟' },
      back: { title: 'ثلاثة / تلاتة!', subtitle: 'Three | TROIS', detail: '🤟 ثلاثة صوابع! 🍎🍎🍎 ثلاثة تفاحات' },
      category: 'numbers-0-10',
    },
    {
      id: 5,
      front: { emoji: '4️⃣', text: 'واش هو الرقم 4 بالدارجة؟' },
      back: { title: 'ربعة!', subtitle: 'Four | QUATRE', detail: '🖖 ربعة صوابع! 🚗 الطوموبيل عندها ربعة روايض!' },
      category: 'numbers-0-10',
    },
    {
      id: 6,
      front: { emoji: '5️⃣', text: 'واش هو الرقم 5 بالدارجة؟' },
      back: { title: 'خمسة!', subtitle: 'Five | CINQ', detail: '🖐️ خمسة صوابع في اليد! عدّ معايا: 1-2-3-4-5!' },
      category: 'numbers-0-10',
    },
    {
      id: 7,
      front: { emoji: '6️⃣', text: 'واش هو الرقم 6 بالدارجة؟' },
      back: { title: 'ستة!', subtitle: 'Six | SIX', detail: '🍓🍓🍓🍓🍓🍓 ستة فراولات!' },
      category: 'numbers-0-10',
    },
    {
      id: 8,
      front: { emoji: '7️⃣', text: 'الرقم 7 رقم خاص! علاه؟' },
      back: { title: 'سبعة - رقم مبارك!', subtitle: 'Seven | SEPT', detail: '🌈 القوس قزح فيه 7 ألوان! 📅 السيمانة فيها 7 أيام! في السما 7 سماوات!' },
      category: 'numbers-0-10',
    },
    {
      id: 9,
      front: { emoji: '8️⃣', text: 'الرقم 8 يشبه واش؟' },
      back: { title: 'ثمنية - يشبه نظارة!', subtitle: 'Eight | HUIT', detail: '👓 الرقم 8 يشبه نظارة! 🐙 الأخطبوط عندو 8 دراع!' },
      category: 'numbers-0-10',
    },
    {
      id: 10,
      front: { emoji: '🔟', text: 'شحال صبع عندك في زوج يدين؟' },
      back: { title: 'عشرة! 🖐️🖐️', subtitle: 'Ten | DIX', detail: 'عشرة = واحد وصفر (10). عندك 10 صوابع في اليدين و10 في الرجلين!' },
      category: 'numbers-0-10',
    },

    // === Numbers 11-20 (5 cards) ===
    {
      id: 11,
      front: { emoji: '1️⃣1️⃣', text: '11 بالدارجة كيفاه نقولوها؟' },
      back: { title: 'حداش!', subtitle: 'Eleven | ONZE', detail: '✋☝️ عشرة صوابع + واحد = حداش! (10 + 1 = 11)' },
      category: 'numbers-11-20',
    },
    {
      id: 12,
      front: { emoji: '1️⃣5️⃣', text: '15 بالدارجة كيفاه نقولوها؟' },
      back: { title: 'خمسطاش!', subtitle: 'Fifteen | QUINZE', detail: 'عشرة زائد خمسة = خمسطاش! (10 + 5 = 15)' },
      category: 'numbers-11-20',
    },
    {
      id: 13,
      front: { emoji: '1️⃣8️⃣', text: '18 بالدارجة كيفاه نقولوها؟' },
      back: { title: 'ثمنطاش!', subtitle: 'Eighteen | DIX-HUIT', detail: 'عشرة زائد ثمنية = ثمنطاش! (10 + 8 = 18)' },
      category: 'numbers-11-20',
    },
    {
      id: 14,
      front: { emoji: '2️⃣0️⃣', text: '20 بالدارجة كيفاه نقولوها؟' },
      back: { title: 'عشرين!', subtitle: 'Twenty | VINGT', detail: '✋✋✋✋ ربعة يدين = عشرين صبع! عشرين = زوج مرات عشرة!' },
      category: 'numbers-11-20',
    },
    {
      id: 15,
      front: { emoji: '🔢', text: 'الأرقام 11-19 كيفاه نكوّنوهم بالدارجة؟' },
      back: { title: 'كلهم = 10 + رقم!', subtitle: 'حداش، طناش، ثلاطاش، ربعطاش...', detail: '"-طاش" في الآخر تعني "عشر"! مثال: ثلا+طاش = ثلاثة عشر' },
      category: 'numbers-11-20',
    },

    // === Counting & Patterns (5 cards) ===
    {
      id: 16,
      front: { emoji: '🔙', text: 'عدّ من 10 للصفر بالمقلوب!' },
      back: { title: 'العد العكسي 🚀', subtitle: 'كيف الصاروخ!', detail: 'عشرة... تسعة... ثمنية... سبعة... ستة... خمسة... ربعة... ثلاثة... زوج... واحد... صفر! 🚀' },
      category: 'counting',
    },
    {
      id: 17,
      front: { emoji: '🦘', text: 'عدّ بالقفز بـ 2: ؟-؟-؟-؟-؟' },
      back: { title: '2 - 4 - 6 - 8 - 10!', subtitle: 'هذي الأرقام الزوجية (Even)', detail: 'الأرقام الفردية (Odd): 1 - 3 - 5 - 7 - 9' },
      category: 'counting',
    },
    {
      id: 18,
      front: { emoji: '🔍', text: 'واش الرقم الناقص: 6 - 7 - ؟ - 9 - 10' },
      back: { title: 'ثمنية! (8)', subtitle: 'الأرقام تمشي بالترتيب', detail: 'دايماً نزيدو واحد: 6 → 7 → 8 → 9 → 10' },
      category: 'counting',
    },
    {
      id: 19,
      front: { emoji: '🏆', text: 'أكبر ولا أصغر: 7 __ 3؟' },
      back: { title: '7 أكبر من 3! (7 > 3)', subtitle: 'الإشارة > تفتح للكبير', detail: '🍎🍎🍎🍎🍎🍎🍎 أكثر من 🍎🍎🍎! الرقم الأكبر = العدد أكثر!' },
      category: 'counting',
    },
    {
      id: 20,
      front: { emoji: '🟰', text: 'واش يعني علامة = ؟' },
      back: { title: 'يساوي! نفس الحاجة!', subtitle: '🍎🍎🍎 = 🍎🍎🍎 → ثلاثة = ثلاثة', detail: 'مثال: 2 + 3 = 5 → زوج زائد ثلاثة يساوي خمسة!' },
      category: 'counting',
    },

    // === Addition (5 cards) ===
    {
      id: 21,
      front: { emoji: '➕', text: 'واش يعني الجمع؟' },
      back: { title: 'الجمع = نزيدو!', subtitle: 'الرقم يكبر 📈', detail: '🍎 + 🍎 = 🍎🍎 → واحد + واحد = زوج!' },
      category: 'addition',
    },
    {
      id: 22,
      front: { emoji: '🍎', text: '3 + 2 = ؟' },
      back: { title: 'خمسة! (5)', subtitle: '🍎🍎🍎 + 🍎🍎 = 🍎🍎🍎🍎🍎', detail: 'ثلاثة زائد زوج يساوي خمسة!' },
      category: 'addition',
    },
    {
      id: 23,
      front: { emoji: '👯', text: 'واش هوما المضاعفات؟ 3+3=؟ 5+5=؟' },
      back: { title: 'نفس الرقم + نفس الرقم!', subtitle: '3+3=6, 4+4=8, 5+5=10', detail: 'المضاعفات سهلة الحفظ! 1+1=2, 2+2=4, 3+3=6, 4+4=8, 5+5=10' },
      category: 'addition',
    },
    {
      id: 24,
      front: { emoji: '🚫', text: 'صفر + 5 = ؟ (القاعدة الذهبية!)' },
      back: { title: 'خمسة! (5)', subtitle: 'صفر + أي رقم = نفس الرقم!', detail: 'لأنو الصفر ماعندو حتى حاجة! 0+3=3, 0+7=7, 0+10=10' },
      category: 'addition',
    },
    {
      id: 25,
      front: { emoji: '📖', text: 'عند أحمد 3 تفاحات، ماما عطاتلو 2. شحال عندو؟' },
      back: { title: '5 تفاحات!', subtitle: '3 + 2 = 5', detail: '🍎🍎🍎 + 🍎🍎 = 🍎🍎🍎🍎🍎 → ثلاثة زائد زوج يساوي خمسة!' },
      category: 'addition',
    },

    // === Subtraction (5 cards) ===
    {
      id: 26,
      front: { emoji: '➖', text: 'واش يعني الطرح؟' },
      back: { title: 'الطرح = ننقصو / نحيّو!', subtitle: 'الرقم يصغر 📉', detail: '🎈🎈🎈 - 🎈 = 🎈🎈 → ثلاثة ناقص واحد = زوج!' },
      category: 'subtraction',
    },
    {
      id: 27,
      front: { emoji: '⚽', text: '5 - 2 = ؟' },
      back: { title: 'ثلاثة! (3)', subtitle: '⚽⚽⚽⚽⚽ - ⚽⚽ = ⚽⚽⚽', detail: 'خمسة ناقص زوج يساوي ثلاثة!' },
      category: 'subtraction',
    },
    {
      id: 28,
      front: { emoji: '🚫', text: '7 - 0 = ؟ (القاعدة الذهبية!)' },
      back: { title: 'سبعة! (7)', subtitle: 'أي رقم - صفر = نفس الرقم!', detail: 'لأننا ماحيينا حتى حاجة! 3-0=3, 10-0=10' },
      category: 'subtraction',
    },
    {
      id: 29,
      front: { emoji: '💨', text: '5 - 5 = ؟' },
      back: { title: 'صفر! (0)', subtitle: 'راحو كامل! 🚫', detail: '⚽⚽⚽⚽⚽ - ⚽⚽⚽⚽⚽ = 0 → خمسة ناقص خمسة = صفر! ماباقيش حتى واحد!' },
      category: 'subtraction',
    },
    {
      id: 30,
      front: { emoji: '📖', text: 'عند سارة 5 بالونات، طارو 2. شحال باقي؟' },
      back: { title: '3 بالونات!', subtitle: '5 - 2 = 3', detail: '🎈🎈🎈🎈🎈 - 🎈🎈 = 🎈🎈🎈 → خمسة ناقص زوج يساوي ثلاثة!' },
      category: 'subtraction',
    },
  ],

  // Course ID 13: الذكاء الاصطناعي للأعمال
  13: [
    // === Chapter 1: Understanding AI (8 cards) ===
    {
      id: 1,
      front: { icon: 'cpu', text: 'واش راهو الذكاء الاصطناعي (AI)؟' },
      back: { title: 'برامج تتعلم وتحل المشاكل', subtitle: 'كيما الإنسان بصح أسرع وأدق', detail: 'تخيّل موظف يخدم 24/7، ما يتعبش، ويتعلم من كل تجربة!' },
      category: 'ch1-basics',
    },
    {
      id: 2,
      front: { icon: 'brain', text: 'شحال من نوع عند الذكاء الاصطناعي؟' },
      back: { title: '4 أنواع رئيسية', subtitle: 'توليدي، تحليلي، تفاعلي، بصري', detail: 'كل نوع يخدم شي معيّن - من كتابة المحتوى لحتى فهم الصور' },
      category: 'ch1-basics',
    },
    {
      id: 3,
      front: { icon: 'pen-tool', text: 'AI التوليدي (Generative AI) شنوا يدير؟' },
      back: { title: 'يخلق محتوى جديد', subtitle: 'نصوص، صور، موسيقى', detail: 'مثال: كتابة إعلانات، تصميم لوقو، كتابة منشورات' },
      category: 'ch1-basics',
    },
    {
      id: 4,
      front: { icon: 'bar-chart-3', text: 'AI التحليلي (Analytical AI) شنوا يدير؟' },
      back: { title: 'يحلل البيانات ويعطي نتائج', subtitle: 'أرقام → رؤى ونصائح', detail: 'مثال: توقع المبيعات، تحليل سلوك الزبائن' },
      category: 'ch1-basics',
    },
    {
      id: 5,
      front: { icon: 'x-circle', text: 'خرافة: AI غالي برك وللشركات الكبيرة!' },
      back: { title: 'الحقيقة: كاين أدوات مجانية!', subtitle: 'كافية للمشاريع الصغيرة', detail: 'من 0 دج لـ 2,000 دج/شهر تقدر تبدا. ما تحتاجش برمجة!' },
      category: 'ch1-basics',
    },
    {
      id: 6,
      front: { icon: 'zap', text: 'واش الفرق بين AI والأتمتة (Automation)؟' },
      back: { title: 'AI يتعلم ويتكيّف', subtitle: 'الأتمتة تكرر نفس الشيء', detail: 'أتمتة = نفس الرسالة للكل. AI = رسالة مخصصة لكل زبون حسب اهتماماته!' },
      category: 'ch1-basics',
    },
    {
      id: 7,
      front: { icon: 'coins', text: 'العائد على الاستثمار (ROI) في AI شحال؟' },
      back: { title: 'كل 1 دج → 3-5 دج أرباح', subtitle: 'بعض الشركات رجعو الاستثمار في 3 أشهر', detail: '40% زيادة إنتاجية + 60% تقليل أخطاء + 35% تخفيض تكاليف' },
      category: 'ch1-basics',
    },
    {
      id: 8,
      front: { icon: 'users', text: 'AI راح ياخذ وظائف الموظفين؟' },
      back: { title: 'لا! راح يغيّر طريقة الخدمة', subtitle: 'AI يدير المهام المملة', detail: 'AI + الإنسان = قوة لا تقهر! الموظف يركّز على الإبداع والقرارات المهمة' },
      category: 'ch1-basics',
    },

    // === Chapter 2: AI in Algeria (5 cards) ===
    {
      id: 9,
      front: { icon: 'globe', text: 'شحال من شركة جزائرية تستعمل AI؟' },
      back: { title: '15% فقط!', subtitle: 'السوق ما زال في البداية', detail: 'هذا خبر زين = فرص كبيرة للي يبداو توّا! First mover advantage' },
      category: 'ch2-algeria',
    },
    {
      id: 10,
      front: { icon: 'building', text: 'الجزائر عندها استراتيجية وطنية لـ AI؟' },
      back: { title: 'نعم! 2024-2030', subtitle: 'مدرسة وطنية + صندوق استثمار + مراكز مهارات', detail: '6 محاور: بحث، مهارات، بنية تحتية، تمويل، قوانين، قطاعات أولوية' },
      category: 'ch2-algeria',
    },
    {
      id: 11,
      front: { icon: 'truck', text: 'شركة توصيل في العاصمة استعملت AI. شنوا النتيجة؟' },
      back: { title: '35% تقليل وقت التوصيل', subtitle: '25% توفير في البنزين', detail: 'الحل: نظام يحلل الزحام والطرق ويعطي أفضل مسار' },
      category: 'ch2-algeria',
    },
    {
      id: 12,
      front: { icon: 'heart-pulse', text: 'عيادة في وهران استعملت AI. شنوا النتيجة؟' },
      back: { title: '60% تقليل المواعيد الملغاة', subtitle: '28% زيادة في الإيرادات', detail: 'AI يتوقع المرضى اللي غالباً يلغاو ويرسل تذكيرات ذكية' },
      category: 'ch2-algeria',
    },
    {
      id: 13,
      front: { icon: 'trending-up', text: 'أعلى قطاع طلباً على AI في الجزائر؟' },
      back: { title: 'التجارة الإلكترونية', subtitle: 'Chatbots + توصيات + تحليل سلوك', detail: 'ثم الصحة واللوجستيك والخدمات المالية' },
      category: 'ch2-algeria',
    },

    // === Chapter 3-4: AI Tools & Marketing (7 cards) ===
    {
      id: 14,
      front: { icon: 'file-text', text: 'صاحب محل ملابس كان يكتب 50 وصف منتج في...' },
      back: { title: 'ساعة وحدة بدل 3 أيام!', subtitle: 'باستعمال AI للكتابة', detail: 'AI يكتب أوصاف مقنعة + منشورات سوشيال + إعلانات + مقالات SEO' },
      category: 'ch3-tools',
    },
    {
      id: 15,
      front: { icon: 'palette', text: 'شحال يكلف التصميم بـ AI مقارنة بمصمم تقليدي؟' },
      back: { title: 'من 30,000 دج → 0-2,000 دج!', subtitle: 'صور منتجات + إعلانات + لوقو', detail: 'AI يصمم في 10 دقائق بدل 3-5 أيام. جودة احترافية!' },
      category: 'ch3-tools',
    },
    {
      id: 16,
      front: { icon: 'smartphone', text: 'شحال من جزائري عندو واتساب؟' },
      back: { title: '98%!', subtitle: '70% يفضلو الشراء عبر واتساب', detail: 'AI يرد تلقائياً + يرسل كاتالوج ذكي + يأكد الطلبات + يذكّر بالسلة' },
      category: 'ch4-marketing',
    },
    {
      id: 17,
      front: { icon: 'megaphone', text: 'كيفاه AI يحسّن إعلانات السوشيال ميديا؟' },
      back: { title: 'استهداف أفضل = تكاليف أقل', subtitle: 'بعض الأعمال: -50% تكلفة +200% مبيعات', detail: 'AI يحلل البيانات، يستهدف الجمهور المناسب، ويوقف الإعلانات الخاسرة تلقائياً' },
      category: 'ch4-marketing',
    },
    {
      id: 18,
      front: { icon: 'calendar', text: 'إدارة السوشيال ميديا بـ AI توفّر شحال؟' },
      back: { title: 'من 4 ساعات → 30 دقيقة يومياً', subtitle: 'كتابة + جدولة + رد + تحليل', detail: 'AI يكتب 7 منشورات للأسبوع في 10 دقائق، ينشر تلقائياً في أفضل الأوقات' },
      category: 'ch4-marketing',
    },
    {
      id: 19,
      front: { icon: 'search', text: 'محل أثاث في سطيف استعمل AI لـ SEO. شنوا النتيجة؟' },
      back: { title: '300% زيادة في الزيارات', subtitle: 'في شهرين فقط', detail: 'AI اكتشف: الناس يبحثو "صالونات عصرية سطيف" مش "أثاث مودرن سطيف"' },
      category: 'ch4-marketing',
    },
    {
      id: 20,
      front: { icon: 'percent', text: 'واش هو التسعير الديناميكي الذكي؟' },
      back: { title: 'AI يعدّل الأسعار تلقائياً', subtitle: 'حسب الطلب + المنافسة + المخزون + الموسم', detail: 'ينزّل أسعار المنتجات الراكدة ويرفع في المواسم. لازم يكون معقول!' },
      category: 'ch4-marketing',
    },

    // === Chapter 5: Customer Service (4 cards) ===
    {
      id: 21,
      front: { icon: 'message-square', text: 'Chatbot يقدر يجاوب على شحال من أسئلة تلقائياً؟' },
      back: { title: '80% من الأسئلة المتكررة!', subtitle: '24/7 خدمة بدون انقطاع', detail: 'متوسط وقت الرد: 3 ثواني. تقليل عبء العمل: 70%' },
      category: 'ch5-service',
    },
    {
      id: 22,
      front: { icon: 'sparkles', text: 'AI يقدر يتوقع مشاكل الزبائن قبل ما تصير؟' },
      back: { title: 'نعم! 85% من المشاكل يمكن توقعها', subtitle: '60% تخفيض في الشكاوى', detail: 'مثال: طلب تأخر → AI يرسل اعتذار + كود تخفيض 15% تلقائياً قبل ما الزبون يزعل' },
      category: 'ch5-service',
    },
    {
      id: 23,
      front: { icon: 'mail', text: 'AI كيفاه يساعد في إدارة الإيميلات؟' },
      back: { title: 'يرد على 60% تلقائياً', subtitle: 'من 3-4 ساعات → 45 دقيقة', detail: 'يصنف حسب الأهمية + يكتب مسودة ردود + يحدد المستعجل + يترجم' },
      category: 'ch5-service',
    },
    {
      id: 24,
      front: { icon: 'target', text: 'مطعم توصيل استعمل AI لتحليل الطلبات. شنوا اكتشف؟' },
      back: { title: 'احتفظو بـ 65% من الزبائن', subtitle: 'اللي كانو راح يضيعو', detail: 'AI لقى: لو الزبون ما طلبش 10 أيام → يجرب مطعم ثاني. الحل: رسالة + تخفيض يوم الأربعاء' },
      category: 'ch5-service',
    },

    // === Chapter 6-7: Management & Production (3 cards) ===
    {
      id: 25,
      front: { icon: 'package', text: 'محل مواد غذائية خفّض الهدر بـ AI من 25% لـ...' },
      back: { title: '8% فقط!', subtitle: 'توفير 200,000 دج في الشهر', detail: 'AI يتوقع الطلب + يحدد المخزون المثالي + ينبّه لإعادة الطلب + يلقى المنتجات البطيئة' },
      category: 'ch6-management',
    },
    {
      id: 26,
      front: { icon: 'globe-2', text: 'AI يقدر يخلقلك موقع إلكتروني بدون برمجة؟' },
      back: { title: 'نعم! في ساعة واحدة', subtitle: 'التكلفة الأولية: 0 دج', detail: 'تصميم + محتوى + صور + متجاوب مع الهاتف والكمبيوتر. AI يدير كل شيء!' },
      category: 'ch7-production',
    },
    {
      id: 27,
      front: { icon: 'video', text: 'AI يخلق فيديوهات بدون كاميرا؟' },
      back: { title: 'نعم! سكريبت + مشاهد + صوت + موسيقى', subtitle: 'فيديوهات تعريفية، إعلانات قصيرة، شروحات', detail: 'حتى يقدر ياخذ فيديو طويل ويقطعو لعدة Reels/Shorts تلقائياً!' },
      category: 'ch7-production',
    },

    // === Chapter 8-10: Strategy, Ethics, Future (3 cards) ===
    {
      id: 28,
      front: { icon: 'compass', text: 'واش أول خطوة باش تدمج AI في عملك؟' },
      back: { title: 'حدد مشكلة واحدة واضحة', subtitle: 'ماتحاولش تستعمل AI في كل حاجة مرة وحدة!', detail: 'ابدا صغير → جرب مجاني → درّب الفريق → قيّم بعد شهر → وسّع تدريجياً' },
      category: 'ch8-strategy',
    },
    {
      id: 29,
      front: { icon: 'shield-check', text: 'AI حلال ولا حرام؟' },
      back: { title: 'AI أداة - حلال في حد ذاته', subtitle: 'كيما السيارة أو الكمبيوتر', detail: 'تحسين خدمات، زيادة إنتاجية = حلال. غش، خداع، انتهاك خصوصية = حرام' },
      category: 'ch9-ethics',
    },
    {
      id: 30,
      front: { icon: 'rocket', text: 'واش المتوقع لـ AI في الجزائر 2026-2030؟' },
      back: { title: 'AI بالدارجة + أرخص + أقوى', subtitle: 'واقع معزز + توصيات ذكية + AI شخصي', detail: 'اللي يبدا اليوم راح يكون قدام بخطوات كبيرة. 75% من الشركات راح تستعمل AI في 2026!' },
      category: 'ch10-future',
    },
  ],

  // Course ID 18: كيفاش تبدأ مشروع صغير في الجزائر
  18: [
    // === Chapter 1: Understanding Entrepreneurship (3 cards) ===
    {
      id: 1,
      front: { icon: 'brain', text: 'واش هي الصفات الأساسية تاع رجل الأعمال الناجح؟' },
      back: { title: '6 صفات أساسية', subtitle: 'العقلية أهم من رأس المال', detail: 'الشجاعة، المثابرة، الإبداع، المرونة، الانضباط، والتواضع. النية الصالحة تجيب البركة!' },
      category: 'ch1-mindset',
    },
    {
      id: 2,
      front: { icon: 'trending-up', text: 'واش هي القطاعات الواعدة في الجزائر؟' },
      back: { title: '4 قطاعات رئيسية', subtitle: 'فرص كبيرة للشباب', detail: 'الطعام والمشروبات، التجارة الإلكترونية (نمو 92%)، الخدمات الرقمية، والخدمات المنزلية' },
      category: 'ch1-mindset',
    },
    {
      id: 3,
      front: { icon: 'globe', text: 'الجزائر فيها 46.8 مليون نسمة. شحال يستعملو الإنترنت؟' },
      back: { title: '79.5% = 37.8 مليون!', subtitle: '27.5 مليون على وسائل التواصل', detail: 'التجارة الإلكترونية قيمتها $1.5 مليار بنمو 92%. الوقت المناسب للبداية هو دروك!' },
      category: 'ch1-mindset',
    },

    // === Chapter 2: Government Support (4 cards) ===
    {
      id: 4,
      front: { icon: 'building', text: 'واش هو NESDA وشحال يمول؟' },
      back: { title: 'تمويل حتى 50 مليون دج!', subtitle: 'بدون فوائد + تدريب + متابعة', detail: 'المساهمة الشخصية 1-2% برك! العمر 19-40 سنة. المدة: 2-3 أشهر للموافقة' },
      category: 'ch2-programs',
    },
    {
      id: 5,
      front: { icon: 'zap', text: 'واش هو Auto-Entrepreneur وعلاه مثالي للبداية؟' },
      back: { title: 'تسجيل في 24 ساعة بـ 10,000 دج!', subtitle: 'وضعية قانونية مبسطة', detail: 'ضرائب 5% مبسطة، محاسبة سهلة، تسجيل online. مثالي للتجربة قبل التوسع!' },
      category: 'ch2-programs',
    },
    {
      id: 6,
      front: { icon: 'coins', text: 'ANGEM واش يعطي وعلاه حلال؟' },
      back: { title: 'قروض 50K-250K دج بدون فوائد!', subtitle: 'قرض حسن متوافق مع الشريعة', detail: 'ترجع نفس المبلغ برك! كاين قرض خاص للمرأة الماكثة بالبيت حتى 100K دج' },
      category: 'ch2-programs',
    },
    {
      id: 7,
      front: { icon: 'bar-chart-3', text: 'واش تختار: NESDA، Auto-Entrepreneur، ولا ANGEM؟' },
      back: { title: 'على حسب مشروعك!', subtitle: 'تقدر تجمع بين برنامجين', detail: 'Auto-Entrepreneur للبداية السريعة. ANGEM للمعدات البسيطة. NESDA للمشاريع الكبيرة المدروسة' },
      category: 'ch2-programs',
    },

    // === Chapter 3: Business Ideas (3 cards) ===
    {
      id: 8,
      front: { icon: 'package', text: 'أفكار مشاريع في الطعام: شحال الربح المتوقع؟' },
      back: { title: 'من 80K حتى 600K دج/شهر!', subtitle: 'مطعم، حلويات، كافيه', detail: 'مطعم صغير: 150-600K دج. حلويات تقليدية: 80-400K دج. كافيه: 100-500K دج' },
      category: 'ch3-ideas',
    },
    {
      id: 9,
      front: { icon: 'smartphone', text: 'واش هي أفضل المشاريع الرقمية في 2026؟' },
      back: { title: 'Dropshipping، كورسات، Freelancing', subtitle: 'تبدا من 20K دج برك!', detail: 'Dropshipping: 80-500K دج/شهر. كورسات رقمية: passive income! Freelancing: حتى 1M+ دج/شهر' },
      category: 'ch3-ideas',
    },
    {
      id: 10,
      front: { icon: 'users', text: 'واش هي النماذج الهجينة (Physical + Digital)؟' },
      back: { title: 'محل فيزيائي + تواجد رقمي = مستقبل!', subtitle: 'Co-working، Cloud Kitchen، Showroom', detail: 'Cloud Kitchen: مطعم بلا صالة. Showroom + متجر online. Gaming Cafe + streaming!' },
      category: 'ch3-ideas',
    },

    // === Chapter 4: Market Research (3 cards) ===
    {
      id: 11,
      front: { icon: 'target', text: 'كيفاه تحدد الفئة المستهدفة (Target Audience)؟' },
      back: { title: '6 أسئلة أساسية', subtitle: 'اعرف زبونك قبل ما تبيعلو', detail: 'العمر، الجنس، المنطقة، الدخل، الاهتمامات، والمشاكل اللي منتجك يحلها' },
      category: 'ch4-feasibility',
    },
    {
      id: 12,
      front: { icon: 'search', text: 'كيفاه تدرس منافسيك بذكاء؟' },
      back: { title: 'زورهم، اشتري منهم، شوف نقاط ضعفهم!', subtitle: 'المنافسة فرصة مش تهديد', detail: 'قارن الأسعار والجودة. اقرأ آراء الزبائن. لقى النقاط الضعيفة وكون أحسن منهم!' },
      category: 'ch4-feasibility',
    },
    {
      id: 13,
      front: { icon: 'percent', text: 'كيفاه تحسب الجدوى المالية لمشروعك؟' },
      back: { title: 'تكاليف ثابتة + متغيرة VS إيرادات', subtitle: 'فترة الاسترجاع = متى ترجع فلوسك', detail: 'مثال: تكاليف 800K دج، ربح 54.5K/شهر = 15 شهر استرجاع. هامش ربح 24% = مجدي!' },
      category: 'ch4-feasibility',
    },

    // === Chapter 5: Legal Registration (3 cards) ===
    {
      id: 14,
      front: { icon: 'file-text', text: 'واش هي أنواع الشركات في الجزائر؟' },
      back: { title: 'Auto-Entrepreneur، EURL، SARL', subtitle: 'كل واحد ليه ميزاتو', detail: 'Auto-Entrepreneur: للمستقلين (0 رأس مال). EURL: مالك واحد (100K دج). SARL: شراكة (2-50 شريك)' },
      category: 'ch5-legal',
    },
    {
      id: 15,
      front: { icon: 'pen-tool', text: 'واش الوثائق المطلوبة لتسجيل Auto-Entrepreneur؟' },
      back: { title: '4 وثائق + 10K دج = 24 ساعة!', subtitle: 'تسجيل online على guichet-unique.dz', detail: 'بطاقة هوية، شهادة إقامة، صورة شمسية، وصف النشاط. معفي من الضرائب لو دخلك أقل من 1M دج/سنة!' },
      category: 'ch5-legal',
    },
    {
      id: 16,
      front: { icon: 'shield-check', text: 'واش الأنشطة اللي تحتاج رخص خاصة؟' },
      back: { title: 'الغذاء، التجميل، النقل، والحرف', subtitle: 'التسجيل يحميك قانونياً', detail: 'مطاعم: رخصة صحية. تجميل: رخصة وزارة الصحة. نقل: شهادة مهنية. المنتجات الغذائية تحتاج شهادة حلال!' },
      category: 'ch5-legal',
    },

    // === Chapter 6: Halal Financing (4 cards) ===
    {
      id: 17,
      front: { icon: 'x-circle', text: 'علاه القروض بالفوائد (الربا) حرام؟' },
      back: { title: 'حرب من الله ورسوله!', subtitle: 'البدائل الحلال موجودة ومربحة', detail: '"الذين يأكلون الربا..." (البقرة:275). القروض بفوائد، بطاقات الائتمان بفوائد = كلهم ربا محرم' },
      category: 'ch6-financing',
    },
    {
      id: 18,
      front: { icon: 'coins', text: 'واش هو القرض الحسن (Qard Hassan)؟' },
      back: { title: 'قرض بلا فوائد = ترجع نفس المبلغ!', subtitle: 'حلال 100% ومحبوب عند الله', detail: 'من العائلة أو ANGEM. اكتب ورقة رسمية، حدد جدول سداد واقعي، والتزم بوعدك!' },
      category: 'ch6-financing',
    },
    {
      id: 19,
      front: { icon: 'users', text: 'واش الفرق بين المشاركة والمضاربة؟' },
      back: { title: 'المشاركة: كلهم يمولو. المضاربة: واحد يمول', subtitle: 'حلال شرعاً - تقاسم الربح والخسارة', detail: 'المشاركة: الخسارة حسب رأس المال. المضاربة: الخسارة على صاحب المال، المدير يخسر وقتو وجهدو' },
      category: 'ch6-financing',
    },
    {
      id: 20,
      front: { icon: 'sparkles', text: 'كيفاه توفر 500K دج في 10 أشهر؟' },
      back: { title: 'ادخار + Freelancing + تقليل المصاريف', subtitle: 'التمويل الذاتي = أنظف طريقة', detail: '25% من الراتب + شغل إضافي + بيع حوايج قديمة + تقليل المصاريف. بلا ديون وبلا ضغط!' },
      category: 'ch6-financing',
    },

    // === Chapter 7: Marketing (4 cards) ===
    {
      id: 21,
      front: { icon: 'megaphone', text: 'أنهي منصة تسويق تختار في الجزائر؟' },
      back: { title: 'Facebook أولاً! 25M+ جزائري', subtitle: 'ثم Instagram وTikTok', detail: 'Facebook: كل الأعمار. Instagram: شباب 18-35. TikTok: 15-30 سنة. YouTube: محتوى تعليمي. ابدا بوحدة واحترفها!' },
      category: 'ch7-marketing',
    },
    {
      id: 22,
      front: { icon: 'message-square', text: 'كيفاه تستعمل WhatsApp Business للتسويق؟' },
      back: { title: 'بروفايل + ردود آلية + كتالوج + Status', subtitle: 'مجاني وكل الجزائريين عندهم واتساب', detail: 'رسالة ترحيب تلقائية، Broadcast للعروض، Status للمنتجات الجديدة، وقروبات الزبائن المهتمين' },
      category: 'ch7-marketing',
    },
    {
      id: 23,
      front: { icon: 'heart-pulse', text: 'واش أهم من التسويق نفسو؟' },
      back: { title: 'خدمة الزبائن!', subtitle: 'زبون مبسوط = 10 زبائن جدد', detail: 'رد سريع، ابتسامة واحترام، حل المشاكل فوراً، صدق، متابعة بعد الشراء' },
      category: 'ch7-marketing',
    },
    {
      id: 24,
      front: { icon: 'bar-chart-3', text: 'واش هي القاعدة الذهبية في قياس التسويق؟' },
      back: { title: 'LTV > CAC × 3', subtitle: 'قيمة الزبون الدائمة > 3× تكلفة جلبو', detail: 'CAC: تكلفة جلب زبون جديد. LTV: بشحال يشري منك طول حياتو. مثال: CAC=500 دج، LTV=72,000 دج' },
      category: 'ch7-marketing',
    },

    // === Chapter 8: Operations (2 cards) ===
    {
      id: 25,
      front: { icon: 'package', text: 'كيفاه تدير المخزون بطريقة بسيطة؟' },
      back: { title: 'دفتر + جرد أسبوعي + FIFO', subtitle: 'الأول يدخل = الأول يخرج', detail: 'سجل كل شيء يدخل ويخرج. حدد الحد الأدنى للطلب. استعمل Excel. كل عملية بفاتورة!' },
      category: 'ch8-operations',
    },
    {
      id: 26,
      front: { icon: 'calendar', text: 'كيفاه رجل الأعمال ينظم يومو؟' },
      back: { title: 'تخطيط صباحاً + مهام صعبة أولاً', subtitle: 'يوم راحة كامل = ضروري', detail: '6-8: تخطيط. 8-12: مهام صعبة. 2-6: اجتماعات. 6-8: متابعة زبائن. 8-10: تعلم. الجمعة: راحة!' },
      category: 'ch8-operations',
    },

    // === Chapter 9: Certifications (2 cards) ===
    {
      id: 27,
      front: { icon: 'shield-check', text: 'كيفاه تاخذ شهادة الحلال في الجزائر؟' },
      back: { title: 'من IANOR: 30-80K دج في 2-4 أشهر', subtitle: 'ثقة الزبائن + ميزة تنافسية + تصدير', detail: 'تقديم ملف، زيارة تفتيشية، فحص المواد، التأكد من المطابقة الشرعية. تجنب الجيلاتين والكحول!' },
      category: 'ch9-quality',
    },
    {
      id: 28,
      front: { icon: 'file-text', text: 'واش هي شهادات الجودة المهمة للتصدير؟' },
      back: { title: 'ISO 9001 + ISO 22000', subtitle: 'معايير دولية للجودة والسلامة', detail: 'ISO 9001: إدارة الجودة (200-500K دج). ISO 22000: سلامة الغذاء. ضروريين للتصدير والمناقصات الكبيرة' },
      category: 'ch9-quality',
    },

    // === Chapter 10: Growth (2 cards) ===
    {
      id: 29,
      front: { icon: 'compass', text: 'وقتاه تتوسع في مشروعك؟' },
      back: { title: 'بعد 6+ أشهر ربح مستقر!', subtitle: 'النمو الذكي أفضل من السريع', detail: 'علامات الجاهزية: ربح مستقر، طلب يفوق العرض، فريق قوي، عمليات منظمة، ورأس مال احتياطي' },
      category: 'ch10-growth',
    },
    {
      id: 30,
      front: { icon: 'rocket', text: 'واش هي استراتيجيات النمو المتاحة؟' },
      back: { title: '6 طرق للتوسع', subtitle: '"ابدا صغير، احترف، ثم توسع"', detail: 'فروع جديدة، خطوط إنتاج إضافية، توسع رقمي، امتياز (Franchising)، تصدير، وشراكات استراتيجية' },
      category: 'ch10-growth',
    },
  ],

  // Course ID 19: تعلم الإنجليزية في أسبوع
  19: [
    // === Day 1: Foundation Basics (5 cards) ===
    {
      id: 1,
      front: { icon: 'globe', text: 'كيفاه نسلمو ونحيو بالإنجليزية؟' },
      back: { title: 'Hello / Hi / Good morning', subtitle: 'Hi أكثر استعمالاً من Hello', detail: 'Good morning (صباحاً)، Good afternoon (القايلة)، Good evening (العشية)، Good night (تصبح على خير)' },
      category: 'day1-basics',
    },
    {
      id: 2,
      front: { icon: 'users', text: 'واش هي الضمائر الشخصية بالإنجليزية؟' },
      back: { title: 'I, You, He, She, It, We, They', subtitle: '"You" للمفرد والجمع!', detail: 'I (أنا)، You (أنت/أنتوما)، He (هو)، She (هي)، It (للأشياء)، We (حنا)، They (هوما)' },
      category: 'day1-basics',
    },
    {
      id: 3,
      front: { icon: 'brain', text: 'واش هي القاعدة الذهبية لفعل "To Be"؟' },
      back: { title: 'I → am | He/She/It → is | You/We/They → are', subtitle: 'أهم فعل في الإنجليزية!', detail: 'I am happy. He is tall. We are friends. الاختصارات: I\'m, He\'s, We\'re' },
      category: 'day1-basics',
    },
    {
      id: 4,
      front: { icon: 'pen-tool', text: 'كيفاه نعرف على روحي بالإنجليزية؟' },
      back: { title: 'My name is... I am from... I am ... years old', subtitle: 'Nice to meet you! = متشرف!', detail: 'Hello! My name is Ahmed. I am from Algeria. I live in Algiers. I am 25 years old. I am a student.' },
      category: 'day1-basics',
    },
    {
      id: 5,
      front: { icon: 'search', text: 'واش هي كلمات السؤال الأساسية؟' },
      back: { title: 'What, Who, Where, When, Why, How', subtitle: 'Question word + to be + subject', detail: 'What (واش)، Who (شكون)، Where (وين)، When (وقتاش)، Why (علاه)، How (كيفاه)' },
      category: 'day1-basics',
    },

    // === Day 2: Daily Life (5 cards) ===
    {
      id: 6,
      front: { icon: 'bar-chart-3', text: 'كيفاه نقولو الأرقام المركبة بالإنجليزية؟' },
      back: { title: 'Twenty-five (25)، Thirty-three (33)', subtitle: 'العشرات: twenty, thirty, forty, fifty...', detail: '47 → Forty-seven. 89 → Eighty-nine. 100 → One hundred. نجمعو العشرات + الآحاد بـ hyphen (-)' },
      category: 'day2-daily',
    },
    {
      id: 7,
      front: { icon: 'calendar', text: 'واش هي أيام الأسبوع بالإنجليزية؟' },
      back: { title: 'Monday → Sunday', subtitle: 'Today (اليوم)، Tomorrow (غدوة)، Yesterday (البارح)', detail: 'Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday. كلهم يبداو بحرف كبير!' },
      category: 'day2-daily',
    },
    {
      id: 8,
      front: { icon: 'zap', text: 'متى نستعملو at, in, on للوقت؟' },
      back: { title: 'AT = الساعات | IN = الفترات | ON = الأيام', subtitle: 'قاعدة ذهبية للوقت!', detail: 'at 7 o\'clock, at noon. in the morning, in January. on Monday, on weekends, on my birthday' },
      category: 'day2-daily',
    },
    {
      id: 9,
      front: { icon: 'file-text', text: 'واش هي قاعدة المضارع البسيط (Present Simple)؟' },
      back: { title: 'He/She/It + verb + s', subtitle: 'I work ← لكن → He works', detail: 'نزيدو es مع: s, x, z, ch, sh, o → go/goes, watch/watches. نستعملوه للعادات والروتين اليومي' },
      category: 'day2-daily',
    },
    {
      id: 10,
      front: { icon: 'trending-up', text: 'واش هي ظروف التكرار ووين نحطوهم؟' },
      back: { title: 'always, usually, often, sometimes, rarely, never', subtitle: 'قبل الفعل العادي، بعد فعل to be', detail: 'I always wake up at 7. She never drinks coffee. لكن: I am always happy (بعد am/is/are)' },
      category: 'day2-daily',
    },

    // === Day 3: People & Relationships (4 cards) ===
    {
      id: 11,
      front: { icon: 'heart-pulse', text: 'واش هي كلمات العائلة الأساسية؟' },
      back: { title: 'Father, Mother, Brother, Sister, Son, Daughter', subtitle: 'Uncle, Aunt, Cousin, Grandfather, Grandmother', detail: 'Uncle (عمي/خالي)، Aunt (عمتي/خالتي)، Husband (راجل)، Wife (مرا)، Children (الدراري)' },
      category: 'day3-people',
    },
    {
      id: 12,
      front: { icon: 'building', text: 'كيفاه نسأل على المهنة بالإنجليزية؟' },
      back: { title: 'What do you do? / What is your job?', subtitle: 'Where do you work? = وين تخدم؟', detail: 'Teacher (أستاذ)، Doctor (طبيب)، Engineer (مهندس)، Lawyer (محامي)، Driver (سايق)، Chef (طباخ)' },
      category: 'day3-people',
    },
    {
      id: 13,
      front: { icon: 'sparkles', text: 'كيفاه نوصف شخص بالإنجليزية؟' },
      back: { title: 'المظهر + الشخصية + الشعر والعيون', subtitle: 'He has + الوصف | He is + الصفة', detail: 'Tall/Short, Strong/Weak. She has long black hair. He is smart and funny. She has brown eyes.' },
      category: 'day3-people',
    },
    {
      id: 14,
      front: { icon: 'shield-check', text: 'واش الفرق بين my/your/his و mine/yours/his؟' },
      back: { title: 'Adjective قبل الاسم | Pronoun بدون اسم', subtitle: 'This is my book ← → This book is mine', detail: 'my/your/his/her/our/their + اسم. mine/yours/his/hers/ours/theirs بدون اسم بعدها' },
      category: 'day3-people',
    },

    // === Day 4: Places & Directions (4 cards) ===
    {
      id: 15,
      front: { icon: 'compass', text: 'واش هي أهم الأماكن في المدينة؟' },
      back: { title: 'Hospital, Bank, School, Restaurant, Park...', subtitle: 'كلمات ضرورية للحياة اليومية', detail: 'Pharmacy (صيدلية)، Mosque (جامع)، Mall (مول)، Airport (مطار)، Train station (محطة القطار)' },
      category: 'day4-places',
    },
    {
      id: 16,
      front: { icon: 'target', text: 'متى نستعملو in, on, at للأماكن؟' },
      back: { title: 'IN = المدن والدول | ON = الشوارع | AT = أماكن محددة', subtitle: 'in Algeria, on Main Street, at school', detail: 'in the house, in Algiers. on the second floor. at the bus stop, at home, at work' },
      category: 'day4-places',
    },
    {
      id: 17,
      front: { icon: 'truck', text: 'كيفاه نسأل على الطريق ونعطي الاتجاهات؟' },
      back: { title: 'Excuse me, where is...? / How do I get to...?', subtitle: 'Go straight, Turn right/left', detail: 'Go straight (سير نيشان)، Turn right (دور لليمين)، Turn left (لليسار)، At the traffic light (عند الضو)' },
      category: 'day4-places',
    },
    {
      id: 18,
      front: { icon: 'globe-2', text: 'كيفاه نقولو "بواسطة" لوسائل النقل؟' },
      back: { title: 'by car, by bus, by train, by plane', subtitle: 'لكن: on foot = على الرجل!', detail: 'Car (طوموبيل)، Bus (كار)، Train (قطار)، Plane (طيارة)، Taxi (تاكسي)، Bicycle (بيسكليت)' },
      category: 'day4-places',
    },

    // === Day 5: Food & Shopping (4 cards) ===
    {
      id: 19,
      front: { icon: 'package', text: 'واش هي أهم كلمات الأكل بالإنجليزية؟' },
      back: { title: 'Fruits, Vegetables, Meat, Drinks', subtitle: 'Apple (تفاحة)، Tomato (طماطيش)، Chicken (دجاج)', detail: 'Bread (خبز)، Rice (روز)، Fish (حوت)، Egg (بيضة)، Milk (حليب)، Coffee (قهوة)، Water (ماء)' },
      category: 'day5-food',
    },
    {
      id: 20,
      front: { icon: 'message-square', text: 'كيفاه نطلب الأكل في المطعم؟' },
      back: { title: 'I would like... / Can I see the menu?', subtitle: 'Can I have the bill? = جيب الحساب!', detail: 'What do you recommend? (واش تنصحني). It\'s delicious! (بنين). I\'m hungry (جيعان). I\'m full (شبعان)' },
      category: 'day5-food',
    },
    {
      id: 21,
      front: { icon: 'coins', text: 'كيفاه نسأل على الأسعار ونتسوق؟' },
      back: { title: 'How much is this? = بشحال هذا؟', subtitle: 'I\'ll take it = راني ناخذو', detail: 'Too expensive (غالي بزاف). Can you give me a discount? (تنقصلي؟). Can I pay by card? (نخلص بالكارت؟)' },
      category: 'day5-food',
    },
    {
      id: 22,
      front: { icon: 'percent', text: 'واش الفرق بين much و many؟' },
      back: { title: 'Much = ما يتعداش | Many = يتعدا', subtitle: 'Uncountable vs Countable', detail: 'much water, much money, much time (ما نعدوهمش). many apples, many people, many cars (نعدوهم)' },
      category: 'day5-food',
    },

    // === Day 6: Actions & Activities (4 cards) ===
    {
      id: 23,
      front: { icon: 'rocket', text: 'واش هي أهم أفعال الحركة بالإنجليزية؟' },
      back: { title: '50+ فعل للحياة اليومية', subtitle: 'Open/Close, Start/Finish, Give/Take', detail: 'Stand (نوقف), Run (نجري), Swim (نعوم), Help (نعاون), Think (نفكر), Learn (نتعلم), Find (نلقى)' },
      category: 'day6-actions',
    },
    {
      id: 24,
      front: { icon: 'cpu', text: 'واش هي قاعدة المضارع المستمر (Present Continuous)؟' },
      back: { title: 'Subject + am/is/are + verb-ing', subtitle: 'لحاجة راها تصرا دروك!', detail: 'I am eating (راني ناكل). He is working (راهو يخدم). -e → writing (نحذفو e). run → running (نضاعفو)' },
      category: 'day6-actions',
    },
    {
      id: 25,
      front: { icon: 'palette', text: 'كيفاه نهدرو على الهوايات والرياضة؟' },
      back: { title: 'play + كورة | go + ing | do + أخرى', subtitle: 'I like/love/enjoy + verb-ing', detail: 'play football/basketball. go swimming/running/cycling. do yoga/karate. I enjoy cooking (نستمتع بالطبخ)' },
      category: 'day6-actions',
    },
    {
      id: 26,
      front: { icon: 'shield-check', text: 'كيفاه نستعملو can و can\'t؟' },
      back: { title: 'can + verb (بدون to)', subtitle: 'can = نقدر | can\'t = ما نقدرش', detail: 'I can speak English (نقدر نهدر). She can\'t drive (ما تقدرش تسوق). Can you swim? (تقدر تعوم؟)' },
      category: 'day6-actions',
    },

    // === Day 7: Complete Communication (4 cards) ===
    {
      id: 27,
      front: { icon: 'file-text', text: 'كيفاه نحكيو على الماضي (Past Simple)؟' },
      back: { title: 'Regular: +ed | Irregular: يتغير كامل', subtitle: 'Did + فعل أصلي للسؤال والنفي', detail: 'worked, played (منتظمة). go→went, eat→ate, buy→bought (شاذة). Did you go? I didn\'t eat.' },
      category: 'day7-comm',
    },
    {
      id: 28,
      front: { icon: 'trending-up', text: 'واش الفرق بين will و going to للمستقبل؟' },
      back: { title: 'will = قرار فوري | going to = خطة مسبقة', subtitle: 'I will help you ← → I am going to travel', detail: 'will + verb: I\'ll call you (راح نتصل). going to + verb: I\'m going to study (راح نقرا/ناوي نقرا)' },
      category: 'day7-comm',
    },
    {
      id: 29,
      front: { icon: 'smartphone', text: 'كيفاه نهدرو في التليفون بالإنجليزية؟' },
      back: { title: 'Hello? This is... Can I speak to...?', subtitle: 'Hold on, please = تسنى من فضلك', detail: 'Who\'s calling? (شكون يتصل). He\'s not here (ماراهوش). I\'ll call back later (نتصل من بعد)' },
      category: 'day7-comm',
    },
    {
      id: 30,
      front: { icon: 'megaphone', text: 'واش هي جمل الطوارئ الأساسية؟' },
      back: { title: 'Help! / Call the police! / I need help', subtitle: 'Emergency = حالة طارئة', detail: 'Call an ambulance! (نادو الإسعاف). I\'m sick (مريض). I\'m lost (تايه). I lost my passport (ضيعت الباسبور)' },
      category: 'day7-comm',
    },
  ],

  // Course ID 20: تعلم الإسبانية في أسبوع
  20: [
    // === Day 1: Foundation Basics (5 cards) ===
    {
      id: 1,
      front: { icon: 'globe', text: 'واش هي الحروف الخاصة في الإسبانية وكيفاه ننطقوهم؟' },
      back: { title: 'Ñ, LL, RR, J, H', subtitle: '27 حرف - كل حرف ينطق كيما مكتوب!', detail: 'Ñ=ني (Mañana)، LL=ي (Llamar)، RR=ر قوية (Perro)، J=خ (Joven)، H=صامت! (Hola=أولا)' },
      category: 'dia1-bases',
    },
    {
      id: 2,
      front: { icon: 'message-square', text: 'كيفاه نسلمو بالإسبانية حسب الوقت؟' },
      back: { title: 'Buenos días / Buenas tardes / Buenas noches', subtitle: 'Hola = للكل! Gracias = شكراً', detail: 'Buenos días: صباح→2ظهر. Buenas tardes: 2ظهر→8ليل. Buenas noches: من 8 الليل (تحية أو وداع)' },
      category: 'dia1-bases',
    },
    {
      id: 3,
      front: { icon: 'brain', text: 'علاه الإسبانية عندها فعلين "يكون"؟ واش الفرق بين SER و ESTAR؟' },
      back: { title: 'SER = دائم | ESTAR = مؤقت', subtitle: 'أهم نقطة في الإسبانية كاملة!', detail: 'SER: اسم، مهنة، أصل (Soy Ahmed). ESTAR: مكان، مشاعر، حالة (Estoy en casa). Soy guapo (دايماً) vs Estoy guapo (اليوم)' },
      category: 'dia1-bases',
    },
    {
      id: 4,
      front: { icon: 'sparkles', text: 'كيفاه نقولو "عندي" بالإسبانية؟ واش التعابير الخاصة بـ TENER؟' },
      back: { title: 'TENER: Tengo, Tienes, Tiene, Tenemos, Tienen', subtitle: 'تعابير خاصة ما كايناش بالعربية!', detail: 'Tener hambre (جوع)، sed (عطش)، sueño (نعاس)، miedo (خوف)، calor/frío (سخانة/برد)، ... años (عمر)' },
      category: 'dia1-bases',
    },
    {
      id: 5,
      front: { icon: 'search', text: 'واش هي كلمات الأسئلة بالإسبانية؟ واش الخاص فيها؟' },
      back: { title: '¿Qué? ¿Quién? ¿Dónde? ¿Cuándo? ¿Por qué? ¿Cómo?', subtitle: 'علامتين استفهام: ¿ في البداية و ? في النهاية!', detail: '¿Qué? (واش)، ¿Quién? (شكون)، ¿Dónde? (وين)، ¿Cuándo? (وقتاش)، ¿Por qué? (علاش)، ¿Cómo? (كيفاش)' },
      category: 'dia1-bases',
    },

    // === Day 2: Daily Life (5 cards) ===
    {
      id: 6,
      front: { icon: 'bar-chart-3', text: 'كيفاه نقولو الوقت بالإسبانية؟' },
      back: { title: '¿Qué hora es? → Es la una / Son las dos', subtitle: 'y cuarto (الربع)، y media (النص)، menos cuarto (إلا الربع)', detail: 'Son las tres y cuarto (3:15). Son las seis y media (6:30). Son las ocho menos cuarto (7:45)' },
      category: 'dia2-vida',
    },
    {
      id: 7,
      front: { icon: 'calendar', text: 'واش هي أيام الأسبوع بالإسبانية؟' },
      back: { title: 'Lunes → Domingo', subtitle: 'كلهم مذكر وما يتكتبوش بحرف كبير!', detail: 'Lunes (الاثنين)، Martes (الثلاثاء)، Miércoles (الأربعاء)، Jueves (الخميس)، Viernes (الجمعة)، Sábado، Domingo' },
      category: 'dia2-vida',
    },
    {
      id: 8,
      front: { icon: 'globe-2', text: 'كيفاه نحكيو على الطقس بالإسبانية؟' },
      back: { title: '¿Qué tiempo hace? = كيفاه الطقس؟', subtitle: 'Hace + اسم (أغلب الأحيان)', detail: 'Hace calor (حار)، Hace frío (بارد)، Hace sol (شمس)، Hace viento (ريح). لكن: Llueve (يشتي)، Nieva (يثلج)' },
      category: 'dia2-vida',
    },
    {
      id: 9,
      front: { icon: 'package', text: 'واش هي كلمات الأكل الأساسية بالإسبانية؟' },
      back: { title: 'Pan, Carne, Pescado, Pollo, Arroz', subtitle: 'الوجبات: Desayuno, Almuerzo, Cena', detail: 'El pan (خبز)، La carne (لحم)، El pescado (حوت)، El pollo (دجاج)، El queso (فرماج)، Los huevos (بيض)' },
      category: 'dia2-vida',
    },
    {
      id: 10,
      front: { icon: 'trending-up', text: 'واش هي أفعال الروتين اليومي بالإسبانية؟' },
      back: { title: 'Despertarse, Ducharse, Desayunar, Ir, Dormir', subtitle: 'أفعال انعكاسية: الفعل ينعكس على الشخص', detail: 'Me despierto (نفيق)، Me ducho (ندوش)، Desayuno (نفطر)، Voy al trabajo (نروح للخدمة)، Me acuesto (نرقد)' },
      category: 'dia2-vida',
    },

    // === Day 3: People & Relationships (4 cards) ===
    {
      id: 11,
      front: { icon: 'heart-pulse', text: 'واش هي كلمات العائلة بالإسبانية؟' },
      back: { title: 'Padre, Madre, Hermano, Hermana, Hijo, Hija', subtitle: 'Abuelo (جد)، Tío (عم/خال)، Primo (ولد العم)', detail: 'El esposo/marido (الراجل)، La esposa/mujer (المرا)، El novio (الخطيب)، Los padres (الوالدين)' },
      category: 'dia3-gente',
    },
    {
      id: 12,
      front: { icon: 'users', text: 'كيفاه نوصف شخص جسدياً وشخصياً بالإسبانية؟' },
      back: { title: 'الصفات لازم توافق الجنس! Alto/Alta', subtitle: 'ESTAR للمشاعر المؤقتة!', detail: 'Alto/Bajo (طويل/قصير). Simpático/Inteligente (باهي/ذكي). Estoy feliz (فرحان-مؤقت) vs Soy alegre (شخص مرح-دائم)' },
      category: 'dia3-gente',
    },
    {
      id: 13,
      front: { icon: 'palette', text: 'واش هي الألوان بالإسبانية؟' },
      back: { title: 'Rojo, Azul, Verde, Amarillo, Negro, Blanco', subtitle: 'الألوان تتبع جنس الاسم!', detail: 'Rojo/Roja (أحمر). Naranja (برتقالي)، Marrón (بني)، Rosa (وردي)، Gris (رمادي). Mi coche es rojo (طوموبيلتي حمرا)' },
      category: 'dia3-gente',
    },
    {
      id: 14,
      front: { icon: 'building', text: 'كيفاه نقولو المهنة بالإسبانية؟' },
      back: { title: 'Soy + مهنة (بدون أداة تعريف!)', subtitle: 'المهن تتغير حسب الجنس: Médico/Médica', detail: 'Soy médico (طبيب). Soy profesora (أستاذة). ¿A qué te dedicas? = شنوا تخدم؟ Ingeniero، Abogado، Cocinero' },
      category: 'dia3-gente',
    },

    // === Day 4: Places & Directions (4 cards) ===
    {
      id: 15,
      front: { icon: 'compass', text: 'كيفاه نسأل على الأماكن والاتجاهات بالإسبانية؟' },
      back: { title: '¿Dónde está...? / ¿Cómo llego a...?', subtitle: '¿Está lejos? (بعيد؟) ¿Está cerca? (قريب؟)', detail: 'Siga recto (نيشان)، Gire a la derecha (يمين)، Gire a la izquierda (يسار)، En la esquina (الزاوية)' },
      category: 'dia4-lugares',
    },
    {
      id: 16,
      front: { icon: 'truck', text: 'واش هي وسائل النقل بالإسبانية؟' },
      back: { title: 'Coche, Autobús, Taxi, Tren, Metro, Avión', subtitle: 'Voy en coche (بالطوموبيل) | A pie (ماشي)', detail: 'Un billete, por favor (تذكرة عافاك). ¿Cuánto cuesta el billete? (بشحال؟). ¿Dónde bajo? (وين نهبط؟)' },
      category: 'dia4-lugares',
    },
    {
      id: 17,
      front: { icon: 'coins', text: 'كيفاه نتسوقو ونسألو على الأسعار بالإسبانية؟' },
      back: { title: '¿Cuánto cuesta esto? = بشحال هذا؟', subtitle: 'Es muy caro (غالي) | Es barato (رخيص)', detail: 'Lo compro (نشريه). ¿Puedo pagar con tarjeta? (بالكارت؟). En efectivo (كاش). Grande/Mediano/Pequeño' },
      category: 'dia4-lugares',
    },
    {
      id: 18,
      front: { icon: 'message-square', text: 'كيفاه نطلبو الأكل في المطعم بالإسبانية؟' },
      back: { title: 'Una mesa para dos / La carta, por favor', subtitle: 'La cuenta, por favor = الحساب عافاك', detail: '¿Qué desea? (شنوا تحب؟). Quiero... (حاب...). Para mí... (ليا...). ¡Está delicioso! (بنين!)' },
      category: 'dia4-lugares',
    },

    // === Day 5: Verbs & Actions (4 cards) ===
    {
      id: 19,
      front: { icon: 'rocket', text: 'واش هي أهم 3 أفعال في الإسبانية وكيفاه نصرفوهم؟' },
      back: { title: 'HACER (يدير) | PODER (يقدر) | QUERER (يحب)', subtitle: 'Hago, Puedo, Quiero (أنا)', detail: '¿Qué haces? (شنوا دير؟). ¿Puedes ayudarme? (تقدر تعاوني؟). Quiero agua (حاب الماء). No puedo (ما نقدرش)' },
      category: 'dia5-verbos',
    },
    {
      id: 20,
      front: { icon: 'sparkles', text: 'كيفاه يخدم فعل GUSTAR (يعجب) الخاص؟' },
      back: { title: 'Me gusta (شيء واحد) | Me gustan (حاجات بزاف)', subtitle: 'me, te, le, nos, os, les + gusta/gustan', detail: 'Me gusta el café (يعجبني). Me gustan los deportes (يعجبوني). ¿Te gusta la música? (تعجبك؟). No me gusta (ما يعجبنيش)' },
      category: 'dia5-verbos',
    },
    {
      id: 21,
      front: { icon: 'cpu', text: 'واش هي الأفعال الانعكاسية وكيفاه نستعملوهم؟' },
      back: { title: 'أفعال تنعكس على الشخص: me, te, se, nos, se', subtitle: 'Me llamo (سميتي) | Me despierto (نفيق)', detail: 'Lavarse (يتغسل): Me lavo, Te lavas, Se lava. Ducharse (يدوش)، Vestirse (يلبس)، Acostarse (يرقد)' },
      category: 'dia5-verbos',
    },
    {
      id: 22,
      front: { icon: 'trending-up', text: 'كيفاه نعبرو على المستقبل القريب بالإسبانية؟' },
      back: { title: 'IR (مصرّف) + A + فعل مصدر', subtitle: 'Voy a estudiar = راح نقرا', detail: 'Voy a comer (راح ناكل). Vas a trabajar (راح تخدم). Va a llover (راح تشتي). Vamos a viajar (راح نسافرو)' },
      category: 'dia5-verbos',
    },

    // === Day 6: Culture & Expressions (4 cards) ===
    {
      id: 23,
      front: { icon: 'megaphone', text: 'واش هي التعابير اليومية الأكثر استعمالاً بالإسبانية؟' },
      back: { title: '¡Vale! ¡Claro! ¡Ojalá! ¡Ya está!', subtitle: 'تعابير ضرورية للحياة اليومية', detail: '¡Qué bien! (مليح). ¡No pasa nada! (ماكاش باس). ¡Tranquilo! (هدّي). ¡Venga! (يالاه). ¡Dios mío! (يا ربي)' },
      category: 'dia6-cultura',
    },
    {
      id: 24,
      front: { icon: 'globe', text: 'واش هي أهم عناصر الثقافة الإسبانية؟' },
      back: { title: 'La Siesta, Las Tapas, El Flamenco', subtitle: 'الإسبان يتعشاو من 9-11 الليل!', detail: 'Siesta: راحة 2-5 عصر. Tapas: أكلات صغيرة. Flamenco: رقص وموسيقى من الأندلس. الغداء 2-4 هو الوجبة الرئيسية!' },
      category: 'dia6-cultura',
    },
    {
      id: 25,
      front: { icon: 'shield-check', text: 'واش هي جمل الطوارئ بالإسبانية؟' },
      back: { title: '¡Ayuda! ¡Socorro! | Necesito un médico', subtitle: 'رقم الطوارئ في إسبانيا: 112', detail: '¡Cuidado! (ردّ بالك). ¡Policía! (البوليس). Estoy perdido (أنا تايه). Llame una ambulancia (عيطو للإسعاف)' },
      category: 'dia6-cultura',
    },
    {
      id: 26,
      front: { icon: 'smartphone', text: 'كيفاه نهدرو في التليفون بالإسبانية؟' },
      back: { title: '¿Dígame? / ¿Diga? = آلو؟', subtitle: 'Un momento, por favor = شوية عافاك', detail: '¿Quién es? (شكون). ¿Está Juan? (واش خوان موجود). No está (مش موجود). Número equivocado (غلطت الرقم)' },
      category: 'dia6-cultura',
    },

    // === Day 7: Review & Advanced (4 cards) ===
    {
      id: 27,
      front: { icon: 'brain', text: 'ملخص: SER vs ESTAR - كيفاه نفرقو بينهم؟' },
      back: { title: 'SER = Who you ARE | ESTAR = How/Where you ARE', subtitle: 'SER: الدائم والثابت | ESTAR: المؤقت والمتغير', detail: 'SER: Soy Ahmed (اسم)، Soy médico (مهنة)، Soy de Argelia (أصل). ESTAR: Estoy en casa (مكان)، Estoy feliz (مشاعر)' },
      category: 'dia7-repaso',
    },
    {
      id: 28,
      front: { icon: 'search', text: 'واش الفرق بين SABER و CONOCER (يعرف)؟' },
      back: { title: 'SABER = معلومة/مهارة | CONOCER = شخص/مكان', subtitle: 'Sé hablar español vs Conozco a María', detail: 'Sé (نعرف معلومة): Sé cocinar (نعرف نطيب). Conozco (نعرف شخص/مكان): Conozco Madrid (نعرف مدريد)' },
      category: 'dia7-repaso',
    },
    {
      id: 29,
      front: { icon: 'file-text', text: 'كيفاه ننفيو بالإسبانية؟ واش القاعدة؟' },
      back: { title: 'NO + فعل = النفي', subtitle: 'بسيطة بزاف! نحطو NO قبل الفعل مباشرة', detail: 'No hablo (ما نهدرش). No tengo tiempo (ما عنديش الوقت). No me gusta (ما يعجبنيش). No puedo (ما نقدرش)' },
      category: 'dia7-repaso',
    },
    {
      id: 30,
      front: { icon: 'compass', text: 'واش هي الأمثال الإسبانية الشهيرة؟' },
      back: { title: 'Más vale tarde que nunca', subtitle: 'الأفضل معطل من أبداً', detail: 'No es oro todo lo que reluce (مش كل ما يلمع ذهب). A quien madruga, Dios le ayuda (اللي يفيق بكري ربي يعاونو)' },
      category: 'dia7-repaso',
    },
  ],

  // Course ID 21: تعلم الإيطالية في أسبوع
  21: [
    // === Day 1: Foundation Basics (5 cards) ===
    {
      id: 1,
      front: { icon: 'globe', text: 'واش هي التركيبات الخاصة في النطق الإيطالي؟' },
      back: { title: 'CH, GH, GLI, GN, SC, CI, GI', subtitle: '21 حرف + H صامت + حروف مضاعفة مهمة!', detail: 'CH=ك (chi)، GH=ڨ (spaghetti)، GLI=ليي (famiglia)، GN=ني (gnocchi)، SC+E/I=ش (pesce)، CI=تش (ciao)' },
      category: 'g1-basi',
    },
    {
      id: 2,
      front: { icon: 'message-square', text: 'كيفاه نسلمو بالإيطالية؟' },
      back: { title: 'Ciao! Buongiorno! Grazie! Per favore!', subtitle: 'Ciao = للترحيب والوداع مع الصحاب', detail: 'Buongiorno (صباح الخير)، Buonasera (مساء الخير)، Buonanotte (ليلة سعيدة)، Arrivederci (بسلامة)، Grazie mille! (ألف شكر)' },
      category: 'g1-basi',
    },
    {
      id: 3,
      front: { icon: 'brain', text: 'كيفاه نصرفو فعل Essere (يكون) بالإيطالية؟' },
      back: { title: 'Sono, Sei, È, Siamo, Siete, Sono', subtitle: 'من أهم الأفعال - احفظوه مليح!', detail: 'Io sono (أنا راني)، Tu sei (أنت راك)، Lui/Lei è (هو/هي راه)، Noi siamo (حنا رانا)، Loro sono (هوما راهم)' },
      category: 'g1-basi',
    },
    {
      id: 4,
      front: { icon: 'sparkles', text: 'كيفاه نقولو "عندي" بالإيطالية؟ واش التعابير الخاصة بـ Avere؟' },
      back: { title: 'Ho, Hai, Ha, Abbiamo, Avete, Hanno', subtitle: 'تعابير خاصة: Avere fame/sete/sonno/paura', detail: 'Ho fame (عندي الجوع)، Ho sete (العطش)، Ho sonno (النعاس)، Ho paura (الخوف)، Ho 25 anni (عندي 25 عام)' },
      category: 'g1-basi',
    },
    {
      id: 5,
      front: { icon: 'pen-tool', text: 'كيفاه نعرف على روحي بالإيطالية؟' },
      back: { title: 'Mi chiamo... Sono di... Ho ... anni', subtitle: 'Piacere! = متشرف!', detail: 'Come ti chiami? (شنوا سميتك). Di dove sei? (منين أنت). Quanti anni hai? (شحال عمرك). Sono studente (أنا طالب)' },
      category: 'g1-basi',
    },

    // === Day 2: Daily Life (5 cards) ===
    {
      id: 6,
      front: { icon: 'bar-chart-3', text: 'كيفاه نقولو الوقت بالإيطالية؟' },
      back: { title: 'Che ora è? → È l\'una / Sono le due', subtitle: 'e un quarto (الربع)، e mezzo (النص)، meno un quarto (إلا الربع)', detail: 'Sono le tre e un quarto (3:15). Sono le sei e mezzo (6:30). È mezzogiorno (الظهر). È mezzanotte (نص الليل)' },
      category: 'g2-vita',
    },
    {
      id: 7,
      front: { icon: 'calendar', text: 'واش هي أيام الأسبوع بالإيطالية؟' },
      back: { title: 'Lunedì → Domenica', subtitle: 'كلهم مذكر ماعدا la Domenica (مؤنث)!', detail: 'Lunedì (الاثنين)، Martedì (الثلاثاء)، Mercoledì (الأربعاء)، Giovedì (الخميس)، Venerdì (الجمعة)، Sabato، Domenica' },
      category: 'g2-vita',
    },
    {
      id: 8,
      front: { icon: 'globe-2', text: 'كيفاه نحكيو على الطقس بالإيطالية؟' },
      back: { title: 'Che tempo fa? = كيفاه الطقس؟', subtitle: 'Fa + صفة (أغلب الأحيان)', detail: 'Fa caldo (حار)، Fa freddo (بارد)، C\'è il sole (شمس)، Piove (يشتي)، Nevica (يثلج)، Tira vento (ريح)' },
      category: 'g2-vita',
    },
    {
      id: 9,
      front: { icon: 'package', text: 'واش هي كلمات الأكل الأساسية بالإيطالية؟' },
      back: { title: 'Pane, Pasta, Pizza, Carne, Pesce', subtitle: 'الوجبات: Colazione, Pranzo, Cena', detail: 'Il pane (خبز)، La pasta (معكرونة)، Il riso (روز)، Il pollo (دجاج)، Il formaggio (فرماج)، Le uova (بيض)' },
      category: 'g2-vita',
    },
    {
      id: 10,
      front: { icon: 'trending-up', text: 'واش هي أفعال الروتين اليومي بالإيطالية؟' },
      back: { title: 'Svegliarsi, Fare la doccia, Andare, Dormire', subtitle: 'أفعال انعكاسية: mi sveglio, mi lavo', detail: 'Mi sveglio alle 7 (نفيق). Faccio la doccia (ندوش). Vado al lavoro (نروح للخدمة). Vado a dormire (نروح نرقد)' },
      category: 'g2-vita',
    },

    // === Day 3: People & Relationships (4 cards) ===
    {
      id: 11,
      front: { icon: 'heart-pulse', text: 'واش هي كلمات العائلة بالإيطالية؟' },
      back: { title: 'Padre, Madre, Fratello, Sorella, Figlio, Figlia', subtitle: 'Nonno (جد)، Zio (عم/خال)، Cugino (ابن العم)', detail: 'Il marito (الراجل)، La moglie (المرا)، Il suocero (حمو)، La suocera (حماة)، Il nipote (حفيد)' },
      category: 'g3-gente',
    },
    {
      id: 12,
      front: { icon: 'building', text: 'كيفاه نقولو المهنة بالإيطالية؟' },
      back: { title: 'Sono + مهنة | المهن تتغير حسب الجنس', subtitle: 'Medico/Dottoressa، Insegnante، Ingegnere', detail: 'Sono medico (طبيب). Che lavoro fai? (شنوا تخدم؟). Avvocato (محامي)، Cuoco (طباخ)، Cameriere (نادل)' },
      category: 'g3-gente',
    },
    {
      id: 13,
      front: { icon: 'users', text: 'كيفاه نوصف المشاعر والصفات بالإيطالية؟' },
      back: { title: 'Felice, Triste, Arrabbiato, Stanco', subtitle: 'الصفات تتغير حسب الجنس: -o (ذكر) / -a (أنثى)', detail: 'Sono felice (فرحان). Sono stanco/a (عيان). Alto/Basso (طويل/قصير). Bello/Brutto (زوين/قبيح). Simpatico (باهي)' },
      category: 'g3-gente',
    },
    {
      id: 14,
      front: { icon: 'shield-check', text: 'كيفاه نستعملو ضمائر الملكية بالإيطالية؟' },
      back: { title: 'Mio, Tuo, Suo, Nostro, Vostro, Loro', subtitle: 'تتغير حسب الجنس والعدد!', detail: 'Mio padre (بابا). Mia madre (ماما). Il mio libro (كتابي). La mia casa (داري). I miei amici (صحابي)' },
      category: 'g3-gente',
    },

    // === Day 4: Places & Directions (4 cards) ===
    {
      id: 15,
      front: { icon: 'compass', text: 'واش هي أهم الأماكن في المدينة بالإيطالية؟' },
      back: { title: 'La città, La stazione, L\'aeroporto, Il ristorante', subtitle: 'La farmacia, La banca, L\'ospedale', detail: 'Il centro (الوسط)، La piazza (الساحة)، Il museo (المتحف)، Il cinema، La chiesa (الكنيسة)، La moschea (الجامع)' },
      category: 'g4-luoghi',
    },
    {
      id: 16,
      front: { icon: 'target', text: 'كيفاه نسألو على الطريق ونعطيو الاتجاهات بالإيطالية؟' },
      back: { title: 'Dov\'è...? / Come arrivo a...?', subtitle: 'A destra (يمين)، A sinistra (يسار)، Dritto (نيشان)', detail: 'Scusi, dov\'è la stazione? (وين المحطة؟). Giri a destra (دور يمين). Vada dritto (مشي نيشان). È vicino/lontano (قريب/بعيد)' },
      category: 'g4-luoghi',
    },
    {
      id: 17,
      front: { icon: 'truck', text: 'واش هي وسائل النقل بالإيطالية؟' },
      back: { title: 'La macchina, L\'autobus, Il treno, L\'aereo', subtitle: 'Vado in macchina | A piedi (ماشي)', detail: 'Il taxi، La bicicletta (بيسكليت)، La moto (موطور)، La metro. Un biglietto, per favore (تذكرة عافاك)' },
      category: 'g4-luoghi',
    },
    {
      id: 18,
      front: { icon: 'coins', text: 'كيفاه نطلبو الأكل ونتسوقو بالإيطالية؟' },
      back: { title: 'Quanto costa? = بشحال هذا؟', subtitle: 'Vorrei... (حاب...) | Il conto, per favore (الحساب)', detail: 'È troppo caro (غالي بزاف). È buono (رخيص). Lo prendo (ناخذو). Posso pagare con carta? (بالكارت؟)' },
      category: 'g4-luoghi',
    },

    // === Day 5: Shopping & Verbs (4 cards) ===
    {
      id: 19,
      front: { icon: 'palette', text: 'واش هي الألوان بالإيطالية؟' },
      back: { title: 'Rosso, Blu, Verde, Giallo, Nero, Bianco', subtitle: 'الألوان تتغير حسب الجنس: Rosso/Rossa', detail: 'Rosso (أحمر)، Arancione (برتقالي)، Marrone (بني)، Rosa (وردي)، Grigio (رمادي)، Viola (بنفسجي)' },
      category: 'g5-shopping',
    },
    {
      id: 20,
      front: { icon: 'rocket', text: 'كيفاه نصرفو الأفعال المنتظمة في المضارع الإيطالي؟' },
      back: { title: '3 مجموعات: -ARE، -ERE، -IRE', subtitle: 'Parlare: parlo, parli, parla, parliamo, parlate, parlano', detail: '-ARE: parlo, parli, parla. -ERE (leggere): leggo, leggi, legge. -IRE (dormire): dormo, dormi, dorme' },
      category: 'g5-shopping',
    },
    {
      id: 21,
      front: { icon: 'file-text', text: 'واش هي أهم الأفعال الشاذة بالإيطالية؟' },
      back: { title: 'Andare (يروح)، Fare (يدير)، Volere (يحب)، Potere (يقدر)', subtitle: 'Vado, Faccio, Voglio, Posso', detail: 'Vado a casa (نروح للدار). Faccio sport (ندير الرياضة). Voglio mangiare (حاب ناكل). Non posso (ما نقدرش)' },
      category: 'g5-shopping',
    },
    {
      id: 22,
      front: { icon: 'sparkles', text: 'كيفاه يخدم فعل Piacere (يعجب) الخاص؟' },
      back: { title: 'Mi piace (شيء واحد) | Mi piacciono (حاجات بزاف)', subtitle: 'mi, ti, gli/le, ci, vi, gli + piace/piacciono', detail: 'Mi piace la pizza (تعجبني). Mi piacciono i gatti (يعجبوني). Ti piace? (يعجبك؟). Non mi piace (ما يعجبنيش)' },
      category: 'g5-shopping',
    },

    // === Day 6: Communication (4 cards) ===
    {
      id: 23,
      front: { icon: 'smartphone', text: 'كيفاه نهدرو في التليفون بالإيطالية؟' },
      back: { title: 'Pronto? = آلو؟', subtitle: 'Un momento, per favore = شوية عافاك', detail: 'Chi parla? (شكون يهدر). C\'è Marco? (واش ماركو موجود). Non c\'è (مش موجود). Richiamo dopo (نعيط من بعد)' },
      category: 'g6-comunicare',
    },
    {
      id: 24,
      front: { icon: 'users', text: 'واش الفرق بين Tu و Lei (رسمي/غير رسمي)؟' },
      back: { title: 'Tu = صحاب وعائلة | Lei = أدب واحترام', subtitle: 'Come stai? (Tu) vs Come sta? (Lei)', detail: 'Tu sei (أنت راك - صاحبك). Lei è (حضرتك - الكبار/المدير). في المطاعم والإدارات نستعملو Lei دايماً!' },
      category: 'g6-comunicare',
    },
    {
      id: 25,
      front: { icon: 'megaphone', text: 'واش هي التعابير اليومية الأكثر استعمالاً بالإيطالية؟' },
      back: { title: 'Va bene! D\'accordo! Certamente!', subtitle: 'تعابير ضرورية للحياة اليومية', detail: 'Va bene (مليح/واخا). Non lo so (معرفتش). Capisco (فهمت). Non capisco (مافهمتش). Forse (يمكن). Certo! (أكيد!)' },
      category: 'g6-comunicare',
    },
    {
      id: 26,
      front: { icon: 'shield-check', text: 'واش هي جمل الطوارئ بالإيطالية؟' },
      back: { title: 'Aiuto! (النجدة) | Ho bisogno di un medico', subtitle: 'رقم الطوارئ في إيطاليا: 112', detail: 'Attenzione! (ردّ بالك). Polizia! (البوليس). Sono perduto (أنا تايه). Chiamate un\'ambulanza (عيطو للإسعاف)' },
      category: 'g6-comunicare',
    },

    // === Day 7: Culture & Review (4 cards) ===
    {
      id: 27,
      front: { icon: 'globe', text: 'واش هي أهم عناصر الثقافة الإيطالية؟' },
      back: { title: 'Il caffè, La pasta, La moda, L\'arte', subtitle: 'Cappuccino برك الصباح! La dolce vita!', detail: 'القهوة مقدسة وصغيرة وقوية. Cappuccino بعد الغداء = غلطة! الماكلة والموضة والفن = هوية إيطاليا' },
      category: 'g7-cultura',
    },
    {
      id: 28,
      front: { icon: 'search', text: 'واش هي كلمات الأسئلة الأساسية بالإيطالية؟' },
      back: { title: 'Chi? Cosa? Dove? Quando? Perché? Come?', subtitle: 'Quanto? (شحال) | Quale? (أشمن)', detail: 'Chi sei? (شكون أنت). Cosa fai? (واش دير). Dove abiti? (وين ساكن). Quando parti? (وقتاش تروح). Come stai? (كيفاش راك)' },
      category: 'g7-cultura',
    },
    {
      id: 29,
      front: { icon: 'file-text', text: 'كيفاه ننفيو بالإيطالية؟' },
      back: { title: 'Non + فعل = النفي', subtitle: 'بسيطة! نحطو Non قبل الفعل مباشرة', detail: 'Non parlo (ما نهدرش). Non ho tempo (ما عنديش الوقت). Non capisco (مافهمتش). Non mi piace (ما يعجبنيش)' },
      category: 'g7-cultura',
    },
    {
      id: 30,
      front: { icon: 'compass', text: 'واش هي التعابير والأمثال الإيطالية الشهيرة؟' },
      back: { title: 'In bocca al lupo! = بالتوفيق!', subtitle: 'الرد: Crepi il lupo! (ليمت الذئب)', detail: 'La pratica rende perfetti (التمرين يخلي الكمال). Chi dorme non piglia pesci (اللي يرقد ما يشد الحوت). Dolce far niente (حلاوة مادير والو)' },
      category: 'g7-cultura',
    },
  ],

  // Course ID 22: تعلم الفرنسية في أسبوع
  22: [
    // === Day 1: Foundation Basics (5 cards) ===
    {
      id: 1,
      front: { icon: 'globe', text: 'واش هي الحروف الخاصة في الفرنسية وكيفاه ننطقوهم؟' },
      back: { title: 'é, è, ê, ç + الحروف الأخيرة ما تنطقش!', subtitle: '26 حرف + حروف خاصة بعلامات', detail: 'é (إي حادة)، è/ê (إي مفتوحة)، ç (س لينة)، H صامت دايماً. Français → الـ S الأخيرة ما تنطقش!' },
      category: 'fr1-bases',
    },
    {
      id: 2,
      front: { icon: 'message-square', text: 'كيفاه نسلمو بالفرنسية؟' },
      back: { title: 'Bonjour! Merci! S\'il vous plaît!', subtitle: 'Salut = غير رسمي | Bonjour = رسمي', detail: 'Bonjour (صباح الخير)، Bonsoir (مساء الخير)، Au revoir (بسلامة)، Comment allez-vous? (كيفاه راك؟)، Ça va? (لاباس؟)' },
      category: 'fr1-bases',
    },
    {
      id: 3,
      front: { icon: 'brain', text: 'كيفاه نصرفو فعل Être (يكون) بالفرنسية؟' },
      back: { title: 'Suis, Es, Est, Sommes, Êtes, Sont', subtitle: 'أهم فعل في الفرنسية!', detail: 'Je suis (راني)، Tu es (راك)، Il/Elle est (راه/راها)، Nous sommes (رانا)، Vous êtes (راكم)، Ils sont (راهم)' },
      category: 'fr1-bases',
    },
    {
      id: 4,
      front: { icon: 'sparkles', text: 'كيفاه نقولو "عندي" بالفرنسية؟ واش التعابير الخاصة بـ Avoir؟' },
      back: { title: 'J\'ai, Tu as, Il a, Nous avons, Vous avez, Ils ont', subtitle: 'تعابير خاصة: Avoir faim/soif/peur/sommeil', detail: 'J\'ai faim (جيعان)، J\'ai soif (عطشان)، J\'ai sommeil (نعسان)، J\'ai peur (خايف)، J\'ai 25 ans (عندي 25 عام)' },
      category: 'fr1-bases',
    },
    {
      id: 5,
      front: { icon: 'pen-tool', text: 'كيفاه نعرف على روحي بالفرنسية؟' },
      back: { title: 'Je m\'appelle... Je viens de... J\'ai ... ans', subtitle: 'Enchanté(e)! = متشرف!', detail: 'Comment vous appelez-vous? (واش اسمك). D\'où venez-vous? (منين أنت). Je viens d\'Algérie (من الجزائر). Je suis étudiant (طالب)' },
      category: 'fr1-bases',
    },

    // === Day 2: Daily Life (5 cards) ===
    {
      id: 6,
      front: { icon: 'calendar', text: 'واش هي أيام الأسبوع بالفرنسية؟' },
      back: { title: 'Lundi → Dimanche', subtitle: 'تبدا بحرف صغير! Le week-end = السبت والأحد', detail: 'Lundi (الاثنين)، Mardi (الثلاثاء)، Mercredi (الأربعاء)، Jeudi (الخميس)، Vendredi (الجمعة)، Samedi، Dimanche' },
      category: 'fr2-quotidien',
    },
    {
      id: 7,
      front: { icon: 'globe-2', text: 'كيفاه نحكيو على الطقس بالفرنسية؟' },
      back: { title: 'Quel temps fait-il? = كيفاه الجو؟', subtitle: 'Il fait + صفة (أغلب الأحيان)', detail: 'Il fait beau (مزيان)، Il fait chaud (سخون)، Il fait froid (بارد)، Il pleut (يشتي)، Il neige (يثلج)، Il y a du vent (ريح)' },
      category: 'fr2-quotidien',
    },
    {
      id: 8,
      front: { icon: 'package', text: 'واش هي كلمات الأكل الأساسية بالفرنسية؟' },
      back: { title: 'Le pain, La viande, Le poulet, Le poisson', subtitle: 'الوجبات: Petit déjeuner, Déjeuner, Dîner', detail: 'Le fromage (فرماج)، Les pâtes (معكرونة)، Le riz (روز)، Les légumes (خضرة)، Les fruits (فواكه)، L\'eau (ماء)' },
      category: 'fr2-quotidien',
    },
    {
      id: 9,
      front: { icon: 'trending-up', text: 'واش هي أفعال الروتين اليومي بالفرنسية؟' },
      back: { title: 'Se réveiller, Se lever, Travailler, Dormir', subtitle: 'الأفعال الانعكاسية: Je me réveille, Je me lève', detail: 'Je me réveille à 7h (نفيق). Je prends une douche (ندوش). Je vais au travail (نروح للخدمة). Je me couche (نرقد)' },
      category: 'fr2-quotidien',
    },
    {
      id: 10,
      front: { icon: 'bar-chart-3', text: 'كيفاه نقولو الوقت بالفرنسية؟' },
      back: { title: 'Il est + الساعة + heures', subtitle: 'Midi (الظهر) | Minuit (نص الليل)', detail: 'Il est 8 heures (الساعة 8). Il est midi (الظهر). Il est 14h30 (2 ونص). Et quart (والربع). Et demie (والنص). Moins le quart (إلا الربع)' },
      category: 'fr2-quotidien',
    },

    // === Day 3: People & Relationships (4 cards) ===
    {
      id: 11,
      front: { icon: 'heart-pulse', text: 'واش هي كلمات العائلة بالفرنسية؟' },
      back: { title: 'Le père, La mère, Le frère, La sœur', subtitle: 'Le grand-père (جد)، L\'oncle (عم/خال)، Le cousin', detail: 'Le fils (الولد)، La fille (البنت)، Le mari (الراجل)، La femme (المرا)، Les parents (الوالدين)، La famille (العايلة)' },
      category: 'fr3-gens',
    },
    {
      id: 12,
      front: { icon: 'building', text: 'كيفاه نقولو المهنة بالفرنسية؟' },
      back: { title: 'Je suis + مهنة (بدون أداة تعريف!)', subtitle: 'المهن تتغير حسب الجنس: -eur/-euse، -ien/-ienne', detail: 'Médecin (طبيب)، Professeur (أستاذ)، Ingénieur (مهندس)، Avocat (محامي)، Cuisinier/ère (طباخ)، Infirmier/ère (ممرض)' },
      category: 'fr3-gens',
    },
    {
      id: 13,
      front: { icon: 'users', text: 'كيفاه نوصف الصفات والمشاعر بالفرنسية؟' },
      back: { title: 'Grand/Petit, Beau/Belle, Content/Triste', subtitle: 'الصفة تتغير حسب الجنس: -e للمؤنث', detail: 'Grand/Grande (كبير). Content/Contente (فرحان). Fatigué/Fatiguée (عيان). Intelligent/e (ذكي). Gentil/le (لطيف)' },
      category: 'fr3-gens',
    },
    {
      id: 14,
      front: { icon: 'shield-check', text: 'كيفاه نستعملو ضمائر الملكية بالفرنسية؟' },
      back: { title: 'Mon/Ma/Mes, Ton/Ta/Tes, Son/Sa/Ses', subtitle: 'تتغير حسب الجنس والعدد تاع الشيء المملوك!', detail: 'Mon père (بابا)، Ma mère (ماما)، Mes frères (خاوتي). Notre maison (دارنا). Votre voiture (طوموبيلتكم). Leur fils (ولدهم)' },
      category: 'fr3-gens',
    },

    // === Day 4: Places & Directions (4 cards) ===
    {
      id: 15,
      front: { icon: 'compass', text: 'واش هي أهم الأماكن في المدينة بالفرنسية؟' },
      back: { title: 'La gare, L\'aéroport, Le restaurant, L\'hôpital', subtitle: 'La pharmacie, La banque, Le supermarché', detail: 'La rue (الزنقة)، La place (الساحة)، Le musée (المتحف)، Le cinéma، L\'église (الكنيسة)، La mosquée (الجامع)' },
      category: 'fr4-lieux',
    },
    {
      id: 16,
      front: { icon: 'target', text: 'كيفاه نسألو على الطريق ونعطيو الاتجاهات بالفرنسية؟' },
      back: { title: 'Où est...? / Comment aller à...?', subtitle: 'À droite (يمين)، À gauche (يسار)، Tout droit (نيشان)', detail: 'Excusez-moi, où est la gare? (وين المحطة؟). Tournez à droite (دور يمين). Continuez tout droit (مشي نيشان). C\'est près/loin (قريب/بعيد)' },
      category: 'fr4-lieux',
    },
    {
      id: 17,
      front: { icon: 'truck', text: 'واش هي وسائل النقل بالفرنسية؟' },
      back: { title: 'La voiture, Le bus, Le train, L\'avion', subtitle: 'En voiture (بالطوموبيل) | À pied (ماشي)', detail: 'Le taxi، Le vélo (بيسكليت)، La moto (موطور)، Le métro. Un billet, s\'il vous plaît (تذكرة عافاك)' },
      category: 'fr4-lieux',
    },
    {
      id: 18,
      front: { icon: 'coins', text: 'كيفاه نطلبو الأكل ونتسوقو بالفرنسية؟' },
      back: { title: 'Combien ça coûte? = بشحال هذا؟', subtitle: 'Je voudrais... (حاب...) | L\'addition, s\'il vous plaît (الحساب)', detail: 'C\'est trop cher (غالي بزاف). C\'est bon marché (رخيص). Je prends ça (ناخذ هذا). Puis-je payer par carte? (بالكارت؟)' },
      category: 'fr4-lieux',
    },

    // === Day 5: Shopping & Verbs (4 cards) ===
    {
      id: 19,
      front: { icon: 'palette', text: 'واش هي الألوان بالفرنسية؟' },
      back: { title: 'Rouge, Bleu, Vert, Jaune, Noir, Blanc', subtitle: 'تتغير حسب الجنس: Bleu/Bleue، Vert/Verte', detail: 'Orange (برتقالي)، Marron (بني)، Rose (وردي)، Gris/Grise (رمادي)، Violet/Violette (بنفسجي)' },
      category: 'fr5-achats',
    },
    {
      id: 20,
      front: { icon: 'rocket', text: 'كيفاه نصرفو الأفعال المنتظمة في المضارع الفرنسي؟' },
      back: { title: '3 مجموعات: -ER، -IR، -RE', subtitle: 'Parler: parle, parles, parle, parlons, parlez, parlent', detail: '-ER (parler): -e, -es, -e, -ons, -ez, -ent. -IR (finir): -is, -is, -it, -issons, -issez, -issent. أكثر من 80% أفعال -ER!' },
      category: 'fr5-achats',
    },
    {
      id: 21,
      front: { icon: 'file-text', text: 'واش هي أهم الأفعال الشاذة بالفرنسية؟' },
      back: { title: 'Aller (يروح)، Faire (يدير)، Vouloir (يحب)، Pouvoir (يقدر)', subtitle: 'Je vais, Je fais, Je veux, Je peux', detail: 'Je vais au travail (نروح للخدمة). Je fais du sport (ندير الرياضة). Je veux manger (حاب ناكل). Je ne peux pas (ما نقدرش)' },
      category: 'fr5-achats',
    },
    {
      id: 22,
      front: { icon: 'trending-up', text: 'كيفاه نعبرو على المستقبل القريب بالفرنسية؟' },
      back: { title: 'Aller (مصرّف) + فعل مصدر', subtitle: 'Je vais manger = راح ناكل', detail: 'Je vais travailler (راح نخدم). Tu vas dormir (راح ترقد). Il va pleuvoir (راح تشتي). Nous allons voyager (راح نسافرو)' },
      category: 'fr5-achats',
    },

    // === Day 6: Communication (4 cards) ===
    {
      id: 23,
      front: { icon: 'smartphone', text: 'كيفاه نهدرو في التليفون بالفرنسية؟' },
      back: { title: 'Allô? = آلو؟', subtitle: 'Un moment, s\'il vous plaît = شوية عافاك', detail: 'Qui est à l\'appareil? (شكون يهدر). Est-ce que Pierre est là? (واش بيار موجود). Il n\'est pas là (مش موجود). Je rappelle plus tard (نعيط من بعد)' },
      category: 'fr6-comm',
    },
    {
      id: 24,
      front: { icon: 'users', text: 'واش الفرق بين Tu و Vous بالفرنسية؟' },
      back: { title: 'Tu = صحاب وعائلة | Vous = أدب واحترام + جمع', subtitle: 'كي ماتكونش متأكد، استعمل Vous!', detail: 'Tu es (أنت راك - صاحبك). Vous êtes (حضرتك - رسمي). Comment vas-tu? (Tu). Comment allez-vous? (Vous). Vous = الجمع دايماً' },
      category: 'fr6-comm',
    },
    {
      id: 25,
      front: { icon: 'megaphone', text: 'واش هي التعابير اليومية الأكثر استعمالاً بالفرنسية؟' },
      back: { title: 'D\'accord! Bien sûr! Pas de problème!', subtitle: 'تعابير ضرورية للحياة اليومية', detail: 'Peut-être (يمكن). Je ne sais pas (مانعرفش). Je ne comprends pas (مافهمتش). Répétez SVP (عاود من فضلك). Pas du tout (والو)' },
      category: 'fr6-comm',
    },
    {
      id: 26,
      front: { icon: 'shield-check', text: 'واش هي جمل الطوارئ بالفرنسية؟' },
      back: { title: 'Au secours! (النجدة) | Appelez un médecin!', subtitle: 'رقم الطوارئ في فرنسا: 112 / 15 (SAMU)', detail: 'Attention! (ردّ بالك). Police! (البوليس). Je suis perdu(e) (أنا تايه). Appelez une ambulance! (عيطو للإسعاف). Au feu! (العافية!)' },
      category: 'fr6-comm',
    },

    // === Day 7: Culture & Review (4 cards) ===
    {
      id: 27,
      front: { icon: 'globe', text: 'علاه الفرنسية مهمة بزاف في الجزائر؟' },
      back: { title: 'لغة الخدمة، الدراسة، والحياة اليومية', subtitle: 'الجزائر ثاني أكبر بلد فرنكوفوني في العالم!', detail: 'مستعملة في الإدارة والتعليم العالي والأعمال. بزاف كلمات دارجة من الفرنسية: طوموبيل، فرماج، لاديسيون...' },
      category: 'fr7-culture',
    },
    {
      id: 28,
      front: { icon: 'search', text: 'واش هي كلمات الأسئلة الأساسية بالفرنسية؟' },
      back: { title: 'Qui? Quoi? Où? Quand? Pourquoi? Comment?', subtitle: 'Combien? (شحال) | Quel/Quelle? (أشمن)', detail: 'Qui est-ce? (شكون). Qu\'est-ce que c\'est? (واش هذا). Où est...? (وين). Quand? (وقتاش). Pourquoi? (علاش). Comment? (كيفاش)' },
      category: 'fr7-culture',
    },
    {
      id: 29,
      front: { icon: 'file-text', text: 'كيفاه ننفيو بالفرنسية؟' },
      back: { title: 'Ne ... pas حول الفعل = النفي', subtitle: 'Je ne parle pas = ما نهدرش', detail: 'Je ne sais pas (مانعرفش). Je n\'ai pas faim (ماني جيعان). Il ne travaille pas (ما يخدمش). Ne + فعل + pas = سندويتش النفي!' },
      category: 'fr7-culture',
    },
    {
      id: 30,
      front: { icon: 'compass', text: 'واش هي التعابير والأمثال الفرنسية الشهيرة؟' },
      back: { title: 'Bon courage! = بالتوفيق!', subtitle: 'C\'est la vie! = هذي هي الحياة!', detail: 'La pratique rend parfait (التمرين يصنع الكمال). Petit à petit l\'oiseau fait son nid (شوية بشوية). Bonne chance! (حظ سعيد!)' },
      category: 'fr7-culture',
    },
  ],

  // Course ID 16: علم ابني الألوان
  16: [
    // === 10 Basic Colors (10 cards) ===
    {
      id: 1,
      front: { emoji: '🔴', text: 'واش هو اللون الأحمر بالدارجة؟' },
      back: { title: 'الحمر!', subtitle: 'Red | Rouge', detail: '🍎 التفاحة حمرا، 🌹 الوردة حمرا، ❤️ القلب أحمر، 🔥 لون النار والحب!' },
      category: 'basic-colors',
    },
    {
      id: 2,
      front: { emoji: '🔵', text: 'واش هو اللون الأزرق بالدارجة؟' },
      back: { title: 'الأزرق / الزرقة!', subtitle: 'Blue | Bleu', detail: '🌊 البحر أزرق، ☁️ السما زرقا، 🐳 الحوت أزرق. لون هادي يريح العين!' },
      category: 'basic-colors',
    },
    {
      id: 3,
      front: { emoji: '🟡', text: 'واش هو اللون الأصفر بالدارجة؟' },
      back: { title: 'الأصفر / الصفرة!', subtitle: 'Yellow | Jaune', detail: '☀️ الشمس صفرا، 🍋 الليمون أصفر، 🍌 الموز أصفر. لون مبهج يفرح القلب!' },
      category: 'basic-colors',
    },
    {
      id: 4,
      front: { emoji: '🟢', text: 'واش هو اللون الأخضر بالدارجة؟' },
      back: { title: 'الأخضر / الخضرة!', subtitle: 'Green | Vert', detail: '🌳 الشجرة خضرا، 🐸 الضفدع أخضر، 🍏 التفاحة خضرا. لون الطبيعة والأمل!' },
      category: 'basic-colors',
    },
    {
      id: 5,
      front: { emoji: '🟠', text: 'واش هو اللون البرتقالي بالدارجة؟' },
      back: { title: 'البرتقالي!', subtitle: 'Orange | Orange', detail: '🍊 البرتقال برتقالي، 🥕 الجزر برتقالي، 🦊 الثعلب برتقالي. لون دافئ!' },
      category: 'basic-colors',
    },
    {
      id: 6,
      front: { emoji: '🟣', text: 'واش هو اللون البنفسجي بالدارجة؟' },
      back: { title: 'البنفسجي / البنفسج!', subtitle: 'Purple | Violet', detail: '🍇 العنب بنفسجي، 🍆 الباذنجان بنفسجي، 👑 لون ملكي وراقي!' },
      category: 'basic-colors',
    },
    {
      id: 7,
      front: { emoji: '🌸', text: 'واش هو اللون الزهري بالدارجة؟' },
      back: { title: 'الزهري / الروز!', subtitle: 'Pink | Rose', detail: '🌸 الزهرة زهرية، 🦩 الفلامنجو زهري، 🩷 لون ناعم وجميل!' },
      category: 'basic-colors',
    },
    {
      id: 8,
      front: { emoji: '🟤', text: 'واش هو اللون البني بالدارجة؟' },
      back: { title: 'البني / القهوي!', subtitle: 'Brown | Marron', detail: '🐻 الدب بني، 🪵 الخشب بني، ☕ القهوة قهوية، 🍫 الشوكولاته. لون الأرض!' },
      category: 'basic-colors',
    },
    {
      id: 9,
      front: { emoji: '⚫', text: 'واش هو اللون الأسود بالدارجة؟' },
      back: { title: 'الأسود / الكحل!', subtitle: 'Black | Noir', detail: '🐈‍⬛ القط أسود، 🦇 الوطواط أسود، 🌙 لون الليل. لون أنيق وقوي!' },
      category: 'basic-colors',
    },
    {
      id: 10,
      front: { emoji: '⚪', text: 'واش هو اللون الأبيض بالدارجة؟' },
      back: { title: 'الأبيض / البيض!', subtitle: 'White | Blanc', detail: '☁️ الغيمة بيضا، 🐑 الخروف أبيض، ❄️ الثلج أبيض. لون النقاوة!' },
      category: 'basic-colors',
    },

    // === Color Mixing (8 cards) ===
    {
      id: 11,
      front: { emoji: '🎨', text: 'شنوا هوما الألوان الأساسية الثلاثة؟' },
      back: { title: '🔴 أحمر + 🔵 أزرق + 🟡 أصفر', subtitle: 'Primary Colors', detail: 'من هذي الثلاثة نقدرو نصنعو كل الألوان الأخرى!' },
      category: 'mixing',
    },
    {
      id: 12,
      front: { emoji: '🟣', text: '🔴 أحمر + 🔵 أزرق = ؟' },
      back: { title: '🟣 بنفسجي!', subtitle: 'Red + Blue = Purple', detail: '🍇 العنب بنفسجي، 🍆 الباذنجان بنفسجي. أحمر + أزرق = بنفسجي!' },
      category: 'mixing',
    },
    {
      id: 13,
      front: { emoji: '🟠', text: '🔴 أحمر + 🟡 أصفر = ؟' },
      back: { title: '🟠 برتقالي!', subtitle: 'Red + Yellow = Orange', detail: '🍊 البرتقال برتقالي، 🥕 الجزر برتقالي. أحمر + أصفر = برتقالي!' },
      category: 'mixing',
    },
    {
      id: 14,
      front: { emoji: '🟢', text: '🔵 أزرق + 🟡 أصفر = ؟' },
      back: { title: '🟢 أخضر!', subtitle: 'Blue + Yellow = Green', detail: '🌳 الشجرة خضرا، 🐸 الضفدع أخضر. أزرق + أصفر = أخضر!' },
      category: 'mixing',
    },
    {
      id: 15,
      front: { emoji: '🌸', text: '🔴 أحمر + ⚪ أبيض = ؟' },
      back: { title: '🌸 زهري!', subtitle: 'Red + White = Pink', detail: '🌸 الزهرة الزهرية، 🦩 الفلامنجو. أحمر + أبيض = زهري!' },
      category: 'mixing',
    },
    {
      id: 16,
      front: { emoji: '🟤', text: 'كيفاه نصنعو اللون البني؟' },
      back: { title: '🔴 أحمر + 🟢 أخضر = 🟤 بني!', subtitle: 'طرق متعددة لصنع البني', detail: 'كمان: 🟠 برتقالي + 🔵 أزرق = 🟤 بني. أو 🟡 أصفر + 🟣 بنفسجي = 🟤 بني' },
      category: 'mixing',
    },
    {
      id: 17,
      front: { emoji: '☀️', text: 'كيفاه نخلّيو اللون فاتح؟' },
      back: { title: 'نزيدو ⚪ أبيض!', subtitle: 'أي لون + أبيض = فاتح', detail: 'مثال: 🔴 أحمر + ⚪ أبيض = 🌸 زهري فاتح' },
      category: 'mixing',
    },
    {
      id: 18,
      front: { emoji: '🌑', text: 'كيفاه نخلّيو اللون غامق؟' },
      back: { title: 'نزيدو ⚫ أسود!', subtitle: 'أي لون + أسود = غامق', detail: 'مثال: 🔴 أحمر + ⚫ أسود = أحمر غامق 🟤' },
      category: 'mixing',
    },

    // === Colors in Nature & Food (4 cards) ===
    {
      id: 19,
      front: { emoji: '🌈', text: 'شحال من لون في قوس قزح؟' },
      back: { title: '7 ألوان!', subtitle: '🔴🟠🟡🟢🔵🟣 + نيلي', detail: 'أحمر، برتقالي، أصفر، أخضر، أزرق، بنفسجي، نيلي. يبان وين تطيح الشمس على الشتا!' },
      category: 'nature',
    },
    {
      id: 20,
      front: { emoji: '🌳', text: 'واش ألوان الطبيعة؟' },
      back: { title: 'الطبيعة مليئة بالألوان!', subtitle: '☀️ صفرا، ☁️ زرقا، 🌳 خضرا', detail: '🏔️ الجبل بني، 🌹 الوردة حمرا، 🌊 البحر أزرق، ❄️ الثلج أبيض' },
      category: 'nature',
    },
    {
      id: 21,
      front: { emoji: '🍎', text: 'واش ألوان الأكل؟' },
      back: { title: 'كل أكلة لها لونها!', subtitle: 'الأكل فيه كل الألوان', detail: '🍎 تفاح حمر، 🍊 برتقال برتقالي، 🍌 موز أصفر، 🍏 تفاح أخضر، 🍇 عنب بنفسجي، 🥛 حليب أبيض' },
      category: 'nature',
    },
    {
      id: 22,
      front: { emoji: '🌅', text: 'واش لون الغروب؟' },
      back: { title: 'برتقالي وأحمر وأصفر!', subtitle: 'ألوان دافئة', detail: '🌅 الغروب فيه خليط من الألوان الدافئة: أحمر + برتقالي + أصفر. مشهد زين بزاف!' },
      category: 'nature',
    },

    // === Warm & Cool + Feelings (4 cards) ===
    {
      id: 23,
      front: { emoji: '🔥', text: 'شنوا هوما الألوان الدافئة؟' },
      back: { title: '🔴 أحمر + 🟠 برتقالي + 🟡 أصفر', subtitle: 'Warm Colors', detail: 'تحسسنا بالدفء والطاقة! ☀️🔥 كيما الشمس والنار' },
      category: 'concepts',
    },
    {
      id: 24,
      front: { emoji: '❄️', text: 'شنوا هوما الألوان الباردة؟' },
      back: { title: '🔵 أزرق + 🟢 أخضر + 🟣 بنفسجي', subtitle: 'Cool Colors', detail: 'تحسسنا بالبرودة والهدوء! 🌊❄️ كيما البحر والثلج' },
      category: 'concepts',
    },
    {
      id: 25,
      front: { emoji: '💭', text: 'كل لون يعطي شعور مختلف. واش يعني الأحمر؟' },
      back: { title: '❤️ حب وطاقة!', subtitle: 'كل لون عندو شعور', detail: '🔵 هدوء وسلام، 🟡 فرح وسعادة، 🟢 طبيعة وأمل، 🟣 ملكي وسحري، 🌸 حنان ولطف' },
      category: 'concepts',
    },
    {
      id: 26,
      front: { emoji: '🎨', text: 'واش الفرق بين الألوان الأساسية والثانوية؟' },
      back: { title: 'الأساسية ما تنخلطش!', subtitle: '3 أساسية → 3 ثانوية', detail: 'أساسية: 🔴🔵🟡 (ما تجيش من خلط). ثانوية: 🟣🟠🟢 (تجي من خلط لونين أساسيين)' },
      category: 'concepts',
    },

    // === Games & Patterns (4 cards) ===
    {
      id: 27,
      front: { emoji: '🤔', text: 'أنا لون النار والحب ❤️. شكون أنا؟' },
      back: { title: '🔴 الأحمر!', subtitle: 'لون النار 🔥 والقلب ❤️', detail: '🍎 التفاحة حمرا، 🌹 الوردة حمرا، 🍓 الفريز أحمر' },
      category: 'games',
    },
    {
      id: 28,
      front: { emoji: '🤔', text: 'أنا لون السما والبحر 🌊. شكون أنا؟' },
      back: { title: '🔵 الأزرق!', subtitle: 'لون السما ☁️ والبحر 🌊', detail: '🦋 الفراشة زرقا، 🐳 الحوت أزرق، 💙 القلب أزرق' },
      category: 'games',
    },
    {
      id: 29,
      front: { emoji: '🎨', text: 'أكمل النمط: 🔴 🔵 🔴 🔵 🔴 ___' },
      back: { title: '🔵 أزرق!', subtitle: 'النمط: أحمر، أزرق، أحمر، أزرق...', detail: 'الأنماط تتكرر دايماً! لقى النمط وأكمل اللون الناقص! 🔄' },
      category: 'games',
    },
    {
      id: 30,
      front: { emoji: '🎵', text: 'غني أغنية الألوان!' },
      back: { title: '🎶 الأحمر كيف التفاحة!', subtitle: 'الأزرق كيف البحر، الأصفر كيف الشمس', detail: '🟢 الأخضر كيف الشجرة، 🟠 البرتقالي كيف البرتقالة، 🌈 كل الألوان زينة، نحبهم كل واحد!' },
      category: 'games',
    },
  ],

  // Course ID 17: علم ابني الحروف العربية
  17: [
    // === Letters أ - خ (7 cards) ===
    {
      id: 1,
      front: { emoji: '🍎', text: 'واش هو أول حرف في الأبجدية العربية؟' },
      back: { title: 'أ - ألف!', subtitle: 'أول حرف! شكلو خط مستقيم |', detail: '🍎 تفاحة، 🦁 أسد، 🐰 أرنب، 👂 أذن (ودن). الألف سهل!' },
      category: 'letters-1',
    },
    {
      id: 2,
      front: { emoji: '🦆', text: 'حرف ب فيه نقطة وين؟' },
      back: { title: 'ب - نقطة واحدة تحت!', subtitle: 'باء = B sound', detail: '🦆 بطة، 🏠 بيت (دار)، 🌊 بحر، 🚪 باب، 🎈 بالون' },
      category: 'letters-1',
    },
    {
      id: 3,
      front: { emoji: '🍅', text: 'واش الفرق بين ب و ت و ث؟' },
      back: { title: 'النقاط برك!', subtitle: 'ب = نقطة تحت، ت = نقطتين فوق، ث = 3 نقاط فوق', detail: 'نفس الشكل، النقاط هي اللي تفرّق بيناتهم! 🍅 تمساح، 🐍 ثعبان' },
      category: 'letters-1',
    },
    {
      id: 4,
      front: { emoji: '🐪', text: 'واش الفرق بين ج و ح و خ؟' },
      back: { title: 'النقاط برك!', subtitle: 'ج = نقطة وسط، ح = بلا نقاط، خ = نقطة فوق', detail: '🐪 جمل، 🐴 حصان (عود)، 🥒 خيار (فقوس). نفس الشكل!' },
      category: 'letters-1',
    },
    {
      id: 5,
      front: { emoji: '🐻', text: 'واش الفرق بين د و ذ؟' },
      back: { title: 'ذ عندها نقطة فوق!', subtitle: 'د = بلا نقاط، ذ = نقطة فوق', detail: '🐻 دب، 🏠 دار. 🐺 ذئب (ذيب)، 🏆 ذهب (الدهب). ما يتصلوش مع اللي بعدهم!' },
      category: 'letters-1',
    },
    {
      id: 6,
      front: { emoji: '👨', text: 'واش الفرق بين ر و ز؟' },
      back: { title: 'ز عندها نقطة فوق!', subtitle: 'ر = بلا نقاط، ز = نقطة فوق', detail: '👨 راجل، 🍚 روز. 🌸 زهرة (وردة)، 🫒 زيتون. ما يتصلوش مع اللي بعدهم!' },
      category: 'letters-1',
    },
    {
      id: 7,
      front: { emoji: '🚗', text: 'واش الفرق بين س و ش؟' },
      back: { title: 'ش عندها 3 نقاط فوق!', subtitle: 'س = بلا نقاط (3 أسنان)، ش = 3 نقاط فوق', detail: '🚗 سيارة (طوموبيل)، 🐟 سمك (حوت). ☀️ شمس، 🌳 شجرة' },
      category: 'letters-1',
    },

    // === Letters ص - غ (6 cards) ===
    {
      id: 8,
      front: { emoji: '🦅', text: 'واش الفرق بين ص و ض؟' },
      back: { title: 'ض عندها نقطة فوق!', subtitle: 'ص = بلا نقاط (دائرة)، ض = نقطة فوق', detail: '🦅 صقر، 🧼 صابون. 🐸 ضفدع (جرانة)، 💡 ضوء' },
      category: 'letters-2',
    },
    {
      id: 9,
      front: { emoji: '🦆', text: 'واش الفرق بين ط و ظ؟' },
      back: { title: 'ظ عندها نقطة فوق!', subtitle: 'ط = بلا نقاط (دائري)، ظ = نقطة فوق', detail: '🦆 طير، 🪑 طاولة (طابلة)، 👶 طفل. 💅 ظفر، 🌳 ظل' },
      category: 'letters-2',
    },
    {
      id: 10,
      front: { emoji: '👁️', text: 'واش الفرق بين ع و غ؟' },
      back: { title: 'غ عندها نقطة فوق!', subtitle: 'ع = بلا نقاط، غ = نقطة فوق', detail: '👁️ عين، 🍇 عنب، 🍯 عسل. 🌳 غابة، 🦌 غزال، 🐦‍⬛ غراب' },
      category: 'letters-2',
    },
    {
      id: 11,
      front: { emoji: '🐭', text: 'واش الفرق بين ف و ق؟' },
      back: { title: 'النقاط!', subtitle: 'ف = نقطة واحدة فوق، ق = نقطتين فوق', detail: '🐭 فأر (فار)، 🐘 فيل، 🦋 فراشة. 🐈 قط، 🌙 قمر، ✏️ قلم (ستيلو)' },
      category: 'letters-2',
    },
    {
      id: 12,
      front: { emoji: '📖', text: 'حرف ك كيفاه نعرفوه؟' },
      back: { title: 'ك - كاف! شكل مميز', subtitle: 'K sound', detail: '📖 كتاب، 🐕 كلب، ⚽ كرة (كورة)، 🪑 كرسي، 📏 كبير' },
      category: 'letters-2',
    },
    {
      id: 13,
      front: { emoji: '🦁', text: 'حرف ل كيفاه نعرفوه؟' },
      back: { title: 'ل - لام! حرف طويل', subtitle: 'L sound', detail: '🦁 أسد (سبع)، 🍋 ليمون، 🥛 لبن (حليب)، 🎨 لون، 🌙 ليل' },
      category: 'letters-2',
    },

    // === Letters م - ي (7 cards) ===
    {
      id: 14,
      front: { emoji: '💧', text: 'حرف م كيفاه نعرفوه؟' },
      back: { title: 'م - ميم! شكلو دائري', subtitle: 'M sound', detail: '💧 ماء (الما)، 🍌 موز، 🏫 مدرسة، 🔑 مفتاح (سارو)، 👩 ماما (يما)' },
      category: 'letters-3',
    },
    {
      id: 15,
      front: { emoji: '🔥', text: 'حرف ن كيفاه نعرفوه؟' },
      back: { title: 'ن - نون! دائري + نقطة فوق', subtitle: 'N sound', detail: '🔥 نار، 🐝 نحلة، ⭐ نجمة، 🐯 نمر، 🐜 نملة' },
      category: 'letters-3',
    },
    {
      id: 16,
      front: { emoji: '🎁', text: 'حرف ه كيفاه نعرفوه؟' },
      back: { title: 'ه - هاء! شكل مميز', subtitle: 'H sound', detail: '🎁 هدية (كادو)، 🌙 هلال، 💨 هواء (الهوا)، 📱 هاتف (بورطابل)' },
      category: 'letters-3',
    },
    {
      id: 17,
      front: { emoji: '🌹', text: 'حرف و كيفاه نعرفوه؟' },
      back: { title: 'و - واو! صغير وما يتصلش', subtitle: 'W sound', detail: '🌹 وردة، 👦 ولد، 😊 وجه، 📄 ورقة. ما يتصلش مع الحرف اللي بعده!' },
      category: 'letters-3',
    },
    {
      id: 18,
      front: { emoji: '✋', text: 'واش هو آخر حرف في الأبجدية؟' },
      back: { title: 'ي - ياء! نقطتين تحت', subtitle: 'Y sound - آخر حرف!', detail: '✋ يد، 📅 يوم (نهار)، 👉 يمين، 🌺 ياسمين. مبروك كملت الحروف!' },
      category: 'letters-3',
    },
    {
      id: 19,
      front: { emoji: '🔢', text: 'شحال من حرف في الأبجدية العربية؟' },
      back: { title: '28 حرف!', subtitle: 'من أ (ألف) لـ ي (ياء)', detail: 'أ ب ت ث ج ح خ د ذ ر ز س ش ص ض ط ظ ع غ ف ق ك ل م ن ه و ي' },
      category: 'letters-3',
    },
    {
      id: 20,
      front: { emoji: '🎵', text: 'غني أغنية الحروف!' },
      back: { title: '🎶 أ ب ت ث، ج ح خ!', subtitle: 'د ذ ر ز، س ش ص ض!', detail: 'ط ظ ع غ، ف ق ك ل م ن، ه و ي! 🎉 كملنا الحروف!' },
      category: 'letters-3',
    },

    // === Letter Families & Dot Patterns (5 cards) ===
    {
      id: 21,
      front: { emoji: '📝', text: 'كم عائلة حروف متشابهة في الشكل؟' },
      back: { title: '7 عائلات رئيسية!', subtitle: 'النقاط هي اللي تفرّق بيناتهم', detail: 'ب/ت/ث | ج/ح/خ | د/ذ | ر/ز | س/ش | ص/ض | ط/ظ | ع/غ | ف/ق' },
      category: 'families',
    },
    {
      id: 22,
      front: { emoji: '⬇️', text: 'شنوا الحروف اللي ما تتصلش مع اللي بعدها؟' },
      back: { title: '6 حروف!', subtitle: 'أ - د - ذ - ر - ز - و', detail: 'هذي الحروف دايماً تبقى منفصلة على يسارها. مثال: دار (الدال منفصل)' },
      category: 'families',
    },
    {
      id: 23,
      front: { emoji: '🔵', text: 'شنوا الحروف اللي عندها نقطة واحدة تحت؟' },
      back: { title: 'ب!', subtitle: 'نقطة واحدة تحت الحرف', detail: 'ب = باء. مثال: 🦆 بطة، 🏠 بيت. كمان ي عندها نقطتين تحت!' },
      category: 'families',
    },
    {
      id: 24,
      front: { emoji: '🔴', text: 'شنوا الحروف اللي عندها 3 نقاط فوق؟' },
      back: { title: 'ث و ش!', subtitle: 'ثلاث نقاط فوق الحرف', detail: 'ث = ثاء (🐍 ثعبان). ش = شين (☀️ شمس). تذكر: ث من عائلة ب/ت، ش من عائلة س' },
      category: 'families',
    },
    {
      id: 25,
      front: { emoji: '⭕', text: 'شنوا الحروف اللي شكلها دائري؟' },
      back: { title: 'ص/ض، ط/ظ، ف/ق، م، ن، ه', subtitle: 'فيهم دوائر أو أجزاء دائرية', detail: 'كل واحد عندو شكل مميز. ص = دائرة كبيرة. م = دائرة صغيرة. ف = دائرة + نقطة' },
      category: 'families',
    },

    // === Word Building & Concepts (5 cards) ===
    {
      id: 26,
      front: { emoji: '🧩', text: 'ركّب كلمة "باب" من الحروف!' },
      back: { title: 'ب + ا + ب = باب! 🚪', subtitle: '3 حروف بسيطة', detail: 'كل كلمة عربية مركبة من حروف. نقراها من اليمين لليسار ←' },
      category: 'words',
    },
    {
      id: 27,
      front: { emoji: '👩', text: 'ركّب كلمة "ماما" من الحروف!' },
      back: { title: 'م + ا + م + ا = ماما! 👩', subtitle: '4 حروف', detail: 'كمان: 👨 بابا = ب + ا + ب + ا. 🏠 دار = د + ا + ر' },
      category: 'words',
    },
    {
      id: 28,
      front: { emoji: '📖', text: 'ركّب كلمة "كتاب" من الحروف!' },
      back: { title: 'ك + ت + ا + ب = كتاب! 📖', subtitle: '4 حروف', detail: 'كمان: ✏️ قلم = ق + ل + م. 💧 ماء = م + ا + ء' },
      category: 'words',
    },
    {
      id: 29,
      front: { emoji: '↩️', text: 'العربية نقراوها من أنا جهة؟' },
      back: { title: 'من اليمين لليسار! ←', subtitle: 'عكس الإنجليزية والفرنسية', detail: 'نبداو من اليمين → ونروحو لليسار ←. مثال: ب ا ب = باب' },
      category: 'words',
    },
    {
      id: 30,
      front: { emoji: '🏆', text: 'كل حرف عربي عندو كم شكل؟' },
      back: { title: 'حتى 4 أشكال!', subtitle: 'بداية، وسط، نهاية، منفصل', detail: 'مثال حرف ب: بَـ (بداية)، ـبـ (وسط)، ـب (نهاية)، ب (منفصل). الشكل يتغير حسب المكان!' },
      category: 'words',
    },
  ],

  // Course ID 23: العقيدة الإسلامية ببساطة
  23: [
    // === Ch1: Tawheed (5 cards) ===
    {
      id: 1,
      front: { icon: 'crown', text: 'التوحيد عندو 3 أنواع. واش هوما؟' },
      back: { title: 'ربوبية + ألوهية + أسماء وصفات', subtitle: 'وأهمهم توحيد الألوهية', detail: 'الربوبية: الله الخالق الرازق. الألوهية: الله وحده يستاهل العبادة. الأسماء والصفات: نثبتها كما جاءت بلا تشبيه ولا تعطيل' },
      category: 'ch1-tawheed',
    },
    {
      id: 2,
      front: { icon: 'key', text: '"لا إله إلا الله" عندها 7 شروط. واش هوما؟' },
      back: { title: 'العلم، اليقين، القبول، الانقياد، الصدق، الإخلاص، المحبة', subtitle: 'ما يكفيش تقولها بلسانك وخلاص!', detail: 'المنافقين كانو يقولوها بلسانهم بصح ما تحققتش فيهم الشروط. "يقولون بألسنتهم ما ليس في قلوبهم"' },
      category: 'ch1-tawheed',
    },
    {
      id: 3,
      front: { icon: 'scan-eye', text: 'الإمام مالك سألوه عن الاستواء. واش قال؟' },
      back: { title: '"الاستواء معلوم، والكيف مجهول، والإيمان به واجب"', subtitle: 'القاعدة الذهبية في صفات الله', detail: '﴿ليس كمثله شيء وهو السميع البصير﴾ = تنزيه (ما يشبهش حد) + إثبات (عنده صفات حقيقية). نثبت بلا تمثيل ونُنزّه بلا تعطيل' },
      category: 'ch1-tawheed',
    },
    {
      id: 4,
      front: { icon: 'brain', text: 'كيفاش نعرفو إن الله موجود؟ اذكر 3 أدلة' },
      back: { title: 'الفطرة + العقل + التصميم والإتقان', subtitle: '﴿أم خُلقوا من غير شيء أم هم الخالقون﴾', detail: 'الفطرة: الطفل كي يخاف يقول "يا ربي" بلا ما يعلّمه حد. العقل: كل حاجة لازم عندها صانع. التصميم: الثوابت الكونية مضبوطة بدقة مذهلة' },
      category: 'ch1-tawheed',
    },
    {
      id: 5,
      front: { icon: 'shield', text: 'التوحيد كيفاش يأثّر على حياتك اليومية؟' },
      back: { title: '6 ثمرات عملية:', subtitle: 'التوحيد يغيّرلك حياتك كاملة', detail: '1. الأمن والطمأنينة. 2. العزة (ما تذلّش لمخلوق). 3. التوكل الحقيقي. 4. التحرر من الخرافات. 5. الإخلاص في العمل. 6. الشجاعة (ما تخافش الموت)' },
      category: 'ch1-tawheed',
    },

    // === Ch2: Shirk & Kufr (4 cards) ===
    {
      id: 6,
      front: { icon: 'alert-octagon', text: 'واش هو الذنب الوحيد اللي الله ما يغفرش بلا توبة؟' },
      back: { title: 'الشرك!', subtitle: '﴿إن الله لا يغفر أن يُشرك به ويغفر ما دون ذلك لمن يشاء﴾', detail: 'الشرك نوعين: أكبر (يخرّجك من الإسلام) وأصغر (ذنب أعظم من الزنا وشرب الخمر). الشرك الأكبر: دعاء غير الله، الذبح لغير الله، الاستغاثة بالأموات' },
      category: 'ch2-shirk',
    },
    {
      id: 7,
      front: { icon: 'ban', text: 'واش هي أخطر الخرافات المنتشرة في الجزائر اللي تخالف العقيدة؟' },
      back: { title: '6 خرافات شائعة:', subtitle: 'كلها ما أنزل الله بها من سلطان', detail: '1. صلاح الدار/الذبح للجن. 2. التمائم والخيوط والخمسة. 3. الأبراج والشوّافة. 4. التشاؤم من صفر أو 13. 5. الدعاء عند الأضرحة. 6. سكب القهوة = حظ' },
      category: 'ch2-shirk',
    },
    {
      id: 8,
      front: { icon: 'eye-off', text: 'النفاق أنواع. واش الفرق بين النفاق الأكبر والأصغر؟' },
      back: { title: 'الأكبر = كفر يخرج من الملة. الأصغر = صفات سيئة', subtitle: 'حتى عمر بن الخطاب كان يخاف من النفاق!', detail: 'الأكبر: يُظهر الإيمان ويُبطن الكفر (الدرك الأسفل من النار). الأصغر: "آية المنافق 3: إذا حدّث كذب، إذا وعد أخلف، إذا اؤتمن خان"' },
      category: 'ch2-shirk',
    },
    {
      id: 9,
      front: { icon: 'shield-alert', text: 'واش هو دعاء الخوف من الشرك اللي حتى إبراهيم كان يقوله؟' },
      back: { title: '"اللهم إني أعوذ بك أن أشرك بك وأنا أعلم، وأستغفرك لما لا أعلم"', subtitle: 'رواه أحمد', detail: 'إبراهيم عليه السلام - أبو الأنبياء واللي حطّم الأصنام - كان يدعي: ﴿واجنبني وبنيّ أن نعبد الأصنام﴾. إذا هو خاف، فكيف بينا نحنا؟!' },
      category: 'ch2-shirk',
    },

    // === Ch3: Knowing Allah (3 cards) ===
    {
      id: 10,
      front: { icon: 'heart', text: 'ربي جعل الرحمة 100 جزء. شحال نزّل منها في الأرض؟' },
      back: { title: 'جزء واحد فقط!', subtitle: 'والـ99 جزء ادّخرهم ليوم القيامة', detail: 'كل الرحمة في الدنيا - رحمة الأم بولدها، رحمة الحيوانات بصغارها - من جزء واحد! والـ99 للمؤمنين يوم القيامة. متفق عليه' },
      category: 'ch3-allah',
    },
    {
      id: 11,
      front: { icon: 'book-heart', text: 'المسلم يعبد ربي بـ3 مشاعر مع بعض. واش هوما؟' },
      back: { title: 'المحبة + الرجاء + الخوف', subtitle: 'كالطير يطير بجناحين', detail: 'بالحب وحده = زنديق. بالخوف وحده = خارجي. بالرجاء وحده = مرجئ. بالثلاثة = مؤمن موحّد. المحبة تحرّكك، الرجاء يعطيك أمل، الخوف يمنعك من المعاصي' },
      category: 'ch3-allah',
    },
    {
      id: 12,
      front: { icon: 'hand-heart', text: 'التوسل المشروع والممنوع: واش الفرق؟' },
      back: { title: 'المشروع: بأسماء الله، بالعمل الصالح، بدعاء حي صالح', subtitle: 'الممنوع: بذات الأموات أو دعاؤهم', detail: '"يا سيدي فلان أغثني" = شرك أكبر! الدليل على التوسل بالعمل: قصة أصحاب الغار اللي توسّل كل واحد بعمل صالح ففرّج الله عنهم' },
      category: 'ch3-allah',
    },

    // === Ch4: Angels & Books (3 cards) ===
    {
      id: 13,
      front: { icon: 'sparkles', text: 'اذكر 5 ملائكة مع وظائفهم' },
      back: { title: 'جبريل، ميكائيل، إسرافيل، ملك الموت، الكرام الكاتبون', subtitle: 'خُلقت الملائكة من نور', detail: 'جبريل: الوحي. ميكائيل: المطر والرزق. إسرافيل: النفخ في الصور. ملك الموت: قبض الأرواح. الكرام الكاتبون: يمين (حسنات) وشمال (سيئات)' },
      category: 'ch4-angels',
    },
    {
      id: 14,
      front: { icon: 'book-open', text: 'واش يميّز القرآن عن باقي الكتب السماوية؟' },
      back: { title: '5 خصائص فريدة:', subtitle: '﴿إنا نحن نزّلنا الذكر وإنا له لحافظون﴾', detail: '1. محفوظ من التحريف. 2. معجز (ما قدر حد يجيب مثلو). 3. خاتم الكتب. 4. للبشرية كلها (مش لقوم واحد). 5. التوراة والإنجيل والزبور كلها محرّفة' },
      category: 'ch4-angels',
    },
    {
      id: 15,
      front: { icon: 'shield-check', text: 'واش هو "برنامج الحماية اليومي" من السحر والعين؟' },
      back: { title: '5 أوقات حماية:', subtitle: 'بلا تمائم ولا طلاسم - بالقرآن فقط', detail: 'الصباح: أذكار + معوّذات 3x. المساء: أذكار + آية الكرسي. النوم: آية الكرسي + معوّذات + نفث. الدار: سورة البقرة كل 3 أيام. الخروج: "بسم الله توكلت على الله"' },
      category: 'ch4-angels',
    },

    // === Ch5: Prophets (3 cards) ===
    {
      id: 16,
      front: { icon: 'users', text: 'كل الأنبياء من أولهم لآخرهم جابو نفس الرسالة. واش هي؟' },
      back: { title: '﴿اعبدوا الله ما لكم من إله غيره﴾', subtitle: 'نوح، هود، صالح، شعيب... نفس الكلمات بالحرف!', detail: 'الشرائع تختلف في التفاصيل (صلاة، صيام...) بصح الأصل واحد: لا إله إلا الله. ﴿وما أرسلنا من قبلك من رسول إلا نوحي إليه أنه لا إله إلا أنا فاعبدون﴾' },
      category: 'ch5-prophets',
    },
    {
      id: 17,
      front: { icon: 'star', text: 'محبة النبي ﷺ الحقيقية كيفاش تكون؟' },
      back: { title: 'الاتّباع لا الابتداع!', subtitle: '﴿قل إن كنتم تحبون الله فاتبعوني يحببكم الله﴾', detail: '5 علامات: 1. اتّباع سنته. 2. الصلاة عليه بكثرة. 3. الدفاع عنه بالعلم. 4. تعلّم سيرته. 5. حب أصحابه. والنبي ﷺ قال: "لا تُطروني كما أطرت النصارى ابن مريم"' },
      category: 'ch5-prophets',
    },
    {
      id: 18,
      front: { icon: 'award', text: 'واش هو ترتيب الخلفاء الراشدين في الأفضلية؟' },
      back: { title: 'أبو بكر → عمر → عثمان → علي', subtitle: 'رضي الله عنهم أجمعين', detail: 'أبو بكر: الصدّيق (أفضل الأمة). عمر: الفاروق. عثمان: ذو النورين. علي: أبو الحسنين. نحبّهم كاملين ولا نسب حد منهم. "لا تسبوا أصحابي" - متفق عليه' },
      category: 'ch5-prophets',
    },

    // === Ch6: Qadar (4 cards) ===
    {
      id: 19,
      front: { icon: 'layers', text: 'الإيمان بالقدر يقوم على 4 مراتب. واش هوما؟' },
      back: { title: 'العلم → الكتابة → المشيئة → الخلق', subtitle: 'اللي ينكر واحدة ما آمن بالقدر كامل', detail: 'العلم: ربي عالم بكل شيء. الكتابة: كل شيء مكتوب في اللوح المحفوظ. المشيئة: ما يصير شيء إلا بإرادة الله. الخلق: الله خالق كل شيء حتى أفعالنا' },
      category: 'ch6-qadar',
    },
    {
      id: 20,
      front: { icon: 'help-circle', text: '"إذا كل شيء مكتوب، علاش نخدمو؟" واش الجواب؟' },
      back: { title: '«اعملوا فكلٌّ ميسَّرٌ لما خُلق له»', subtitle: 'الأسباب جزء من القدر!', detail: 'أنت ما تعرفش واش مكتوبلك! ربي كي قدّر إنك تنجح، قدّر معاها إنك تقرا. كيما ما تقولش "مكتوبلي ناكل" وتقعد بلا ماكلة - نفس الشيء مع كل شيء' },
      category: 'ch6-qadar',
    },
    {
      id: 21,
      front: { icon: 'smile', text: '«عجباً لأمر المؤمن» - علاش المؤمن ديما رابح؟' },
      back: { title: 'في السرّاء يشكر = خير. في الضرّاء يصبر = خير!', subtitle: 'رواه مسلم', detail: 'وليس ذلك لأحد إلا للمؤمن. من ثمرات الإيمان بالقدر: طمأنينة، شجاعة، عدم يأس، عدم غرور، كرم، وتوكّل حقيقي' },
      category: 'ch6-qadar',
    },
    {
      id: 22,
      front: { icon: 'x-circle', text: 'النبي ﷺ نهى عن كلمة واحدة وقت المصيبة. واش هي؟' },
      back: { title: '"لو"!', subtitle: '«فإن لو تفتح عمل الشيطان» - رواه مسلم', detail: 'ما تقولش "لو درت هكذا لكان كذا". الصح: "قدر الله وما شاء فعل". ثم: خُذ بالأسباب وتوكّل، ودوّر على الخير في المصيبة' },
      category: 'ch6-qadar',
    },

    // === Ch7-8: Last Day + Jannah/Nar (5 cards) ===
    {
      id: 23,
      front: { icon: 'message-circle', text: 'في القبر يجيوك ملكين يسألوك 3 أسئلة. واش هوما؟' },
      back: { title: 'من ربك؟ ما دينك؟ من نبيك؟', subtitle: '﴿يُثبّت الله الذين آمنوا بالقول الثابت﴾', detail: 'المؤمن يجاوب: ربي الله، ديني الإسلام، نبيي محمد ﷺ. الكافر يتلعثم: "هاه هاه لا أدري". عيش على التوحيد باش تموت عليه!' },
      category: 'ch7-lastday',
    },
    {
      id: 24,
      front: { icon: 'umbrella', text: '7 أصناف يظلّهم الله يوم ما كاين ظل إلا ظله. اذكر 3 منهم' },
      back: { title: 'إمام عادل، شاب نشأ في العبادة، قلبه معلّق بالمساجد...', subtitle: 'متفق عليه', detail: '+ متحابان في الله، رفض الحرام رغم الإغراء، تصدّق بالسر، ذكر الله خالياً فبكى. يوم القيامة 50,000 سنة والشمس قريبة - هذول عندهم ظل!' },
      category: 'ch7-lastday',
    },
    {
      id: 25,
      front: { icon: 'door-open', text: 'الجنة عندها 8 أبواب. اذكر 4 منهم' },
      back: { title: 'باب الصلاة، الجهاد، الصدقة، الريّان (للصائمين)', subtitle: 'أبو بكر يُدعى من الأبواب كلها!', detail: '+ باب الحج، الكاظمين الغيظ، التوبة، الذكر. والنبي ﷺ قال: اسألو الله الفردوس الأعلى - أوسط الجنة وأعلاها وفوقه عرش الرحمن' },
      category: 'ch8-jannah',
    },
    {
      id: 26,
      front: { icon: 'eye', text: 'واش هي أعظم نعمة في الجنة؟ (مش القصور ولا الأنهار)' },
      back: { title: 'رؤية الله عز وجل!', subtitle: '﴿وجوهٌ يومئذٍ ناضرة • إلى ربها ناظرة﴾', detail: '"إنكم سترون ربكم كما ترون القمر ليلة البدر" - متفق عليه. ﴿للذين أحسنوا الحسنى وزيادة﴾ - النبي ﷺ فسّر "الزيادة" بالنظر لوجه الله الكريم' },
      category: 'ch8-jannah',
    },
    {
      id: 27,
      front: { icon: 'scale', text: 'واش هي الكلمتين الخفيفتين على اللسان الثقيلتين في الميزان؟' },
      back: { title: '"سبحان الله وبحمده، سبحان الله العظيم"', subtitle: 'حبيبتان إلى الرحمن - متفق عليه', detail: 'يوم القيامة الميزان حقيقي بكفتين. ﴿فمن يعمل مثقال ذرة خيراً يره • ومن يعمل مثقال ذرة شراً يره﴾. كل كلمة وكل فعل محسوب!' },
      category: 'ch7-lastday',
    },

    // === Ch9-10: Wasatiyyah + Conclusion (3 cards) ===
    {
      id: 28,
      front: { icon: 'compass', text: 'واش معنى "الوسطية" في الإسلام؟' },
      back: { title: 'لا إفراط ولا تفريط - لا تشدد ولا تساهل', subtitle: '﴿وكذلك جعلناكم أمة وسطاً﴾', detail: 'التشدد: يكفّر ويحرّم كل شيء. التساهل: يبيح كل شيء باسم "التجديد". الوسطية: تتبع الدليل بلا زيادة ولا نقصان. قصة الثلاثة اللي تشددوا والنبي ﷺ ردّ عليهم' },
      category: 'ch9-wasatiyyah',
    },
    {
      id: 29,
      front: { icon: 'alert-triangle', text: 'واش هي البدعة؟ وواش الفرق بينها وبين الاختراعات الحديثة؟' },
      back: { title: 'البدعة = حاجة جديدة في الدين ما كانتش عند النبي ﷺ', subtitle: '«كل محدثة بدعة وكل بدعة ضلالة»', detail: 'الموبايل والسيارة مش بدع (اختراعات دنيوية). البدعة: تزيد عبادة جديدة ما شرعها الله. القاعدة: كل عبادة لازم عندها دليل من القرآن أو السنة الصحيحة' },
      category: 'ch9-wasatiyyah',
    },
    {
      id: 30,
      front: { icon: 'list-checks', text: 'حديث جبريل قسّم الدين لـ3 مراتب. واش هوما؟' },
      back: { title: 'الإسلام + الإيمان + الإحسان', subtitle: 'رواه مسلم - سمّاه العلماء "أم السنة"', detail: 'الإسلام: الأعمال الظاهرة (الأركان الخمسة). الإيمان: الاعتقاد الباطن (أركان الإيمان الستة). الإحسان: أعلى المراتب "تعبد الله كأنك تراه"' },
      category: 'ch10-summary',
    },
  ],

  // Course ID 27: الطب النبوي
  27: [
    // === Ch1: Honey (5 cards) ===
    {
      id: 1,
      front: { icon: 'droplets', text: 'ربّي ذكر العسل في القرآن. واش قال بالضبط؟' },
      back: { title: '﴿يخرج من بطونها شراب مختلف ألوانه فيه شفاء للناس﴾', subtitle: 'سورة النحل: 68-69', detail: 'قال "شفاء للناس" مش "للمؤمنين" وحدهم - يعني الشفاء عام لكل البشر. والنبي ﷺ قال: "عليكم بالشفاءين: العسل والقرآن"' },
      category: 'ch1-honey',
    },
    {
      id: 2,
      front: { icon: 'flask-round', text: 'النبي ﷺ قال: "الشفاء في ثلاثة". واش هوما؟' },
      back: { title: 'شربة عسل + شرطة محجم + كية نار', subtitle: 'رواه البخاري (5681)', detail: 'العسل: مستحب. الحجامة: سنة مؤكدة. الكي: مكروه إلا للضرورة القصوى. النبي ﷺ ذكر العسل أولاً لمكانته الكبيرة' },
      category: 'ch1-honey',
    },
    {
      id: 3,
      front: { icon: 'thermometer', text: 'كيفاش تستعمل العسل للسعال والتهاب الحلق؟' },
      back: { title: 'ملعقة كبيرة عسل طبيعي قبل النوم', subtitle: 'أحسن من بزاف أدوية السعال الكيميائية!', detail: 'ممكن تخلطها مع ليمون وماء دافئ. دراسة بريطانية أثبتت أن العسل أحسن من الديكسترومثرفان (دواء السعال الشائع)' },
      category: 'ch1-honey',
    },
    {
      id: 4,
      front: { icon: 'alert-triangle', text: 'واش هي أهم تحذيرات استعمال العسل؟' },
      back: { title: '3 تحذيرات مهمة:', subtitle: '1. ما تعطيش العسل للأطفال أقل من سنة', detail: '2. ما تسخّنوش فوق 40 درجة (يقتل المواد الفعّالة). 3. مرضى السكري يستعملوه بكميات صغيرة مع متابعة الطبيب' },
      category: 'ch1-honey',
    },
    {
      id: 5,
      front: { icon: 'plus-circle', text: 'واش يصرا كي تخلط العسل مع الحبة السوداء؟' },
      back: { title: 'قوة مضاعفة!', subtitle: 'ملعقة عسل + ملعقة صغيرة حبة سوداء مطحونة على الريق', detail: 'تقوية المناعة، تحسين الكبد، حماية المعدة، تنظيم السكر والكوليسترول. دراسة 2025 أثبتت نتائج أحسن من كل واحد وحدو' },
      category: 'ch1-honey',
    },

    // === Ch2: Black Seed (5 cards) ===
    {
      id: 6,
      front: { icon: 'circle-dot', text: 'النبي ﷺ قال على الحبة السوداء "شفاء من كل داء إلا..." إلا واش؟' },
      back: { title: 'إلا السّام (الموت)!', subtitle: 'رواه البخاري (5688) ومسلم (2215)', detail: '"كل" هنا من باب العموم اللي يراد به الكثرة - يعني تنفع في أغلب الأمراض. المادة الفعّالة الرئيسية: الثيموكينون' },
      category: 'ch2-blackseed',
    },
    {
      id: 7,
      front: { icon: 'microscope', text: 'واش هي المادة الفعّالة الرئيسية في الحبة السوداء؟' },
      back: { title: 'الثيموكينون (Thymoquinone)', subtitle: '30-48% من زيت الحبة السوداء', detail: 'مضاد التهاب + مضاد أكسدة + يقوّي المناعة + يوقف نمو الخلايا السرطانية في المختبر. أكثر من 1000 دراسة علمية أثبتت فوائده' },
      category: 'ch2-blackseed',
    },
    {
      id: 8,
      front: { icon: 'list', text: 'كم طريقة عندك لاستعمال الحبة السوداء؟' },
      back: { title: '5 طرق مختلفة:', subtitle: 'حسب الحالة الصحية', detail: '1. مضغ 7 حبات وبلعها (المناعة). 2. مطحونة مع عسل (السعال). 3. زيت مع ماء دافئ (المعدة والكبد). 4. دهان خارجي (الجلد والشعر). 5. استنشاق بخارها (الزكام)' },
      category: 'ch2-blackseed',
    },
    {
      id: 9,
      front: { icon: 'scale', text: 'واش هي الجرعة اليومية الصحيحة للحبة السوداء؟' },
      back: { title: '2 غرام تقريباً (ملعقة صغيرة)', subtitle: 'لا تكثر!', detail: 'تحذيرات: ممنوعة بكميات كبيرة للحامل والمرضعة. ما تعوّضش أدويتك الطبية. ممكن تسبّب اضطرابات هضمية خفيفة عند بعض الناس' },
      category: 'ch2-blackseed',
    },
    {
      id: 10,
      front: { icon: 'heart-pulse', text: 'واش أثبتت الدراسات الحديثة على الحبة السوداء والقلب؟' },
      back: { title: 'تقليل الدهون بنسبة 40%!', subtitle: 'ورفع الكوليسترول الجيد', detail: 'كذلك: تحسين حساسية الأنسولين (السكري)، تنظيم المناعة، تأثير مضاد للالتهاب يشبه الأدوية الكيميائية. كل هذا من دراسات 2024-2025' },
      category: 'ch2-blackseed',
    },

    // === Ch3: Hijama/Cupping (4 cards) ===
    {
      id: 11,
      front: { icon: 'target', text: 'النبي ﷺ قال: "إن أمثل ما تداويتم به..." واش؟' },
      back: { title: 'الحجامة والقسط البحري!', subtitle: 'رواه البخاري (5696)', detail: '"أمثل" يعني الأفضل والأحسن. النبي ﷺ احتجم بنفسو عدة مرات وأعطى الحجّام أجرو. نوعان: رطبة (سحب دم) وجافة (شفط فقط)' },
      category: 'ch3-hijama',
    },
    {
      id: 12,
      front: { icon: 'moon', text: 'واش هي أفضل أيام الحجامة الوقائية؟' },
      back: { title: 'اليوم 17 و19 و21 من الشهر الهجري', subtitle: 'فترة اكتمال القمر (البدر)', detail: 'السبب العلمي: في فترة البدر يرتفع ضغط الدم وتزيد لزوجته بسبب جاذبية القمر، فالحجامة تكون أكثر فعالية. النبي ﷺ عرف هذا قبل 1400 سنة!' },
      category: 'ch3-hijama',
    },
    {
      id: 13,
      front: { icon: 'map-pin', text: 'واش هي مواضع الحجامة من السنة النبوية؟' },
      back: { title: '5 مواضع ثابتة بالأحاديث:', subtitle: 'الأخدعان، الكاهل، وسط الرأس، القفا، الظهر', detail: 'الأخدعان (جانبا العنق): للصداع. الكاهل (بين الكتفين): للضعف العام. وسط الرأس: للضغط. كذلك تتم حسب مكان الألم' },
      category: 'ch3-hijama',
    },
    {
      id: 14,
      front: { icon: 'shield-off', text: 'مين اللي ما يعملش الحجامة؟' },
      back: { title: '6 حالات ممنوعة:', subtitle: 'لازم تعرفهم قبل ما تروح', detail: '1. الحامل. 2. مرضى سيولة الدم. 3. فقر الدم الحاد. 4. أمراض جلدية معدية في مكان الحجامة. 5. الأطفال تحت 3 سنوات. 6. السرطان المتقدم (إلا بإذن الطبيب)' },
      category: 'ch3-hijama',
    },

    // === Ch4-5: Herbs & Eyes/Mouth (5 cards) ===
    {
      id: 15,
      front: { icon: 'olive', text: 'النبي ﷺ قال على زيت الزيتون "شجرة مباركة". واش فوائدو؟' },
      back: { title: '5 فوائد كبرى:', subtitle: '"ائتدموا بالزيت وادّهنوا به" - صححه الألباني', detail: '1. يحمي القلب والشرايين. 2. يعالج الإمساك. 3. يرطّب البشرة ويقوّي الشعر. 4. يحمي الخلايا العصبية والذاكرة. 5. فيه مركب مضاد للسرطان' },
      category: 'ch4-herbs',
    },
    {
      id: 16,
      front: { icon: 'calendar', text: 'النبي ﷺ قال: "من تصبّح كل يوم سبع تمرات عجوة..." واش يصرا؟' },
      back: { title: 'لم يضرّه في ذلك اليوم سمّ ولا سحر!', subtitle: 'رواه البخاري (5445) ومسلم (2047)', detail: 'التمر فيه: سكريات طبيعية (طاقة فورية)، ألياف (هضم)، بوتاسيوم (ضغط الدم)، حديد (أنيميا)، ماغنيزيوم (أعصاب)' },
      category: 'ch4-herbs',
    },
    {
      id: 17,
      front: { icon: 'soup', text: 'واش هي التلبينة وعلاش النبي ﷺ وصفها؟' },
      back: { title: '"مجمّة لفؤاد المريض تذهب ببعض الحزن"', subtitle: 'حساء شعير مطحون بنخالته مع ماء وعسل', detail: 'الشعير يحتوي على مركبات تؤثر على السيروتونين (هرمون السعادة). يعني التلبينة فعلاً تحسّن المزاج وتخفّف الاكتئاب - ثبت علمياً!' },
      category: 'ch4-herbs',
    },
    {
      id: 18,
      front: { icon: 'leaf', text: 'النبي ﷺ قال على القسط الهندي "فيه سبعة أشفية". كيفاش يتستعمل؟' },
      back: { title: '4 طرق:', subtitle: '"أمثل ما تداويتم به الحجامة والقسط البحري"', detail: '1. سعوط: مسحوق في زيت يقطّر في الأنف (الزكام). 2. شرب مع ماء (المناعة). 3. دهان بزيت الزيتون (الروماتيزم). 4. تبخير واستنشاق (الربو)' },
      category: 'ch4-herbs',
    },
    {
      id: 19,
      front: { icon: 'brush', text: 'واش فيه السواك اللي يخلّيه أحسن من الفرشاة؟' },
      back: { title: '6 مواد طبيعية فعّالة!', subtitle: '"مطهرة للفم مرضاة للرب" - رواه النسائي', detail: 'كبريت (مطهّر)، سنجرين (مضاد التهاب)، عفص (يقوّي اللثة)، زيوت عطرية (ريحة طيبة)، فلوريد طبيعي (ضد التسوس)، سيليكا (تبييض)' },
      category: 'ch5-eyes-mouth',
    },

    // === Ch6-7: Food & Sleep (4 cards) ===
    {
      id: 20,
      front: { icon: 'pie-chart', text: 'واش هي "قاعدة الأثلاث" اللي علّمها النبي ﷺ؟' },
      back: { title: 'ثلث طعام + ثلث شراب + ثلث نَفَس', subtitle: '"ما ملأ آدمي وعاءً شراً من بطن"', detail: 'الإسراف في الأكل سبب رئيسي للسمنة وتصلّب الشرايين والسكري وارتفاع الضغط. النبي ﷺ حطّ أساس التغذية الصحية قبل 1400 سنة!' },
      category: 'ch6-food',
    },
    {
      id: 21,
      front: { icon: 'glass-water', text: 'كيفاش كان النبي ﷺ يشرب الماء؟' },
      back: { title: 'على 3 دفعات مع التنفس بينهم!', subtitle: '"إنه أروى وأبرأ وأمرأ" - رواه مسلم', detail: 'سنن الشرب: جالساً، 3 دفعات، بسم الله، باليمين، عدم التنفس في الإناء. علمياً: يسمح بالامتصاص التدريجي ويحمي الكلى والقلب' },
      category: 'ch6-food',
    },
    {
      id: 22,
      front: { icon: 'bed', text: 'النبي ﷺ أمر بالنوم على الجنب الأيمن. واش الفوائد؟' },
      back: { title: '5 فوائد طبية مثبتة:', subtitle: '"اضطجع على شقّك الأيمن" - البخاري ومسلم', detail: '1. تحسين الهضم. 2. منع ارتجاع المريء. 3. راحة القلب. 4. تقليل الشخير. 5. تحسين الدورة الدموية. والنوم على البطن "ضجعة لا يحبها الله"' },
      category: 'ch7-sleep',
    },
    {
      id: 23,
      front: { icon: 'alarm-clock', text: 'واش هو روتين النبي ﷺ قبل النوم؟' },
      back: { title: '4 خطوات:', subtitle: 'يتوافق مع نصائح أطباء النوم اليوم!', detail: '1. الوضوء. 2. نفض الفراش (إزالة الحشرات). 3. قراءة الإخلاص والمعوذات 3 مرات + آية الكرسي. 4. النوم على الجنب الأيمن مع الأذكار' },
      category: 'ch7-sleep',
    },

    // === Ch8: Exercise & Fasting (4 cards) ===
    {
      id: 24,
      front: { icon: 'dumbbell', text: 'واش هي الرياضات اللي وصفها النبي ﷺ؟' },
      back: { title: '6 رياضات نبوية:', subtitle: '"المؤمن القوي خير وأحب إلى الله" - رواه مسلم', detail: 'السباحة، الرماية، ركوب الخيل، المشي (كان يمشي بسرعة)، المصارعة (صارع ركانة)، الجري (سابق عائشة). والصلوات الخمس = 200+ حركة يومياً!' },
      category: 'ch8-fasting',
    },
    {
      id: 25,
      front: { icon: 'utensils-crossed', text: 'واش أثبت العلم الحديث على فوائد الصيام؟' },
      back: { title: 'جائزة نوبل 2016 أثبتت "الأوتوفاجي"!', subtitle: '﴿وأن تصوموا خير لكم إن كنتم تعلمون﴾', detail: 'الجسم يتخلّص من الخلايا التالفة أثناء الصيام. كذلك: تقوية المناعة 10x، تحسين الأنسولين 22%، حرق الدهون، حماية المخ والقلب' },
      category: 'ch8-fasting',
    },
    {
      id: 26,
      front: { icon: 'repeat', text: 'صيام الاثنين والخميس = واش عند الغرب؟' },
      back: { title: 'نظام 5:2 الحديث بالضبط!', subtitle: 'النبي ﷺ وصفو قبل 1400 سنة', detail: 'الغرب يسمّوه "Intermittent Fasting 5:2" - 5 أيام أكل عادي و2 أيام صيام. يعتبروه من أنجح أنظمة الصيام المتقطع. والنبي ﷺ سبقهم!' },
      category: 'ch8-fasting',
    },

    // === Ch9: Spiritual Medicine (3 cards) ===
    {
      id: 27,
      front: { icon: 'book-open', text: 'واش هي خطوات الرقية الشرعية الصحيحة؟' },
      back: { title: '5 خطوات بسيطة - تقدر تديرها بنفسك:', subtitle: 'بلا ما تحتاج أي شخص آخر', detail: '1. توضأ واستقبل القبلة. 2. ضع يدك على رأسك أو مكان الألم. 3. اقرأ الفاتحة + آية الكرسي + آخر البقرة + المعوذات (3x). 4. انفث في كفيك وامسح. 5. ادعُ بالشفاء' },
      category: 'ch9-spiritual',
    },
    {
      id: 28,
      front: { icon: 'hand-heart', text: 'النبي ﷺ قال: "داووا مرضاكم بالصدقة". كيفاش الصدقة تشفي؟' },
      back: { title: '4 تأثيرات:', subtitle: 'حسّنه الألباني في صحيح الجامع', detail: '1. روحي: تزكّي النفس وتريّح القلب. 2. نفسي: تحفّز السيروتونين (هرمون السعادة). 3. صحي: 80% من الأمراض تتأثّر بالنفسية. 4. إلهي: تدفع البلاء بإذن الله' },
      category: 'ch9-spiritual',
    },
    {
      id: 29,
      front: { icon: 'shield-check', text: 'واش هو الذكر اللي يحميك من كل شيء طول اليوم؟' },
      back: { title: '"بسم الله الذي لا يضرّ مع اسمه شيء في الأرض ولا في السماء"', subtitle: '3 مرات صباحاً ومساءً', detail: 'من قالها 3 مرات صباحاً ومساءً "لم يضرّه شيء" - رواه أبو داود والترمذي. تأمين ربّاني مجاني!' },
      category: 'ch9-spiritual',
    },

    // === Ch6+10: Prevention & Summary (1 card) ===
    {
      id: 30,
      front: { icon: 'lock', text: 'النبي ﷺ وضع أسس الحجر الصحي قبل 1400 سنة. واش قال؟' },
      back: { title: '"إذا سمعتم بالطاعون بأرض فلا تدخلوها، وإذا وقع وأنتم بها فلا تخرجوا"', subtitle: 'رواه البخاري (5728) ومسلم', detail: 'لا تدخلوها = منع التعرّض للعدوى. لا تخرجوا = حصر الانتشار. هذا بالضبط اللي طبّقوه في كورونا 2020!' },
      category: 'ch6-prevention',
    },
  ],

  // Course ID 29: الدعاء - سلاح المؤمن
  29: [
    // === Chapter 1: What is Du'a? (5 cards) ===
    {
      id: 1,
      front: { icon: 'sword', text: 'علاش النبي ﷺ سمّى الدعاء "سلاح المؤمن"؟' },
      back: { title: 'لأنو يحميك من كل الأعداء!', subtitle: 'الشيطان، النفس الأمّارة، الفتن، المصائب', detail: 'كيما السلاح يصدّي كي ما تستعملوش، الدعاء كيفكيف - كل ما تتركو كل ما تبتعد على ربّك' },
      category: 'ch1-meaning',
    },
    {
      id: 2,
      front: { icon: 'heart', text: 'النبي ﷺ قال: "الدعاء هو العبادة". واش يعني هاذا؟' },
      back: { title: 'الدعاء مش جزء من العبادة - هو جوهرها!', subtitle: 'لأن العبادة الحقيقية هي الافتقار لله', detail: 'ما قالش "من العبادة" قال "هو العبادة" - يعني أساس كل عبادة هو التذلّل لله وهذا بالضبط الدعاء' },
      category: 'ch1-meaning',
    },
    {
      id: 3,
      front: { icon: 'gift', text: 'كل دعاء تدعوه عندو كم نتيجة ممكنة؟' },
      back: { title: '3 نتائج - ما كاين دعاء يروح هباءً!', subtitle: 'استجابة فورية، ادخار للآخرة، أو صرف شر', detail: 'الصحابة قالو: "إذن نُكثر!" النبي ﷺ قال: "الله أكثر" - مهما أكثرت ربّي أكثر في العطاء!' },
      category: 'ch1-meaning',
    },
    {
      id: 4,
      front: { icon: 'angry', text: 'ربّي يغضب كي ما تسألوش! واش الدليل؟' },
      back: { title: '«مَن لم يسأل الله يغضب عليه»', subtitle: 'عكس الناس تماماً!', detail: 'الناس كي تسألهم بزاف يزعفو. ربّي العكس - يحب تسألو وتلحّ عليه. كي ما تسألوش كأنك مستغني عليه' },
      category: 'ch1-meaning',
    },
    {
      id: 5,
      front: { icon: 'layers', text: 'واش هوما النوعان الأساسيان تاع الدعاء؟' },
      back: { title: 'دعاء العبادة + دعاء المسألة', subtitle: 'المؤمن الذكي يجمع بينهم', detail: 'دعاء العبادة: الصلاة والصيام والذكر. دعاء المسألة: "يا ربّي ارزقني". الأحسن تجمع: تصلّي وفي سجودك تدعو' },
      category: 'ch1-meaning',
    },

    // === Chapter 2: Etiquettes (5 cards) ===
    {
      id: 6,
      front: { icon: 'list-ordered', text: 'واش هو الترتيب الصحيح للدعاء اللي علّمنا النبي ﷺ؟' },
      back: { title: '4 خطوات بالترتيب', subtitle: 'حمد الله → صلاة على النبي → الطلب → صلاة على النبي', detail: 'كيما الرسالة عندها مقدمة وموضوع وخاتمة. هاذا الترتيب يخلّي دعاءك أقوى وأقرب للاستجابة' },
      category: 'ch2-etiquettes',
    },
    {
      id: 7,
      front: { icon: 'lock', text: 'النبي ﷺ قال: "كلّ دعاء محجوب حتى..." واش؟' },
      back: { title: 'حتى يُصلَّى على النبي ﷺ!', subtitle: 'الصلاة على النبي هي مفتاح الدعاء', detail: 'الصلاة على النبي في البداية والنهاية تخلّي دعاءك "محصور" بين شيئين مقبولين، والله كريم ما يردّ ما بينهما' },
      category: 'ch2-etiquettes',
    },
    {
      id: 8,
      front: { icon: 'x-circle', text: 'علاش ما نقولوش "يا ربّي اغفرلي إن شئت"؟' },
      back: { title: 'النبي ﷺ نهى عن هاذا! لازم تجزم', subtitle: '«ليعزم المسألة فإن الله لا مكره له»', detail: 'كي تقول "إن شئت" كأنك تقول لربّي ما عندي مشكل كان ما استجبتش. ربّي يحب العبد اللي يطلب بيقين وثقة!' },
      category: 'ch2-etiquettes',
    },
    {
      id: 9,
      front: { icon: 'volume-x', text: 'ربّي قال: ﴿ادعوا ربّكم تضرّعاً وخفية﴾. واش معنى خفية؟' },
      back: { title: 'الدعاء سرّاً أفضل من الجهر!', subtitle: 'أصدق في الإخلاص وأبعد عن الرياء', detail: 'زكريا عليه السلام نادى ربّه نداءً خفياً فمدحو ربّي. الدعاء بينك وبين ربّك أقوى من اللي قدّام الناس' },
      category: 'ch2-etiquettes',
    },
    {
      id: 10,
      front: { icon: 'tag', text: 'كيفاش تدعو ربّك بأسمائه الحسنى؟' },
      back: { title: 'اختار الاسم اللي يناسب طلبك!', subtitle: '﴿ولله الأسماء الحسنى فادعوه بها﴾', detail: 'مريض؟ يا شافي. محتاج رزق؟ يا رزّاق. خايف؟ يا حفيظ. ضايق؟ يا لطيف. مذنب؟ يا غفور يا توّاب' },
      category: 'ch2-etiquettes',
    },

    // === Chapter 3: Times & Places (5 cards) ===
    {
      id: 11,
      front: { icon: 'moon', text: 'واش هو أعظم وقت للدعاء في اليوم؟' },
      back: { title: 'الثلث الأخير من الليل!', subtitle: 'ربّي ينزل ويقول: "من يدعوني فأستجيب له؟"', detail: 'احسب ساعات الليل (مغرب→فجر) واقسمها على 3. حتى 15 دقيقة قبل الفجر تنفع!' },
      category: 'ch3-times',
    },
    {
      id: 12,
      front: { icon: 'hand', text: 'واش هو أقرب وقت تكون فيه من ربّك؟' },
      back: { title: 'في السجود!', subtitle: '«أقرب ما يكون العبد من ربّه وهو ساجد فأكثروا الدعاء»', detail: 'جبهتك في الأرض وقلبك يطلع لأعلى ما يكون عند الله. ادعو بالعربية أو بالدارجة - ربّي يفهم كل اللغات' },
      category: 'ch3-times',
    },
    {
      id: 13,
      front: { icon: 'clock', text: 'يوم الجمعة فيه ساعة مستجابة. وقتاش؟' },
      back: { title: 'أقوى رأيين:', subtitle: '1. من جلوس الإمام للمنبر حتى نهاية الصلاة', detail: '2. آخر ساعة بعد العصر حتى المغرب. الأحسن تدعو في الوقتين باش تصيبها إن شاء الله!' },
      category: 'ch3-times',
    },
    {
      id: 14,
      front: { icon: 'bell', text: '«الدعاء لا يُردّ بين...» بين واش وواش؟' },
      back: { title: 'بين الأذان والإقامة!', subtitle: 'وقت ذهبي بزاف ناس يضيّعوه', detail: 'بدل ما تقعد تهدر في التلفون بين الأذان والإقامة، استغل هاذ الدقائق في الدعاء - دعاء لا يُردّ!' },
      category: 'ch3-times',
    },
    {
      id: 15,
      front: { icon: 'users', text: 'كي تدعو لأخوك في غيابو واش يصرا؟' },
      back: { title: 'ملك يقول: "آمين ولك بمثل"!', subtitle: 'دعوة المرء لأخيه بظهر الغيب مستجابة', detail: 'حاب ربّي يشفيك؟ ادعو لمريض يشفيه ربّي والملك يدعيلك بنفس الشيء! فرصة ذهبية' },
      category: 'ch3-times',
    },

    // === Chapter 4: Conditions (4 cards) ===
    {
      id: 16,
      front: { icon: 'utensils', text: 'علاش المأكل الحلال شرط أساسي للاستجابة؟' },
      back: { title: 'الحرام يسدّ باب الاستجابة!', subtitle: 'راجل مسافر، أشعث، يرفع يديه... "فأنّى يُستجاب لذلك!"', detail: 'عندو كل الآداب بصح ماكلتو حرام فربّي ما استجابلوش. راجع مصادر رزقك!' },
      category: 'ch4-conditions',
    },
    {
      id: 17,
      front: { icon: 'hourglass', text: '«يُستجاب لأحدكم ما لم يعجل». واش معنى الاستعجال؟' },
      back: { title: 'تقول: "دعيت وما تجاوبش ربّي!"', subtitle: 'هاذا بالضبط اللي يمنع الاستجابة', detail: 'يعقوب عليه السلام فقد يوسف ودعا 40+ سنة وما يأسش! ربّي يستجيب في الوقت اللي يعرف إنو أحسن ليك' },
      category: 'ch4-conditions',
    },
    {
      id: 18,
      front: { icon: 'sparkles', text: '«أنا عند ظنّ عبدي بي». واش معناها؟' },
      back: { title: 'ربّي يعاملك على حسب ظنّك فيه!', subtitle: 'ادعو وأنت واثق 100%', detail: 'كي تدعو متيقّن = ربّي يستجيب. كي تدعو شاكّ = ربّي يعاملك على حسب شكّك. فظنّ بربّي خيراً!' },
      category: 'ch4-conditions',
    },
    {
      id: 19,
      front: { icon: 'settings', text: 'واش الفرق بين التوكّل والتواكل في الدعاء؟' },
      back: { title: '«اعقلها وتوكّل»!', subtitle: 'ادعو واخدم - ما تقعدش تستنّى', detail: 'ادعو ربّي يشفيك وروح للطبيب. ادعو ربّي يرزقك واخدم وابحث. التوكّل الصحيح = أسباب + توكّل على الله' },
      category: 'ch4-conditions',
    },

    // === Chapter 5-6: Barriers + Prophets' Du'as (5 cards) ===
    {
      id: 20,
      front: { icon: 'shield-off', text: 'واش هي أكبر 3 موانع تمنع استجابة الدعاء؟' },
      back: { title: 'الذنوب، المال الحرام، القلب الغافل', subtitle: 'ابن القيم شبّه الدعاء بالسلاح', detail: 'كي يكون السلاح قوي (أدعية صحيحة) واليد قوية (قلب حاضر) والمانع مفقود (بلا ذنوب) = نكاية في العدو' },
      category: 'ch5-barriers',
    },
    {
      id: 21,
      front: { icon: 'fish', text: 'واش هو "الدعاء اللي ما يخيّب أبداً"؟' },
      back: { title: '﴿لا إله إلا أنت سبحانك إني كنت من الظالمين﴾', subtitle: 'دعاء يونس عليه السلام في بطن الحوت', detail: 'النبي ﷺ ضمن: "ما من مسلم يدعو بها في شيء إلا استجاب الله له". احفظها واستعملها في أي ضيق!' },
      category: 'ch6-prophets',
    },
    {
      id: 22,
      front: { icon: 'book-open', text: 'كيفاش دعا أيوب عليه السلام وهو مريض؟' },
      back: { title: '﴿أنّي مسّني الضرّ وأنت أرحم الراحمين﴾', subtitle: 'ما قالش "اشفيني"! وصف حالو ومدح ربّي', detail: 'أدب عظيم: وصف الحال + مدح الله = ربّي فهم واستجاب. أحياناً أحسن دعاء هو تصف حالك لربّي بتذلّل' },
      category: 'ch6-prophets',
    },
    {
      id: 23,
      front: { icon: 'megaphone', text: 'واش دعا موسى عليه السلام قبل ما يواجه فرعون؟' },
      back: { title: '﴿ربّ اشرح لي صدري ويسّر لي أمري﴾', subtitle: 'شرح الصدر + تيسير الأمر + فصاحة اللسان', detail: 'إيلا كنت رايح تدير حاجة صعبة (امتحان، مقابلة، قرار مهم) - ادعو بدعاء موسى!' },
      category: 'ch6-prophets',
    },
    {
      id: 24,
      front: { icon: 'globe', text: 'واش هو أكثر دعاء كان يردّده النبي ﷺ؟' },
      back: { title: '﴿ربّنا آتنا في الدنيا حسنة وفي الآخرة حسنة وقنا عذاب النار﴾', subtitle: 'أجمع دعاء في القرآن!', detail: 'خير الدنيا + خير الآخرة + النجاة من النار في جملة وحدة. النبي ﷺ أعلم الناس بالدعاء واختار هاذا!' },
      category: 'ch6-prophets',
    },

    // === Chapter 7: Sunnah Du'as (3 cards) ===
    {
      id: 25,
      front: { icon: 'shield-check', text: 'واش هو "سيد الاستغفار" وواش فضلو؟' },
      back: { title: '«اللهم أنت ربّي لا إله إلا أنت خلقتني وأنا عبدك...»', subtitle: 'من قالها موقناً ومات من يومه = من أهل الجنة!', detail: 'فيه: توحيد، عبودية، التزام بالعهد، اعتراف بالنعم، اعتراف بالذنب، ثم طلب المغفرة. أكمل استغفار' },
      category: 'ch7-sunnah',
    },
    {
      id: 26,
      front: { icon: 'heart-pulse', text: 'واش هو دعاء الكرب اللي يذهب الهمّ والحزن؟' },
      back: { title: '«اللهم إني عبدك ابن عبدك ابن أمتك ناصيتي بيدك...»', subtitle: 'النبي ﷺ ضمن: ما قالها أحد إلا أذهب الله همّه', detail: 'التوسّل بكل أسماء الله حتى المخفية! "أو استأثرت به في علم الغيب عندك" - شمولية عجيبة' },
      category: 'ch7-sunnah',
    },
    {
      id: 27,
      front: { icon: 'compass', text: 'كي تكون محتار بين قرارين واش تدير؟' },
      back: { title: 'صلاة الاستخارة!', subtitle: 'صلّي ركعتين ثم ادعو بدعاء الاستخارة', detail: 'النتيجة: إيلا تيسّرت الحاجة = خير. إيلا تعسّرت = ربّي يصرفك عنها. ما تستناش حلم أو إشارة - امشي في الأسباب' },
      category: 'ch7-sunnah',
    },

    // === Chapter 8-9: Daily + Special (3 cards) ===
    {
      id: 28,
      front: { icon: 'sunrise', text: 'أذكار الصباح شحال تاخذ وواش أهمها؟' },
      back: { title: '10-15 دقيقة = حصن يومك كامل!', subtitle: 'آية الكرسي + المعوّذات + "بسم الله الذي لا يضر..."', detail: '"بسم الله الذي لا يضر مع اسمه شيء" 3 مرات = لم يضرّه شيء حتى يمسي. تأمين ربّاني مجاني!' },
      category: 'ch8-daily',
    },
    {
      id: 29,
      front: { icon: 'shopping-bag', text: 'واش تقول كي تدخل السوق (المارشي)؟' },
      back: { title: '«لا إله إلا الله وحده لا شريك له...»', subtitle: 'مليون حسنة + مليون سيئة ممحية!', detail: '"لا إله إلا الله وحده لا شريك له، له الملك وله الحمد يحيي ويميت وهو حيّ لا يموت بيده الخير وهو على كل شيء قدير"' },
      category: 'ch8-daily',
    },
    {
      id: 30,
      front: { icon: 'star', text: 'واش هو دعاء ليلة القدر اللي علّمو النبي ﷺ لعائشة؟' },
      back: { title: '«اللهم إنك عفوّ تحبّ العفو فاعفُ عنّي»', subtitle: 'ليلة القدر خير من ألف شهر (83+ سنة!)', detail: 'ردّده بزاف في الليالي الوتر من العشر الأواخر: 21، 23، 25، 27، 29 من رمضان' },
      category: 'ch9-special',
    },
  ],

  // Course ID 25: ربّي ولادك على الإسلام
  25: [
    // === Chapter 1: التربية أمانة (4 cards) ===
    {
      id: 1,
      front: { icon: 'shield', text: 'ربّي أمرنا نحمي عايلاتنا في سورة التحريم. واش قال بالضبط؟' },
      back: { title: '﴿قُوا أَنفُسَكُمْ وَأَهْلِيكُمْ نَارًا﴾', subtitle: 'سورة التحريم - الآية 6', detail: 'التربية فرض مش تطوع! ربّي بدا بالأنفس قبل الأهل: صلّح روحك أولاً ثم صلّح ولادك' },
      category: 'ch1-trust',
    },
    {
      id: 2,
      front: { icon: 'users', text: 'النبي ﷺ قال "كلكم راعٍ..." واش يعني الراعي في التربية؟' },
      back: { title: 'الراعي = اللي يرعى ويحمي ويهتم', subtitle: 'مش بس يأمر ويفرض!', detail: '6 جوانب: الحماية، التعليم، التغذية الحلال، العاطفة والحب، العدل بين الأولاد، والقدوة الحسنة' },
      category: 'ch1-trust',
    },
    {
      id: 3,
      front: { icon: 'scroll', text: 'لقمان الحكيم وصّى ولده 5 وصايا. واش هي وبأي ترتيب؟' },
      back: { title: 'التوحيد → برّ الوالدين → مراقبة الله → الصلاة → التواضع', subtitle: 'بدا بالتوحيد قبل كل شيء!', detail: 'لاحظ أسلوبه: "يا بُنيّ" بالتصغير والحنان. وكل وصية فيها تعليل: "إن الشرك لظلم عظيم" - يشرح علاه مش يأمر فقط' },
      category: 'ch1-trust',
    },
    {
      id: 4,
      front: { icon: 'scale', text: 'النبي ﷺ رفض يشهد على هدية النعمان بن بشير. علاه؟' },
      back: { title: 'لأن أبوه فضّله على إخوته!', subtitle: '«اتقوا الله واعدلوا بين أولادكم» - متفق عليه', detail: 'العدل فرض مش اختيار! مش بس في المال، حتى في الحب والاهتمام والوقت. التفرقة = حقد بين الأخوة' },
      category: 'ch1-trust',
    },

    // === Chapter 2: من قبل ما يتولد (3 cards) ===
    {
      id: 5,
      front: { icon: 'heart', text: 'النبي ﷺ قال "تُنكح المرأة لأربع..." واش نصح؟' },
      back: { title: '«فاظفر بذات الدين تربت يداك»', subtitle: 'اختيار الشريك الصالح = أساس التربية', detail: 'المرا/الراجل المتدين راح يربّي ولادك على الإسلام حتى كي ما تكونش موجود. الشكل يروح والمال يروح، الدين يبقى' },
      category: 'ch2-before',
    },
    {
      id: 6,
      front: { icon: 'baby', text: 'واش هو دعاء الجماع اللي يحمي الولد من الشيطان؟' },
      back: { title: '«بسم الله، اللهم جنّبنا الشيطان وجنّب الشيطان ما رزقتنا»', subtitle: 'متفق عليه', detail: 'لو قُدّر ولد من ذلك لم يضرّه شيطان أبداً! الحماية تبدا من أول لحظة. كثير من الناس ينساو هذا الدعاء' },
      category: 'ch2-before',
    },
    {
      id: 7,
      front: { icon: 'list-checks', text: 'واش هي سنن يوم السابع من الولادة؟' },
      back: { title: 'العقيقة + التسمية + الحلاقة', subtitle: '«كل غلام مرتهن بعقيقته» - أبو داود والترمذي', detail: 'شاتين للذكر وشاة للأنثى + اسم حسن المعنى + حلق الرأس والتصدق بوزن الشعر فضة + الأذان في الأذن اليمنى' },
      category: 'ch2-before',
    },

    // === Chapter 3: لاعبه سبعاً 0-7 (4 cards) ===
    {
      id: 8,
      front: { icon: 'gamepad-2', text: 'المرحلة الأولى (0-7 سنين) كلمتها المفتاحية واحدة. واش هي؟' },
      back: { title: '«لاعبه» - الطفل سيّد!', subtitle: 'العب معاه، أحبّه، عطيه الأمان', detail: 'ما تضربوش، ما تفرض عليه أوامر قاسية. علّمه باللعب والحب والقصص. عقله ما زال ما نضجش للتأديب الجدّي' },
      category: 'ch3-play',
    },
    {
      id: 9,
      front: { icon: 'message-circle', text: 'واش هي أول كلمات لازم الدرّي يتعلّمها؟' },
      back: { title: 'بسم الله، الحمد لله، السلام عليكم', subtitle: 'كلمات ربّي قبل أي كلام دنيوي', detail: 'اربط كل كلمة بفعل: بسم الله قبل الأكل، الحمد لله بعده، السلام عليكم كي يدخل. التكرار اليومي يخلّيها عادة' },
      category: 'ch3-play',
    },
    {
      id: 10,
      front: { icon: 'heart-handshake', text: 'كثير من الآباء يخوّفو ولادهم بربّي. واش الطريقة الصحيحة؟' },
      back: { title: 'حب الله قبل الخوف من الله!', subtitle: 'تحت 7 سنين: ربّي يحبّك ويعطيك ويحميك', detail: 'بدل "ربّي راح يعاقبك!" ← "ربّي يحبّك كي تكون مزيان". بدل "النار تحرق الكاذبين!" ← "ربّي يحب الصادقين ويعطيهم هدايا في الجنة"' },
      category: 'ch3-play',
    },
    {
      id: 11,
      front: { icon: 'book-open', text: 'القصص أقوى أداة تربوية. واش الدليل من القرآن؟' },
      back: { title: '﴿نَحْنُ نَقُصُّ عَلَيْكَ أَحْسَنَ الْقَصَصِ﴾', subtitle: 'ربّي استعمل القصص لتعليم الناس!', detail: 'كل عمر عنده قصص: 2-3 سنين: نوح والسفينة. 4-5: يوسف مبسّطة. 6-7: سيرة النبي ﷺ. أفضل وقت: قبل النوم بتغيير نبرة الصوت' },
      category: 'ch3-play',
    },

    // === Chapter 4: أدّبه سبعاً 7-14 (5 cards) ===
    {
      id: 12,
      front: { icon: 'alarm-clock', text: 'النبي ﷺ قال "مُروا أولادكم بالصلاة لسبع..." واش التدرّج الصحيح؟' },
      back: { title: '7 سنين = أمر لطيف → 10 سنين = إلزام', subtitle: '3 سنين تعليم وتشجيع قبل أي عقاب!', detail: '7: صلاة وحدة/يوم + الوضوء. 8: صلاتين + سور قصيرة. 9: ثلاث + خذه للجمعة. 10: الخمس كاملة + اشريله سجادة خاصة بيه' },
      category: 'ch4-discipline',
    },
    {
      id: 13,
      front: { icon: 'book-marked', text: 'واش خطة حفظ القرآن العملية من 7 لـ 14 سنة؟' },
      back: { title: 'جزء عمّ → جزء تبارك → الكهف ويس → التوسّع', subtitle: '«خيركم من تعلّم القرآن وعلّمه» - البخاري', detail: 'القاعدة: 70% مراجعة + 30% حفظ جديد. أفضل وقت بعد الفجر. آية واحدة يوميا أفضل من صفحة مرة في الشهر!' },
      category: 'ch4-discipline',
    },
    {
      id: 14,
      front: { icon: 'list-ordered', text: 'واش هي مراحل التأديب الإيجابي بالترتيب (6 مراحل)؟' },
      back: { title: 'التوجيه → التنبيه → العقاب المعنوي → العزل → الحرمان → (آخر حل) الضرب غير المبرح', subtitle: 'التدرّج مش القسوة!', detail: 'ممنوعات: الضرب على الوجه، الشتيمة، المقارنة، التأديب وأنت زعفان. والأهم: لا تدعي على ولادك أبداً!' },
      category: 'ch4-discipline',
    },
    {
      id: 15,
      front: { icon: 'trophy', text: 'كي ولدك يعترف بغلطه واش الردة الصحيحة؟' },
      back: { title: 'كافئه على الصدق! ما تعاقبوش!', subtitle: '«إياكم والكذب فإن الكذب يهدي إلى الفجور» - متفق عليه', detail: '"شكراً اللي قلتلي الحقيقة، هذا شجاع!" - كي يعرف إن الصدق = مكافأة والكذب = عقاب، يختار الصدق دائماً' },
      category: 'ch4-discipline',
    },
    {
      id: 16,
      front: { icon: 'message-square', text: 'موضوع البلوغ "تابو" عندنا. الإسلام واش يقول؟' },
      back: { title: 'النبي ﷺ علّم الصحابة بوضوح وبدون حرج!', subtitle: 'الأم مع البنت (9-10 سنين) والأب مع الولد (10-11)', detail: 'اشرح بمصطلحات شرعية. اشرح الأحكام: الغسل، الطهارة. كي ما تعلّمش أنت، راح يتعلّم من الشارع أو الإنترنت!' },
      category: 'ch4-discipline',
    },

    // === Chapter 5: صاحبه سبعاً 14-21 (4 cards) ===
    {
      id: 17,
      front: { icon: 'handshake', text: 'المرحلة الثالثة (14-21) كلمتها المفتاحية واحدة. واش هي؟' },
      back: { title: '«صاحبه» - المراهق يولّي صاحبك!', subtitle: 'ما عادش درّي تأمره. ولّى شاب عنده رأيه', detail: 'دورك الجديد: المرشد والصديق. اسمعله، شاوره، واحترم رأيه. أغلب مشاكل المراهقة سببها إهمال المرحلتين الأولى والثانية' },
      category: 'ch5-befriend',
    },
    {
      id: 18,
      front: { icon: 'ear', text: 'ولدك المراهق حكالك إنه حبّ واحد/ة. واش تدير؟' },
      back: { title: 'اشكره على الثقة + وجّهه بحكمة', subtitle: 'الردة الأولى تقطع التواصل للأبد!', detail: '❌ "واش بيك؟ هذا حرام!" ✅ "شكراً اللي حكيتلي. هذي مشاعر طبيعية، بصح لازم نديروها في إطارها الشرعي. كي تكبر نخطبلك إن شاء الله"' },
      category: 'ch5-befriend',
    },
    {
      id: 19,
      front: { icon: 'help-circle', text: 'ولدك يشكّك في الدين ويسأل أسئلة صعبة. واش تدير؟' },
      back: { title: 'السؤال مش كفر! السؤال طريق للإيمان القوي', subtitle: 'حتى إبراهيم قال "ربّ أرني كيف تُحيي الموتى"', detail: '❌ "اسكت يا كافر!" ✅ "سؤال مليح، خلّينا نبحثو مع بعض." لو ما عندكش الجواب خذه لشيخ يثق فيه. وادعيله بالهداية كل سجدة' },
      category: 'ch5-befriend',
    },
    {
      id: 20,
      front: { icon: 'shield-check', text: 'واش أقوى حماية لولدك المراهق من الانحراف؟' },
      back: { title: 'الرقيب الداخلي - يخاف ربّي وهو وحده', subtitle: 'أقوى من أي كاميرا مراقبة أو فلتر!', detail: 'يتبنى من الطفولة بالحب والتعليم والقدوة. المنع والسيطرة وحدهم ما يكفوش. كي يمتنع عن الحرام بإرادته = نجحت' },
      category: 'ch5-befriend',
    },

    // === Chapter 6: التربية بالقدوة (3 cards) ===
    {
      id: 21,
      front: { icon: 'eye', text: 'الدراسات تقول الأطفال يتعلّمو 80% من سلوكياتهم بطريقة واحدة. واش هي؟' },
      back: { title: 'المراقبة والتقليد! (مش التعليم المباشر)', subtitle: '«خيركم خيركم لأهله» - الترمذي', detail: 'كي تقول "ما تكذبش" وأنت تكذب قدّامه = يتعلّم الكذب. كون أنت المثال: صلّي يشوفك، اصدق يسمعك، سامح يتعلّم منك' },
      category: 'ch6-example',
    },
    {
      id: 22,
      front: { icon: 'clock', text: 'أنس بن مالك خدم النبي ﷺ عشر سنين. كم مرة زعف عليه؟' },
      back: { title: 'ولا مرة واحدة! صفر!', subtitle: '«ما قال لي لشيء فعلته لِمَ فعلت، ولا لشيء لم أفعله لِمَ لم تفعل»', detail: '10 سنين من الصبر المطلق مع طفل! هذا هو الصبر الحقيقي في التربية. والنتيجة: أنس صار من أعظم الصحابة' },
      category: 'ch6-example',
    },
    {
      id: 23,
      front: { icon: 'alert-triangle', text: 'النبي ﷺ حذّر من وعود كاذبة للأطفال. واش قال؟' },
      back: { title: '«من قال لصبي تعال أعطيك ثم لم يعطه فهي كذبة»', subtitle: 'رواه أبو داود', detail: '"غدوة نشريلك" وما تشريش = كذب عند ربّي! الولد يفقد الثقة فيك شوية بشوية. كن صادق: "ما نقدرش دروك، بصح نشوف كي يجي الوقت"' },
      category: 'ch6-example',
    },

    // === Chapter 7: غرس العقيدة والأخلاق (3 cards) ===
    {
      id: 24,
      front: { icon: 'sparkles', text: 'كيفاش تعلّم التوحيد لطفل صغير ببساطة؟' },
      back: { title: '"شكون خلق السما؟ ربّي! شكون خلقك؟ ربّي!"', subtitle: 'حب الله أولاً مش الخوف منه', detail: 'ربّي واحد، يحبّنا، يسمعنا، عطانا عينينا وماماه وباباه. مع الصغار: حب الله. مع الكبار: حب + خشية. لا تبدأ بالتخويف أبداً!' },
      category: 'ch7-values',
    },
    {
      id: 25,
      front: { icon: 'gem', text: 'واش هي أهم 7 قيم إسلامية لازم تغرسها في ولدك؟' },
      back: { title: 'الصدق، الأمانة، الكرم، الصبر، الشكر، التواضع، الرحمة', subtitle: '«الراحمون يرحمهم الرحمن» - أبو داود', detail: 'كل قيمة تتعلّم بالممارسة: الكرم = يوزّع الماكلة للجيران بيده. الصدق = كافئه كي يعترف بغلطه. التعاطف = زيارة المرضى معاك' },
      category: 'ch7-values',
    },
    {
      id: 26,
      front: { icon: 'calendar', text: 'كيفاش تستغل المناسبات الإسلامية في التربية؟' },
      back: { title: 'كل مناسبة = فرصة ذهبية!', subtitle: 'رمضان، العيدين، الجمعة، عاشوراء...', detail: 'رمضان: صبر + كرم + قرآن. العيد: صلة رحم + فرحة. الجمعة: الكهف + المسجد. فكرة: "صحابي الأسبوع" = 52 صحابي في السنة!' },
      category: 'ch7-values',
    },

    // === Chapter 8: التحديات العصرية (3 cards) ===
    {
      id: 27,
      front: { icon: 'smartphone', text: '32% من تلاميذ الجزائر يقضو +3 ساعات/يوم أمام الشاشات. واش الحل؟' },
      back: { title: 'قواعد صارمة حسب العمر!', subtitle: '0-2: صفر شاشة | 2-5: نصف ساعة | 5-12: ساعة', detail: 'الشاشة تسبّب: تأخّر الكلام، ضعف التركيز، مشاكل النوم، العزلة. البديل: ألعاب حقيقية، حديقة، قصص، أناشيد، كتب ملوّنة' },
      category: 'ch8-challenges',
    },
    {
      id: 28,
      front: { icon: 'wifi-off', text: 'واش فكرة "يوم بلا شاشات" وكيفاش تطبّقها؟' },
      back: { title: 'يوم واحد/أسبوع بلا هاتف ولا تابلت ولا تلفزيون', subtitle: 'في البداية صعيب بصح بعد شوية يستنّاوها ولادك!', detail: 'اخرجو تتنزّهو، العبو ألعاب عائلية، اقرأو كتب. والأهم: أنت زادة حطّ الهاتف! ما تقدرش تمنع وأنت ملتصق بالشاشة' },
      category: 'ch8-challenges',
    },

    // === Chapters 9-10: الأدعية + الخاتمة (2 cards) ===
    {
      id: 29,
      front: { icon: 'hand', text: 'النبي ﷺ ذكر 3 دعوات مستجابات. واش هي؟' },
      back: { title: 'دعوة الوالد + دعوة المسافر + دعوة المظلوم', subtitle: 'رواه أبو داود والترمذي', detail: 'دعوتك لولدك أقوى من أي خطة تربوية! ادعيله في كل سجدة. أهم دعاء: ﴿رَبَّنَا هَبْ لَنَا مِنْ أَزْوَاجِنَا وَذُرِّيَّاتِنَا قُرَّةَ أَعْيُنٍ﴾' },
      category: 'ch9-dua',
    },
    {
      id: 30,
      front: { icon: 'route', text: 'لخّص المراحل الثلاث للتربية الإسلامية في 3 كلمات.' },
      back: { title: 'لاعبه (0-7) → أدّبه (7-14) → صاحبه (14-21)', subtitle: 'كل مرحلة تبني على اللي قبلها!', detail: 'كي تلعب معاه يسمعلك. كي تأدّبه بالحسنى يقبل صداقتك. القواعد الذهبية: ابدأ بنفسك، الحب أولاً، القدوة، العدل، الصبر، الدعاء' },
      category: 'ch10-conclusion',
    },
  ],

  // Course ID 28: فهم القرآن - مفاتيح التدبّر
  28: [
    // === الباب 1: واش معناها تدبّر القرآن (4 cards) ===
    {
      id: 1,
      front: { icon: 'book-open-check', text: 'واش الفرق بين التلاوة والتفسير والتدبّر؟' },
      back: { title: '3 مستويات مختلفة ومكمّلة', subtitle: 'التلاوة = القراءة | التفسير = الشرح العلمي | التدبّر = التأمّل الشخصي', detail: 'التلاوة: تقرا بتجويد. التفسير: تفتح كتاب وتقرا شرح الآية. التدبّر: تسأل روحك "كيفاش نطبّق هاذي في حياتي؟" - هذا اللي يبدّل السلوك!' },
      category: 'ch1-meaning',
    },
    {
      id: 2,
      front: { icon: 'lock', text: 'ربّي ذكر "التدبّر" في 4 مواضع في القرآن. واش أقوى آية فيهم؟' },
      back: { title: '﴿أَفَلَا يَتَدَبَّرُونَ الْقُرْآنَ أَمْ عَلَىٰ قُلُوبٍ أَقْفَالُهَا﴾', subtitle: 'سورة محمد - الآية 24', detail: 'توبيخ شديد! ربّي يسأل: واش قلوبكم مقفّلة حتى ما تقدروش تتدبّرو؟ اللي ما يتدبّرش كأنو على قلبو قفل!' },
      category: 'ch1-meaning',
    },
    {
      id: 3,
      front: { icon: 'layers', text: 'خمسة مستويات للعلاقة مع القرآن. واش هي بالترتيب؟' },
      back: { title: 'استماع → قراءة → حفظ → تدبّر → عمل', subtitle: 'أغلب الناس في المستوى 1 أو 2', detail: 'الهدف هو المستوى 4 على الأقل (التدبّر). ابن عباس قال: "لأن أقرأ آيتين وأتدبّرهما أحبّ إليّ من أقرأ البقرة وآل عمران تهذيراً"' },
      category: 'ch1-meaning',
    },
    {
      id: 4,
      front: { icon: 'activity', text: 'النبي ﷺ كان يتفاعل مع كل آية. كيفاش بالضبط؟' },
      back: { title: 'يوقف عند كل آية ويتفاعل معاها!', subtitle: 'آية رحمة = يسأل | آية عذاب = يتعوّذ | تسبيح = يسبّح', detail: 'قرا سورة البقرة (286 آية) ووقف عند كل آية رحمة وكل آية عذاب! تخيّل كم وقت خذاتلو - هذا هو التدبّر الحقيقي' },
      category: 'ch1-meaning',
    },

    // === الباب 2: تحضير الروح للتدبّر (3 cards) ===
    {
      id: 5,
      front: { icon: 'shield-off', text: 'ربّي شبّه موانع التدبّر بأقفال على القلب. واش هي الأقفال الأربعة؟' },
      back: { title: 'الذنوب | الغفلة | قسوة القلب | الجهل باللغة', subtitle: 'كل قفل عندو مفتاح يفتحو!', detail: 'الذنوب ← التوبة والاستغفار. الغفلة ← الذكر. قسوة القلب ← تقليل المشتّتات. الجهل ← التعلّم التدريجي. ابدا بأي مفتاح!' },
      category: 'ch2-prepare',
    },
    {
      id: 6,
      front: { icon: 'heart', text: 'واش أهم شرط باش تتدبّر القرآن صح؟' },
      back: { title: 'حضور القلب - القلب يكون حاضر مش غايب!', subtitle: '﴿لِمَن كَانَ لَهُ قَلْبٌ أَوْ أَلْقَى السَّمْعَ وَهُوَ شَهِيدٌ﴾ - سورة ق', detail: 'استشعر عظمة المتكلّم: اللي يكلّمك هو الله خالق الكون! اقرأ كأن القرآن نزل عليك نت. توقّف كي ما تحسّش بحضور القلب' },
      category: 'ch2-prepare',
    },
    {
      id: 7,
      front: { icon: 'clipboard-list', text: 'واش هي قائمة التحضير قبل كل جلسة تدبّر؟ (9 خطوات)' },
      back: { title: 'وضوء + مكان هادي + إشعارات مطفية + استعاذة + بسملة + دعاء', subtitle: 'ما تاخذش أكثر من 5 دقائق!', detail: '+ حضّر أدواتك (مصحف + دفتر + قلم + تفسير). حدّد الكمية (صفحة أو صفحتين). استحضر نيّتك. هاذ الـ5 دقائق تفرق بزاف!' },
      category: 'ch2-prepare',
    },

    // === الباب 3: علوم القرآن الأساسية (4 cards) ===
    {
      id: 8,
      front: { icon: 'map-pin', text: 'واش الفرق بين السور المكية والمدنية وعلاش يهمّك؟' },
      back: { title: 'المكية = عقيدة وقصص | المدنية = أحكام وتشريعات', subtitle: 'المكية: "يا أيها الناس" | المدنية: "يا أيها الذين آمنوا"', detail: 'المكية نزلت والمسلمين مستضعفين (فيها تثبيت). المدنية نزلت بعد قيام الدولة (فيها أحكام). معرفة هاذا يساعدك تفهم السياق!' },
      category: 'ch3-sciences',
    },
    {
      id: 9,
      front: { icon: 'file-text', text: 'واش معنى "أسباب النزول" وعلاش مهمة بزاف؟' },
      back: { title: 'الحادثة أو السؤال اللي نزلت الآية بسببو', subtitle: 'القاعدة: العبرة بعموم اللفظ لا بخصوص السبب', detail: 'مثال: آية الحجاب نزلت لحماية النساء من أذى المنافقين. كي تعرف السبب تفهم إن الحجاب = تكريم وحماية. بصح الحكم عام لكل زمان!' },
      category: 'ch3-sciences',
    },
    {
      id: 10,
      front: { icon: 'target', text: 'كل سورة عندها محور رئيسي. كيفاش تكتشفو؟' },
      back: { title: '4 خطوات: اقرأ كاملة → أول وآخر آية → الكلمات المتكررة → التفاسير', subtitle: 'مثل العقد: حبّات مختلفة بصح الخيط واحد', detail: 'أمثلة: البقرة = الاستخلاف. آل عمران = الثبات أمام الفتن. الكهف = العصمة من 4 فتن. يوسف = الوعد بالتمكين بعد الابتلاء' },
      category: 'ch3-sciences',
    },
    {
      id: 11,
      front: { icon: 'repeat', text: 'قصة موسى مذكورة في 20+ سورة. علاش التكرار مش عبثي؟' },
      back: { title: '5 حِكَم للتكرار في القصص القرآني', subtitle: 'كل تكرار يضيف زاوية جديدة!', detail: '1) إضافة معاني جديدة. 2) تأكيد الدروس المهمة. 3) مناسبة لسياق كل سورة. 4) تنويع الأسلوب. 5) تثبيت قلب النبي ﷺ. في البقرة: عناد بني إسرائيل. في طه: بداية الرسالة. في القصص: حياته الشخصية' },
      category: 'ch3-sciences',
    },

    // === الباب 4: أدوات فهم القرآن (3 cards) ===
    {
      id: 12,
      front: { icon: 'list-ordered', text: 'واش هي الطرق الخمسة للتفسير بالترتيب الصحيح؟' },
      back: { title: 'القرآن بالقرآن → بالسنة → بأقوال الصحابة → باللغة → بالاجتهاد', subtitle: 'الترتيب مهم بزاف!', detail: 'أعلى طريقة: تفسير القرآن بالقرآن (ربّي يفسّر كلامو بكلامو). مثال: "الصراط المستقيم" في الفاتحة فسّرو ربّي في الأنعام: "وأن هذا صراطي مستقيماً فاتّبعوه"' },
      category: 'ch4-tools',
    },
    {
      id: 13,
      front: { icon: 'book', text: 'واش أحسن 3 كتب تفسير للمبتدئين؟' },
      back: { title: 'التفسير الميسّر → تفسير السعدي → المختصر في التفسير', subtitle: 'ابدا بالميسّر - مبسّط بزاف ومجاني!', detail: 'الميسّر: كل آية تحتها تفسير واضح (مجمع الملك فهد). السعدي: يستخرج فوائد عملية لحياتك. المختصر: حديث ومعاصر على هامش المصحف' },
      category: 'ch4-tools',
    },
    {
      id: 14,
      front: { icon: 'notebook-pen', text: 'واش هو "دفتر التدبّر" وكيفاش تستعملو؟' },
      back: { title: 'دفتر تكتب فيه خواطرك كل ما تقرا القرآن', subtitle: '6 عناصر: التاريخ، الآية، المعنى، الخاطرة، التطبيق العملي', detail: 'مثال: الآية ﴿ومن يتوكّل على الله فهو حسبه﴾ → الخاطرة: "نتوكّل على الأسباب وننسى المسبّب" → التطبيق: "كل ما نخاف نقول حسبي الله وأعمل اللي عليّا"' },
      category: 'ch4-tools',
    },

    // === الباب 5: أسرار البلاغة القرآنية (4 cards) ===
    {
      id: 15,
      front: { icon: 'arrow-right-left', text: '"إيّاك نعبد" - علاش ما قالش ربّي ببساطة "نعبدك"؟' },
      back: { title: 'التقديم يفيد الحصر والاختصاص!', subtitle: '"إيّاك نعبد" = أنت وحدك فقط نعبد', detail: 'لو قال "نعبدك" كان المعنى: نعبدك (وممكن نعبدو غيرك زيادة). بصح "إيّاك نعبد" = ما نعبدو حتى واحد غيرك! حرف واحد بدّل المعنى بالكامل' },
      category: 'ch5-rhetoric',
    },
    {
      id: 16,
      front: { icon: 'flame', text: '﴿واشتعل الرأس شيباً﴾ - علاش هاذي أقوى من "ابيضّ شعري"؟' },
      back: { title: 'هاذي استعارة: الشيب كأنو نار اشتعلت في الرأس!', subtitle: 'الاستعارة أقوى من التشبيه لأنها مباشرة', detail: 'زكريا عليه السلام وصف كِبَرو بطريقة تحسّسك بالضعف. ما قالش "شعري أبيض" (خبر عادي)، قال "اشتعل" (صورة حيّة). القرآن ما فيهش كلمة عادية!' },
      category: 'ch5-rhetoric',
    },
    {
      id: 17,
      front: { icon: 'wind', text: 'في القرآن "ريح" مفرد و"رياح" جمع. واش الفرق العجيب؟' },
      back: { title: '"ريح" = غالباً عذاب | "رياح" = غالباً رحمة!', subtitle: '﴿وأرسلنا الرياح لواقح﴾ (رحمة) — ﴿فأرسلنا عليهم ريحاً صرصراً﴾ (عذاب)', detail: 'الحكمة: الرحمة تجي من جهات مختلفة (رياح جمع)، والعذاب يجي من جهة واحدة (ريح مفرد). كل كلمة في القرآن بميزان!' },
      category: 'ch5-rhetoric',
    },
    {
      id: 18,
      front: { icon: 'hash', text: 'كلمة "الدنيا" وكلمة "الآخرة" كل وحدة ذُكرت كم مرة؟' },
      back: { title: 'كل وحدة ذُكرت 115 مرة بالضبط!', subtitle: 'توازن عددي مذهل في كتاب نزل على 23 سنة', detail: 'زيد: "يوم" مفرد = 365 مرة (أيام السنة). "شهر" = 12 مرة (أشهر السنة). الحياة = الموت = 145. هاذا دليل إنو كلام الله مش كلام بشر!' },
      category: 'ch5-rhetoric',
    },

    // === الباب 6: مفاتيح التدبّر العملي (4 cards) ===
    {
      id: 19,
      front: { icon: 'turtle', text: 'واش أول وأهم مفتاح من المفاتيح العشرة للتدبّر؟' },
      back: { title: 'المفتاح 1: اقرأ ببطء وكرّر!', subtitle: 'عمر بن الخطاب قعد 12 عام يحفظ سورة البقرة - كان يطبّق كل آية', detail: 'ربع حزب في 15 دقيقة خير من حزب كامل في 15 دقيقة. وقّف عند كل آية. كرّر اللي حرّكت قلبك. الإمام الغزالي: "لا تنتقل من آية حتى تستوفي حقها من التأمل"' },
      category: 'ch6-keys',
    },
    {
      id: 20,
      front: { icon: 'replace', text: 'المفتاح 5: "اسأل علاه هاذي الكلمة" - كيفاش يخدم؟' },
      back: { title: 'بدّل الكلمة القرآنية بمرادفها وشوف الفرق!', subtitle: 'القرآن ما فيهش كلمة ممكن تتبدّل بغيرها', detail: 'مثال: "خشية" vs "خوف" - الخشية = خوف مع علم. لهذا ﴿إنما يخشى الله من عباده العلماء﴾ استعمل "يخشى" مش "يخاف" لأن العالم يخاف بمعرفة!' },
      category: 'ch6-keys',
    },
    {
      id: 21,
      front: { icon: 'user', text: 'المفتاح 7: "حط روحك في الآية" - واش يعني؟' },
      back: { title: 'اقرأ كأن القرآن نزل عليك نت شخصياً!', subtitle: 'ابن مسعود: "إذا سمعت يا أيها الذين آمنوا فأصغِ لها سمعك"', detail: 'آية وعد: "يا ربّي أنا منهم!" آية وعيد: "واش أنا من هاؤلاء؟" عمر بن الخطاب كي يسمع آية وعيد يقعد مريض أياماً - كأنها نزلت عليه هو!' },
      category: 'ch6-keys',
    },
    {
      id: 22,
      front: { icon: 'clock', text: 'نظام القراءات الثلاث اليومية - واش هو بالضبط؟' },
      back: { title: '3 جلسات × 10 دقائق = 30 دقيقة/يوم', subtitle: 'قراءة تفسير (الفجر) + مصحف (الظهر) + تطبيق (قبل النوم)', detail: 'التفسير: 5 آيات مع شرح = 1800 آية/سنة = ثلث القرآن بفهم عميق! المصحف: ورد يومي = 6 ختمات/سنة. التطبيق: آية وحدة "كيفاش نطبّقها غدوة" = 365 تطبيق/سنة!' },
      category: 'ch6-keys',
    },

    // === الباب 7: تدبّر سور نموذجية (4 cards) ===
    {
      id: 23,
      front: { icon: 'gem', text: 'الفاتحة 7 آيات فقط. واش سرّ بنيتها العجيب؟' },
      back: { title: 'أول 3 = ثناء على الله | الوسطى = مشتركة | آخر 3 = دعاء', subtitle: '«قسمتُ الصلاة بيني وبين عبدي نصفين» - حديث قدسي', detail: '"الحمد لله" ربّي يردّ: "حمدني عبدي". "إياك نعبد" = الانعطاف من الكلام عنه للكلام معه! "اهدنا" بالجمع مش "اهدني" - حتى في الدعاء تدعي لغيرك' },
      category: 'ch7-surahs',
    },
    {
      id: 24,
      front: { icon: 'shield-alert', text: 'سورة الكهف فيها 4 قصص = 4 فتن. واش هم؟' },
      back: { title: 'فتنة الدين → المال → العلم → السلطة', subtitle: 'كل قصة فيها الفتنة وفيها الحل!', detail: 'أصحاب الكهف: اللجوء لله + صحبة صالحة. صاحب الجنتين: "ما شاء الله لا قوة إلا بالله". موسى والخضر: التواضع. ذو القرنين: "هذا رحمة من ربّي"' },
      category: 'ch7-surahs',
    },
    {
      id: 25,
      front: { icon: 'drama', text: 'سورة يوسف سمّاها ربّي "أحسن القصص". واش الدرس الأكبر فيها؟' },
      back: { title: 'ثق في تدبير الله حتى لو ما فهمتش واش يحصل!', subtitle: 'البئر → العبودية → السجن → العرش = خطة ربّي المحكمة', detail: 'البئر كان باش يوصل لمصر. السجن كان باش يوصل للقصر. ﴿وعسى أن تكرهوا شيئاً وهو خير لكم﴾. والسماح قوة مش ضعف: "لا تثريب عليكم اليوم"' },
      category: 'ch7-surahs',
    },
    {
      id: 26,
      front: { icon: 'crown', text: 'آية الكرسي أعظم آية في القرآن. واش يميّزها؟' },
      back: { title: '10 جمل و50 كلمة كلها تمجيد وتعظيم لله!', subtitle: 'من قرأها بعد كل صلاة ما يمنعو من الجنة إلا الموت', detail: 'الحي القيوم: حياة كاملة أبدية. لا تأخذه سنة ولا نوم: حتى النعاس ما يجيهش! وسع كرسيّه السماوات والأرض: العظمة المطلقة. اقراها كل ليلة = حافظ من الله' },
      category: 'ch7-surahs',
    },

    // === الباب 8: لطائف وأسرار (2 cards) ===
    {
      id: 27,
      front: { icon: 'scan-search', text: 'الفاتحة تنتهي بطلب الهداية. وبداية البقرة واش تقول؟' },
      back: { title: '﴿ذلك الكتاب لا ريب فيه هدًى للمتقين﴾ - ها هي الهداية!', subtitle: 'كأنك دعيت "اهدنا" وربّي ردّ عليك في البقرة!', detail: 'هذا من أسرار ترتيب السور: نهاية سورة تمهّد لبداية اللي بعدها. وسورة المؤمنون: بدات بـ"قد أفلح المؤمنون" وختمت بـ"إنه لا يفلح الكافرون" - دائرة كاملة!' },
      category: 'ch8-secrets',
    },
    {
      id: 28,
      front: { icon: 'mic', text: 'أيوب عليه السلام عانى سنين من المرض. كيفاش دعا ربّي؟' },
      back: { title: '﴿أنّي مسّني الضرّ وأنت أرحم الراحمين﴾ - أدب عظيم!', subtitle: 'ما اشتكاش ولا طلب الشفاء مباشرة', detail: 'قال "مسّني" (مجرّد مسّ مش ضرب!) و"أنت أرحم الراحمين" (ذكر رحمة ربّي). حتى آدم: "ظلمنا أنفسنا" ما لام الشيطان. إبراهيم: "تقبّل منّا" بعد بناء الكعبة ما تفاخرش. الأدب مع الله فنّ!' },
      category: 'ch8-secrets',
    },

    // === الباب 9-10: القرآن في حياتك + الخاتمة (2 cards) ===
    {
      id: 29,
      front: { icon: 'alert-circle', text: 'واش هي أخطر 4 أخطاء في التدبّر لازم تتجنّبها؟' },
      back: { title: 'التفسير بلا علم | اقتطاع من السياق | إهمال أسباب النزول | اتّباع الهوى', subtitle: '«من قال في القرآن برأيه فليتبوّأ مقعده من النار»', detail: 'التدبّر مش تفسير! لمّا تحسّ بمعنى في قلبك = تدبّر مشروع. بصح "هاذي الآية معناها كذا" بلا علم = تفسير بالرأي محرّم. دايماً ارجع للتفاسير المعتبرة' },
      category: 'ch9-daily',
    },
    {
      id: 30,
      front: { icon: 'sparkles', text: 'كيفاش تعرف إن التدبّر بدا يأثّر فيك فعلاً؟ (5 علامات)' },
      back: { title: 'تغيّر سلوك + خشوع أكبر + اتصال عاطفي + قرارات أفضل + نظرة جديدة', subtitle: 'التدبّر الحقيقي يبدّل حياتك مش بس معلوماتك', detail: 'تسمع آية في الصلاة وقلبك يتحرّك. تشوف المطر وتفتكر ﴿وأنزلنا من السماء ماء طهوراً﴾. تسأل قبل كل قرار: "واش يقول القرآن؟" - الكون ولّى كتاب مفتوح تقراه بعين القرآن' },
      category: 'ch10-conclusion',
    },
  ],

  // Course ID 26: قصص الأنبياء بالدارجة
  26: [
    // === الفصل 1: آدم وإدريس ونوح (7 cards) ===
    {
      id: 1,
      front: { icon: 'book-open', text: 'علاش سجدت الملائكة لآدم عليه السلام؟' },
      back: { title: 'التكريم بالعلم', subtitle: 'الله علّم آدم الأسماء كلها وسأل الملائكة فما عرفوها', detail: 'ربي علّم آدم أسماء كل شيء في الكون. الملائكة ما قدروش يجاوبو. آدم جاوب عليها كلها! العلم هو اللي رفع مقام الإنسان — ربي كرّمو بالعلم قبل أي حاجة أخرى.' },
      category: 'ch1-adam',
    },
    {
      id: 2,
      front: { icon: 'scale', text: 'واش الفرق بين غلطة آدم وغلطة إبليس؟' },
      back: { title: 'التوبة vs الكبر — الفرق بين النجاة والهلاك', subtitle: 'آدم اعترف وتاب ← ربي سامحو | إبليس استكبر ← ربي لعنو', detail: 'الذنب ما يهلكش، الكبر هو اللي يهلك! آدم قال: "ربنا ظلمنا أنفسنا" واستغفر. إبليس قال: "أنا خير منه" ورفض. باب التوبة مفتوح دايماً — المهم ما تتكبرش.' },
      category: 'ch1-adam',
    },
    {
      id: 3,
      front: { icon: 'alert-triangle', text: 'واش أول جريمة في تاريخ البشرية ومن وراها؟' },
      back: { title: 'قابيل قتل أخوه هابيل بسبب الحسد', subtitle: 'ربي تقبّل قربان هابيل ورفض قربان قابيل فحسدو', detail: 'هابيل قدّم أحسن غنمو، قابيل قدّم أردأ زرعو. كي ربي تقبّل من هابيل، الحسد ملا قلب قابيل فقتلو. الحسد يدمّر الإنسان ويوصلو لأسوأ الأفعال — والله يتقبل من المتقين فقط.' },
      category: 'ch1-adam',
    },
    {
      id: 4,
      front: { icon: 'pen-tool', text: 'بواش اشتهر إدريس عليه السلام؟' },
      back: { title: 'أول من كتب بالقلم وخاط الثياب', subtitle: 'وصفه الله: صدّيق ونبي — ورفعه مكاناً عليّاً', detail: 'إدريس كان عالم في الحساب والفلك. ما كانش عندو ملك ولا جيش — كان عندو علم وصدق وإيمان. ربي رفعو مكاناً عليّاً بهذي الصفات فقط. العلم والصدق هم الطريق للرفعة عند الله.' },
      category: 'ch1-idris',
    },
    {
      id: 5,
      front: { icon: 'clock', text: 'شحال دامت دعوة نوح عليه السلام لقومو؟' },
      back: { title: '950 سنة! أطول دعوة في التاريخ', subtitle: 'بالليل والنهار، بالسر والعلن — وقومو يحطو صبعانهم في وذانهم', detail: 'تخيّل! قريب ألف سنة وهو يدعو بدون ما ييأس. قومو يسخرو منو ويقولو: "ما نراك إلا بشراً مثلنا." بصح نوح ما طرد حتى واحد ولا وقف. الصبر على الدعوة من أعظم الصفات.' },
      category: 'ch1-nuh',
    },
    {
      id: 6,
      front: { icon: 'ship', text: 'واش تعلّم نوح عليه السلام من قصة ابنه اللي غرق؟' },
      back: { title: 'رابطة الإيمان أقوى من رابطة الدم', subtitle: 'ربي قال: "إنه ليس من أهلك إنه عمل غير صالح"', detail: 'ابن نوح رفض يركب السفينة وقال: "سآوي إلى جبل." نوح حزن عليه بزاف بصح ربي علّمو: القرابة الحقيقية هي قرابة الإيمان. حتى ابن نبي ما ينفعوش نسبو بدون إيمان.' },
      category: 'ch1-nuh',
    },
    {
      id: 7,
      front: { icon: 'anchor', text: 'علاش يُلقّب نوح بـ"أبو البشرية الثاني"؟' },
      back: { title: 'كل البشر اليوم من ذرية نوح عليه السلام', subtitle: 'أبناؤه الثلاثة: سام وحام ويافث = أصل كل الشعوب', detail: 'بعد الطوفان اللي غطى كل شيء، نجا نوح والمؤمنين فقط. كل البشرية من بعد تفرعت من أولادو الثلاثة. لهذا هو "أبو البشرية الثاني" بعد آدم عليه السلام.' },
      category: 'ch1-nuh',
    },

    // === الفصل 2: هود وصالح وشعيب (4 cards) ===
    {
      id: 8,
      front: { icon: 'wind', text: 'قوم عاد كانو أقوى ناس في زمانهم — كيفاش هلكو؟' },
      back: { title: 'ريح صرصر عاتية دامت 7 ليالي و8 أيام', subtitle: 'قالو: "من أشد منا قوة؟" فأراهم الله أن الريح أشد!', detail: 'بنو حضارة "إرم ذات العماد" ما كاين مثلها. بصح تكبرو بقوتهم. شافو سحابة وقالو: "ممطرنا!" كانت ريح لا مطر. حضارة كاملة تدمرت في أسبوع — القوة بلا إيمان ما تنفعش.' },
      category: 'ch2-hud',
    },
    {
      id: 9,
      front: { icon: 'mountain', text: 'واش المعجزة العظيمة اللي أعطاها الله لصالح عليه السلام؟' },
      back: { title: 'ناقة خرجت من صخرة صلدة بمواصفات طلبها القوم', subtitle: 'قانون: الناقة تشرب يوم وهم يشربو يوم', detail: 'قوم ثمود حدّدو صخرة وقالو: "نحبو ناقة عشراء تخرج منها!" الصخرة انشقت وخرجت الناقة! بصح المعجزة الواضحة ما نفعتش قلب مقفل بالكبر — عقروها فجاء العذاب بعد 3 أيام.' },
      category: 'ch2-salih',
    },
    {
      id: 10,
      front: { icon: 'scale', text: 'علاش لقّبو شعيب عليه السلام بـ"خطيب الأنبياء"؟ وواش ذنب قومو؟' },
      back: { title: 'فصيح بليغ — وقومو كانو يغشّو في الميزان', subtitle: 'الغش في التجارة ذنب يساوي الشرك عند الله!', detail: 'قوم مدين كانو يطفّفو: كي يبيعو ينقصو، كي يشريو يزيدو. شعيب قالهم: "أوفوا المكيال والميزان بالقسط!" الإسلام ما يفصلش بين العبادة والمعاملات — تصلي وتغش؟ صلاتك ما تنفعكش.' },
      category: 'ch2-shuayb',
    },
    {
      id: 11,
      front: { icon: 'list-checks', text: 'واش العقوبات الثلاثة اللي أرسلها الله لأقوام هود وصالح وشعيب؟' },
      back: { title: 'عاد: ريح 8 أيام | ثمود: صيحة ورجفة | مدين: عذاب الظُلّة', subtitle: 'كلهم تكبّرو بنعم الله فتحولت النعم لنقم', detail: 'عاد: قوة جسدية. ثمود: حضارة عمرانية. مدين: ثروة تجارية. كلهم استعملو نعم الله في المعصية بدل الشكر. الدرس: النعم اللي ما نشكروش عليها تتحول لنقم!' },
      category: 'ch2-summary',
    },

    // === الفصل 3: إبراهيم وعائلته (5 cards) ===
    {
      id: 12,
      front: { icon: 'sun', text: 'كيفاش وصل إبراهيم عليه السلام للتوحيد وهو تربّى في عائلة تصنع الأصنام؟' },
      back: { title: 'بالتفكّر العقلي: الكواكب ← القمر ← الشمس ← الله', subtitle: '"إني وجّهت وجهي للذي فطر السماوات والأرض حنيفاً"', detail: 'شاف كوكب وقال: "هذا ربي" — غاب. شاف القمر — غاب. شاف الشمس — غابت. قال: "لا أحب الآفلين." العقل والتفكر يوصّلو للحقيقة حتى في بيئة كلها شرك.' },
      category: 'ch3-ibrahim',
    },
    {
      id: 13,
      front: { icon: 'flame', text: 'واش قال إبراهيم كي رموه في النار؟ وواش صار؟' },
      back: { title: '"حسبنا الله ونعم الوكيل" — النار ولّات بردة وسلام', subtitle: 'قال الله: "يا نار كوني برداً وسلاماً على إبراهيم"', detail: 'أشعلو نار عظيمة حتى الطيور ما تقدرش تطير فوقها. رموه بالمنجنيق. بصح بكلمة من الله صارت بردة وسلام! ما حرقتو ولا حوايجو. "حسبنا الله ونعم الوكيل" = أعظم كلمة توكل!' },
      category: 'ch3-ibrahim',
    },
    {
      id: 14,
      front: { icon: 'droplets', text: 'كيفاش نبع ماء زمزم؟ وعلاش نسعى بين الصفا والمروة؟' },
      back: { title: 'نبع تحت رجلي إسماعيل الرضيع وأمه هاجر تسعى', subtitle: 'هاجر جرات 7 مرات بين الصفا والمروة تحوّس على ماء', detail: 'إبراهيم سكّن هاجر وإسماعيل الرضيع في صحراء مكة بأمر الله. كي خلص الماء، هاجر بدات تجري بين الصفا والمروة. ربي أنبع زمزم تحت رجلي الطفل! البئر لا يزال يجري لليوم — والسعي من مناسك الحج تخليداً لها.' },
      category: 'ch3-ibrahim',
    },
    {
      id: 15,
      front: { icon: 'heart', text: 'واش جاوب إسماعيل كي قالو أبوه بلي ربي أمرو يذبحو؟' },
      back: { title: '"يا أبت افعل ما تؤمر ستجدني إن شاء الله من الصابرين"', subtitle: 'الله فداه بكبش عظيم — ونحتفلو بعيد الأضحى كل سنة', detail: 'إبراهيم شاف في المنام أنو يذبح ابنو. وإسماعيل — شاب صغير — وافق بكل طاعة! كي حط السكين جاء النداء: "قد صدقت الرؤيا!" هذا الاستسلام الكامل لأمر الله هو الإيمان الحقيقي.' },
      category: 'ch3-ismail',
    },
    {
      id: 16,
      front: { icon: 'eye-off', text: 'كيفاش ابتُلي يعقوب عليه السلام وواش كان يقول؟' },
      back: { title: 'فقد ابنه يوسف وبكى حتى فقد بصره', subtitle: '"إنما أشكو بثي وحزني إلى الله" — ما يئس أبداً', detail: 'غاب عنو يوسف سنين طويلة. بكى حتى ابيضت عيناه. بصح ظل يقول: "ولا تيأسوا من روح الله." وفي النهاية ربي رجعلو ابنو ورجعلو بصره كي حطو قميص يوسف على وجهه!' },
      category: 'ch3-yaqub',
    },

    // === الفصل 4: يوسف عليه السلام (4 cards) ===
    {
      id: 17,
      front: { icon: 'star', text: 'علاش سمّى الله قصة يوسف "أحسن القصص"؟' },
      back: { title: 'فيها كل المشاعر: حسد، ظلم، صبر، فتنة، سجن، ملك، عفو', subtitle: 'السورة الوحيدة اللي جاءت قصة كاملة في مكان واحد (111 آية)', detail: 'من قاع البئر للعبودية للسجن لعرش مصر — قصة أمل لكل واحد يمر بظروف صعيبة. يوسف شاف في المنام 11 كوكب والشمس والقمر يسجدولو — وتحققت بعد عقود!' },
      category: 'ch4-yusuf',
    },
    {
      id: 18,
      front: { icon: 'shield', text: 'واش قال يوسف كي راودتو امرأة العزيز عن نفسه؟' },
      back: { title: '"معاذ الله إنه ربي أحسن مثواي" — فضّل السجن على الحرام', subtitle: 'شاب، عبد، بعيد عن أهله، وحده — ومع ذلك رفض!', detail: 'امرأة العزيز غلقت الأبواب وقالت: "هيت لك!" بصح يوسف هرب! وكي خيّروه بين المعصية والسجن قال: "رب السجن أحب إلي." العفة أغلى شيء عند الإنسان — حتى في أصعب الظروف.' },
      category: 'ch4-yusuf',
    },
    {
      id: 19,
      front: { icon: 'wheat', text: 'كيفاش أنقذ يوسف مصر من المجاعة؟' },
      back: { title: 'فسّر رؤيا الملك: 7 سنوات رخاء + 7 سنوات قحط', subtitle: 'خزّن المحاصيل في الرخاء ووزّع بعدل في القحط', detail: 'الملك شاف 7 بقرات سمان ياكلهم 7 عجاف. يوسف فسّرها وطلب يكون على خزائن الأرض. نظّم الاقتصاد بحكمة: مصر ولّات الدولة الوحيدة عندها طعام! التخطيط للمستقبل سنة نبوية.' },
      category: 'ch4-yusuf',
    },
    {
      id: 20,
      front: { icon: 'hand-heart', text: 'واش قال يوسف لإخوته اللي رموه في البئر كي عرفوه؟' },
      back: { title: '"لا تثريب عليكم اليوم يغفر الله لكم" — أعظم عفو في التاريخ', subtitle: 'سامحهم بالكامل وهو أقوى رجل في مصر!', detail: 'الإخوة اللي حسدوه ورموه في البئر وباعوه عبد — سامحهم كلهم. ما انتقم ولا لامهم. العفو عند المقدرة من أعظم صفات الأنبياء. كي تقدر تنتقم وتسامح — هذا هو العفو الحقيقي.' },
      category: 'ch4-yusuf',
    },

    // === الفصل 5: أيوب عليه السلام (2 cards) ===
    {
      id: 21,
      front: { icon: 'hourglass', text: 'شحال دام ابتلاء أيوب عليه السلام وواش خسر؟' },
      back: { title: '18 سنة! فقد المال والأولاد والصحة', subtitle: 'ماحدش بقى معاه إلا زوجته الصالحة', detail: 'ضاعت كل أموالو. ماتو كل أولادو. مرض مرض شديد شوّه جسمو. الناس بعدو عليه. بصح أيوب ما تذمر أبداً — 18 سنة صبر! الابتلاء مش دايماً عقوبة، أحياناً هو رفعة في الدرجات.' },
      category: 'ch5-ayyub',
    },
    {
      id: 22,
      front: { icon: 'heart-handshake', text: 'كيفاش دعا أيوب ربو؟ وكيفاش كان التعويض؟' },
      back: { title: '"مسّني الضر وأنت أرحم الراحمين" — بأدب بدون أمر!', subtitle: 'ربي ردّ عليه أهله ومثلهم معهم = الضعف!', detail: 'ما قالش "ارفع عني" بل قال "مسني الضر" وسكت — ترك الأمر لله. ربي أمرو يضرب الأرض فنبع ماء شُفي منو. ماله رجع أكثر، صحته رجعت أحسن، عائلته تضاعفت. بعد العسر يسر — دايماً!' },
      category: 'ch5-ayyub',
    },

    // === الفصل 6: موسى وهارون (4 cards) ===
    {
      id: 23,
      front: { icon: 'baby', text: 'كيفاش نجا موسى الرضيع من فرعون اللي يقتل المواليد؟' },
      back: { title: 'أمو حطتو في تابوت ورماتو في النيل — وتربّى في قصر فرعون نفسه!', subtitle: 'الطفل اللي أمر فرعون بقتله صار يعيش تحت سقفه', detail: 'ربي ألهم أم موسى ترمي ابنها في النهر! آسية مرة فرعون تبنّتو. ورفض كل المرضعات حتى رجعت أمو ترضعو! ربي وعد أمو: "إنا رادّوه إليك وجاعلوه من المرسلين" — وتحقق الوعد.' },
      category: 'ch6-musa',
    },
    {
      id: 24,
      front: { icon: 'waves', text: 'واش قال موسى كي لحقهم فرعون والبحر قدامهم؟' },
      back: { title: '"كلّا إن معي ربي سيهدين" — ثقة مطلقة بالله', subtitle: 'ضرب البحر بعصاه فانشق لنصفين وعبرو بسلام!', detail: 'البحر قدامهم وفرعون بجيشه وراهم. الناس فزعو وقالو: "إنا لمدركون!" بصح موسى ما شك لحظة. ربي أمر البحر ينشق فصار طريق يابس! فرعون دخل خلفهم فانطبق عليه البحر وغرق.' },
      category: 'ch6-musa',
    },
    {
      id: 25,
      front: { icon: 'x-circle', text: 'علاش رفض الله إيمان فرعون كي كان يغرق؟' },
      back: { title: 'التوبة عند الموت مرفوضة — "آلآن وقد عصيت قبل؟!"', subtitle: 'الله حفظ جسده ليكون عبرة — محفوظ في المتحف لليوم!', detail: 'فرعون قال "أنا ربكم الأعلى" وادّعى الألوهية. كي غرق صرخ: "آمنت!" ربي قال: "آلآن؟" — فات الأوان. التوبة قبل الموت مقبولة، بصح التوبة عند الموت مرفوضة. لا تأجّل التوبة!' },
      category: 'ch6-musa',
    },
    {
      id: 26,
      front: { icon: 'sparkles', text: 'واش صار كي سحرة فرعون شافو عصا موسى تبتلع سحرهم؟' },
      back: { title: 'سجدو فوراً: "آمنا برب العالمين رب موسى وهارون"', subtitle: 'من أكبر الكفر لأقوى الإيمان في لحظة واحدة!', detail: 'السحرة — أعلم الناس بالسحر — فهمو فوراً: هذا مش سحر! فرعون هددهم بالصلب وقطع الأيدي. جاوبو: "لن نؤثرك على ما جاءنا من البينات." الحق واضح لقلب مفتوح — حتى لو كان كافر قبل دقيقة!' },
      category: 'ch6-musa',
    },

    // === الفصل 7: داود وسليمان (2 cards) ===
    {
      id: 27,
      front: { icon: 'crown', text: 'واش سخّر الله لسليمان عليه السلام؟ وواش تعلم من نملة؟' },
      back: { title: 'الجن والريح ومنطق الطير والإنس — أعظم ملك في التاريخ', subtitle: 'نملة نادت قومها فتبسّم وشكر الله! ملك يشكر بسبب نملة', detail: 'سليمان سمع نملة تقول: "ادخلوا مساكنكم لا يحطمنكم سليمان!" ما تكبّر عليها بل شكر الله. أعظم ملك في التاريخ وأكثرهم تواضعاً وشكراً. النعمة الحقيقية هي القدرة على الشكر.' },
      category: 'ch7-sulayman',
    },
    {
      id: 28,
      front: { icon: 'fish', text: 'واش الدعاء العظيم اللي قالو يونس في بطن الحوت؟' },
      back: { title: '"لا إله إلا أنت سبحانك إني كنت من الظالمين"', subtitle: 'النبي ﷺ قال: هذا الدعاء مستجاب لكل مسلم!', detail: 'في 3 ظلمات: ظلمة الليل + ظلمة البحر + ظلمة بطن الحوت. يونس نادى ربو بهذا الدعاء فاستجاب الله وأمر الحوت يلفظو. وقومو أهل نينوى = الوحيدين في التاريخ اللي آمنو كلهم!' },
      category: 'ch8-yunus',
    },

    // === الفصل 9: عيسى ومريم (1 card) ===
    {
      id: 29,
      front: { icon: 'message-circle', text: 'واش أول كلمة قالها عيسى عليه السلام وهو رضيع في المهد؟' },
      back: { title: '"إني عبد الله" — أول كلمة = عبد الله مش ابن الله', subtitle: 'خُلق بكلمة "كن" بدون أب — مثل آدم خُلق بلا أب ولا أم', detail: 'مريم جابت عيسى بمعجزة بدون أب. كي اتهمها القوم تكلّم الرضيع: "إني عبد الله آتاني الكتاب وجعلني نبياً." الله رفعو للسماء كي حاولو يقتلوه — وراح يرجع في آخر الزمان ويحكم بالإسلام.' },
      category: 'ch9-issa',
    },

    // === الفصل 10: الخاتمة والدروس المشتركة (1 card) ===
    {
      id: 30,
      front: { icon: 'book-heart', text: 'واش الدروس المشتركة بين كل الأنبياء الـ25؟' },
      back: { title: 'التوحيد + الصبر + التوكل + العفو + الشجاعة + الرحمة + الأمل', subtitle: '"أولئك الذين هدى الله فبهداهم اقتده" — سورة الأنعام', detail: 'كل نبي جاء بنفس الرسالة: اعبدو الله وحده. كلهم تعرضو لأذى وصبرو. سامحو اللي عاداهم. واجهو الطغاة بلا خوف. ما يئسو أبداً من رحمة الله. هذي القيم متاحة لكل واحد فينا!' },
      category: 'ch10-conclusion',
    },
  ],
};

export function getFlashcards(courseId) {
  return flashcardsData[courseId] || [];
}

export function getIconType(courseId) {
  return courseIconType[courseId] || ICON_TYPE.TWEMOJI;
}

export { ICON_TYPE };
export default flashcardsData;
